
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire89da"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire89da"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jDp01", function(module, exports) {

$parcel$export(module.exports, "SVG", () => SVG);
/*!
* @svgdotjs/svg.js - A lightweight library for manipulating and animating SVG.
* @version 3.2.8
* https://svgjs.dev/
*
* @copyright Wout Fierens <wout@mick-wout.com>
* @license MIT
*
* BUILT: 2026-08-04T07:47:41.000Z
*/ //#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod)=>()=>(mod || (cb((mod = {
            exports: {}
        }).exports, mod), cb = null), mod.exports);
var __exportAll = (all, no_symbols)=>{
    let target = {};
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
    if (!no_symbols) __defProp(target, Symbol.toStringTag, {
        value: "Module"
    });
    return target;
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") for(var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ((k)=>from[k]).bind(null, key),
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
//#endregion
//#region src/utils/methods.js
const methods = {};
const names = [];
function registerMethods(name, m) {
    if (Array.isArray(name)) {
        for (const _name of name)registerMethods(_name, m);
        return;
    }
    if (typeof name === "object") {
        for(const _name in name)registerMethods(_name, name[_name]);
        return;
    }
    addMethodNames(Object.getOwnPropertyNames(m));
    methods[name] = Object.assign(methods[name] || {}, m);
}
function getMethodsFor(name) {
    return methods[name] || {};
}
function getMethodNames() {
    return [
        ...new Set(names)
    ];
}
function addMethodNames(_names) {
    names.push(..._names);
}
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/fails.js
var require_fails = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = function(exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-bind-native.js
var require_function_bind_native = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var fails = require_fails();
    module.exports = !fails(function() {
        var test = (function() {}).bind();
        return typeof test != "function" || test.hasOwnProperty("prototype");
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-uncurry-this.js
var require_function_uncurry_this = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var NATIVE_BIND = require_function_bind_native();
    var FunctionPrototype = Function.prototype;
    var call = FunctionPrototype.call;
    var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
    module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
        return function() {
            return call.apply(fn, arguments);
        };
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/object-is-prototype-of.js
var require_object_is_prototype_of = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this();
    module.exports = uncurryThis({}.isPrototypeOf);
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/global-this.js
var require_global_this = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var check = function(it) {
        return it && it.Math === Math && it;
    };
    module.exports = check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof $parcel$global == "object" && $parcel$global) || check(typeof exports == "object" && exports) || function() {
        return this;
    }() || Function("return this")();
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-apply.js
var require_function_apply = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var NATIVE_BIND = require_function_bind_native();
    var FunctionPrototype = Function.prototype;
    var apply = FunctionPrototype.apply;
    var call = FunctionPrototype.call;
    module.exports = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
        return call.apply(apply, arguments);
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/classof-raw.js
var require_classof_raw = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this();
    var toString = uncurryThis({}.toString);
    var stringSlice = uncurryThis("".slice);
    module.exports = function(it) {
        return stringSlice(toString(it), 8, -1);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-uncurry-this-clause.js
var require_function_uncurry_this_clause = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var classofRaw = require_classof_raw();
    var uncurryThis = require_function_uncurry_this();
    module.exports = function(fn) {
        if (classofRaw(fn) === "Function") return uncurryThis(fn);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-callable.js
var require_is_callable = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var documentAll = typeof document == "object" && document.all;
    module.exports = typeof documentAll == "undefined" && documentAll !== void 0 ? function(argument) {
        return typeof argument == "function" || argument === documentAll;
    } : function(argument) {
        return typeof argument == "function";
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/descriptors.js
var require_descriptors = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var fails = require_fails();
    module.exports = !fails(function() {
        return Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1] !== 7;
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-call.js
var require_function_call = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var NATIVE_BIND = require_function_bind_native();
    var call = Function.prototype.call;
    module.exports = NATIVE_BIND ? call.bind(call) : function() {
        return call.apply(call, arguments);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/object-property-is-enumerable.js
var require_object_property_is_enumerable = /* @__PURE__ */ __commonJSMin((exports)=>{
    var $propertyIsEnumerable = {}.propertyIsEnumerable;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
        1: 2
    }, 1);
    exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/create-property-descriptor.js
var require_create_property_descriptor = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/indexed-object.js
var require_indexed_object = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this();
    var fails = require_fails();
    var classof = require_classof_raw();
    var $Object = Object;
    var split = uncurryThis("".split);
    module.exports = fails(function() {
        return !$Object("z").propertyIsEnumerable(0);
    }) ? function(it) {
        return classof(it) === "String" ? split(it, "") : $Object(it);
    } : $Object;
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-null-or-undefined.js
var require_is_null_or_undefined = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = function(it) {
        return it === null || it === void 0;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/require-object-coercible.js
var require_require_object_coercible = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isNullOrUndefined = require_is_null_or_undefined();
    var $TypeError = TypeError;
    module.exports = function(it) {
        if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
        return it;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-indexed-object.js
var require_to_indexed_object = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var IndexedObject = require_indexed_object();
    var requireObjectCoercible = require_require_object_coercible();
    module.exports = function(it) {
        return IndexedObject(requireObjectCoercible(it));
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-object.js
var require_is_object = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isCallable = require_is_callable();
    module.exports = function(it) {
        return typeof it == "object" ? it !== null : isCallable(it);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/path.js
var require_path = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = {};
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/get-built-in.js
var require_get_built_in = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var path = require_path();
    var globalThis1 = require_global_this();
    var isCallable = require_is_callable();
    var aFunction = function(variable) {
        return isCallable(variable) ? variable : void 0;
    };
    module.exports = function(namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(globalThis1[namespace]) : path[namespace] && path[namespace][method] || globalThis1[namespace] && globalThis1[namespace][method];
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/environment-user-agent.js
var require_environment_user_agent = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var navigator = require_global_this().navigator;
    var userAgent = navigator && navigator.userAgent;
    module.exports = userAgent ? String(userAgent) : "";
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/environment-v8-version.js
var require_environment_v8_version = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var userAgent = require_environment_user_agent();
    var process = globalThis1.process;
    var Deno = globalThis1.Deno;
    var versions = process && process.versions || Deno && Deno.version;
    var v8 = versions && versions.v8;
    var match;
    var version;
    if (v8) {
        match = v8.split(".");
        version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    }
    if (!version && userAgent) {
        match = userAgent.match(/Edge\/(\d+)/);
        if (!match || match[1] >= 74) {
            match = userAgent.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
        }
    }
    module.exports = version;
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/symbol-constructor-detection.js
var require_symbol_constructor_detection = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var V8_VERSION = require_environment_v8_version();
    var fails = require_fails();
    var $String = require_global_this().String;
    module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
        var symbol = Symbol("symbol detection");
        return !$String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/use-symbol-as-uid.js
var require_use_symbol_as_uid = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var NATIVE_SYMBOL = require_symbol_constructor_detection();
    module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-symbol.js
var require_is_symbol = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var getBuiltIn = require_get_built_in();
    var isCallable = require_is_callable();
    var isPrototypeOf = require_object_is_prototype_of();
    var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
    var $Object = Object;
    module.exports = USE_SYMBOL_AS_UID ? function(it) {
        return typeof it == "symbol";
    } : function(it) {
        var $Symbol = getBuiltIn("Symbol");
        return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/try-to-string.js
var require_try_to_string = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var $String = String;
    module.exports = function(argument) {
        try {
            return $String(argument);
        } catch (error) {
            return "Object";
        }
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/a-callable.js
var require_a_callable = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isCallable = require_is_callable();
    var tryToString = require_try_to_string();
    var $TypeError = TypeError;
    module.exports = function(argument) {
        if (isCallable(argument)) return argument;
        throw new $TypeError(tryToString(argument) + " is not a function");
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/get-method.js
var require_get_method = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var aCallable = require_a_callable();
    var isNullOrUndefined = require_is_null_or_undefined();
    module.exports = function(V, P) {
        var func = V[P];
        return isNullOrUndefined(func) ? void 0 : aCallable(func);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/ordinary-to-primitive.js
var require_ordinary_to_primitive = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var call = require_function_call();
    var isCallable = require_is_callable();
    var isObject = require_is_object();
    var $TypeError = TypeError;
    module.exports = function(input, pref) {
        var fn, val;
        if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
        if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
        if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
        throw new $TypeError("Can't convert object to primitive value");
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-pure.js
var require_is_pure = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = true;
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/define-global-property.js
var require_define_global_property = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var defineProperty = Object.defineProperty;
    module.exports = function(key, value) {
        try {
            defineProperty(globalThis1, key, {
                value: value,
                configurable: true,
                writable: true
            });
        } catch (error) {
            globalThis1[key] = value;
        }
        return value;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/shared-store.js
var require_shared_store = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var IS_PURE = require_is_pure();
    var globalThis1 = require_global_this();
    var defineGlobalProperty = require_define_global_property();
    var SHARED = "__core-js_shared__";
    var store = module.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
    (store.versions || (store.versions = [])).push({
        version: "3.49.0",
        mode: IS_PURE ? "pure" : "global",
        copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
        license: "https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/shared.js
var require_shared = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var store = require_shared_store();
    module.exports = function(key, value) {
        return store[key] || (store[key] = value || {});
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-object.js
var require_to_object = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var requireObjectCoercible = require_require_object_coercible();
    var $Object = Object;
    module.exports = function(argument) {
        return $Object(requireObjectCoercible(argument));
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/has-own-property.js
var require_has_own_property = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this();
    var toObject = require_to_object();
    var hasOwnProperty = uncurryThis({}.hasOwnProperty);
    module.exports = Object.hasOwn || function hasOwn(it, key) {
        return hasOwnProperty(toObject(it), key);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/uid.js
var require_uid = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this();
    var id = 0;
    var postfix = Math.random();
    var toString = uncurryThis(1.1.toString);
    module.exports = function(key) {
        return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString(++id + postfix, 36);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/well-known-symbol.js
var require_well_known_symbol = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var shared = require_shared();
    var hasOwn = require_has_own_property();
    var uid = require_uid();
    var NATIVE_SYMBOL = require_symbol_constructor_detection();
    var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
    var Symbol1 = globalThis1.Symbol;
    var WellKnownSymbolsStore = shared("wks");
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1["for"] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
    module.exports = function(name) {
        if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol("Symbol." + name);
        return WellKnownSymbolsStore[name];
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-primitive.js
var require_to_primitive = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var call = require_function_call();
    var isObject = require_is_object();
    var isSymbol = require_is_symbol();
    var getMethod = require_get_method();
    var ordinaryToPrimitive = require_ordinary_to_primitive();
    var wellKnownSymbol = require_well_known_symbol();
    var $TypeError = TypeError;
    var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
    module.exports = function(input, pref) {
        if (!isObject(input) || isSymbol(input)) return input;
        var exoticToPrim = getMethod(input, TO_PRIMITIVE);
        var result;
        if (exoticToPrim) {
            if (pref === void 0) pref = "default";
            result = call(exoticToPrim, input, pref);
            if (!isObject(result) || isSymbol(result)) return result;
            throw new $TypeError("Can't convert object to primitive value");
        }
        if (pref === void 0) pref = "number";
        return ordinaryToPrimitive(input, pref);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-property-key.js
var require_to_property_key = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var toPrimitive = require_to_primitive();
    var isSymbol = require_is_symbol();
    module.exports = function(argument) {
        var key = toPrimitive(argument, "string");
        return isSymbol(key) ? key : key + "";
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/document-create-element.js
var require_document_create_element = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var isObject = require_is_object();
    var document1 = globalThis1.document;
    var EXISTS = isObject(document1) && isObject(document1.createElement);
    module.exports = function(it) {
        return EXISTS ? document1.createElement(it) : {};
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/ie8-dom-define.js
var require_ie8_dom_define = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var DESCRIPTORS = require_descriptors();
    var fails = require_fails();
    var createElement = require_document_create_element();
    module.exports = !DESCRIPTORS && !fails(function() {
        return Object.defineProperty(createElement("div"), "a", {
            get: function() {
                return 7;
            }
        }).a !== 7;
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/object-get-own-property-descriptor.js
var require_object_get_own_property_descriptor = /* @__PURE__ */ __commonJSMin((exports)=>{
    var DESCRIPTORS = require_descriptors();
    var call = require_function_call();
    var propertyIsEnumerableModule = require_object_property_is_enumerable();
    var createPropertyDescriptor = require_create_property_descriptor();
    var toIndexedObject = require_to_indexed_object();
    var toPropertyKey = require_to_property_key();
    var hasOwn = require_has_own_property();
    var IE8_DOM_DEFINE = require_ie8_dom_define();
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPropertyKey(P);
        if (IE8_DOM_DEFINE) try {
            return $getOwnPropertyDescriptor(O, P);
        } catch (error) {}
        if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-forced.js
var require_is_forced = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var fails = require_fails();
    var isCallable = require_is_callable();
    var replacement = /#|\.prototype\./;
    var isForced = function(feature, detection) {
        var value = data[normalize(feature)];
        return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
    };
    var normalize = isForced.normalize = function(string) {
        return String(string).replace(replacement, ".").toLowerCase();
    };
    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = "N";
    var POLYFILL = isForced.POLYFILL = "P";
    module.exports = isForced;
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/function-bind-context.js
var require_function_bind_context = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var uncurryThis = require_function_uncurry_this_clause();
    var aCallable = require_a_callable();
    var NATIVE_BIND = require_function_bind_native();
    var bind = uncurryThis(uncurryThis.bind);
    module.exports = function(fn, that) {
        aCallable(fn);
        return that === void 0 ? fn : NATIVE_BIND ? bind(fn, that) : function() {
            return fn.apply(that, arguments);
        };
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/v8-prototype-define-bug.js
var require_v8_prototype_define_bug = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var DESCRIPTORS = require_descriptors();
    var fails = require_fails();
    module.exports = DESCRIPTORS && fails(function() {
        return Object.defineProperty(function() {}, "prototype", {
            value: 42,
            writable: false
        }).prototype !== 42;
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/an-object.js
var require_an_object = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isObject = require_is_object();
    var $String = String;
    var $TypeError = TypeError;
    module.exports = function(argument) {
        if (isObject(argument)) return argument;
        throw new $TypeError($String(argument) + " is not an object");
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/object-define-property.js
var require_object_define_property = /* @__PURE__ */ __commonJSMin((exports)=>{
    var DESCRIPTORS = require_descriptors();
    var IE8_DOM_DEFINE = require_ie8_dom_define();
    var V8_PROTOTYPE_DEFINE_BUG = require_v8_prototype_define_bug();
    var anObject = require_an_object();
    var toPropertyKey = require_to_property_key();
    var $TypeError = TypeError;
    var $defineProperty = Object.defineProperty;
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = "enumerable";
    var CONFIGURABLE = "configurable";
    var WRITABLE = "writable";
    exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPropertyKey(P);
        anObject(Attributes);
        if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
            var current = $getOwnPropertyDescriptor(O, P);
            if (current && current[WRITABLE]) {
                O[P] = Attributes.value;
                Attributes = {
                    configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                    enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                    writable: false
                };
            }
        }
        return $defineProperty(O, P, Attributes);
    } : $defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPropertyKey(P);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
            return $defineProperty(O, P, Attributes);
        } catch (error) {}
        if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/create-non-enumerable-property.js
var require_create_non_enumerable_property = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var DESCRIPTORS = require_descriptors();
    var definePropertyModule = require_object_define_property();
    var createPropertyDescriptor = require_create_property_descriptor();
    module.exports = DESCRIPTORS ? function(object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/export.js
var require_export = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var apply = require_function_apply();
    var uncurryThis = require_function_uncurry_this_clause();
    var isCallable = require_is_callable();
    var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
    var isForced = require_is_forced();
    var path = require_path();
    var bind = require_function_bind_context();
    var createNonEnumerableProperty = require_create_non_enumerable_property();
    var hasOwn = require_has_own_property();
    require_shared_store();
    var wrapConstructor = function(NativeConstructor) {
        var Wrapper = function(a, b, c) {
            if (this instanceof Wrapper) {
                switch(arguments.length){
                    case 0:
                        return new NativeConstructor();
                    case 1:
                        return new NativeConstructor(a);
                    case 2:
                        return new NativeConstructor(a, b);
                }
                return new NativeConstructor(a, b, c);
            }
            return apply(NativeConstructor, this, arguments);
        };
        Wrapper.prototype = NativeConstructor.prototype;
        return Wrapper;
    };
    module.exports = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var PROTO = options.proto;
        var nativeSource = GLOBAL ? globalThis1 : STATIC ? globalThis1[TARGET] : globalThis1[TARGET] && globalThis1[TARGET].prototype;
        var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
        var targetPrototype = target.prototype;
        var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
        var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
        for(key in source){
            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
            USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);
            targetProperty = target[key];
            if (USE_NATIVE) {
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(nativeSource, key);
                    nativeProperty = descriptor && descriptor.value;
                } else nativeProperty = nativeSource[key];
            }
            sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
            if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
            if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, globalThis1);
            else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
            else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
            else resultProperty = sourceProperty;
            if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(resultProperty, "sham", true);
            createNonEnumerableProperty(target, key, resultProperty);
            if (PROTO) {
                VIRTUAL_PROTOTYPE = TARGET + "Prototype";
                if (!hasOwn(path, VIRTUAL_PROTOTYPE)) createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
                createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
                if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) createNonEnumerableProperty(targetPrototype, key, sourceProperty);
            }
        }
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/math-trunc.js
var require_math_trunc = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var ceil = Math.ceil;
    var floor = Math.floor;
    module.exports = Math.trunc || function trunc(x) {
        var n = +x;
        return (n > 0 ? floor : ceil)(n);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-integer-or-infinity.js
var require_to_integer_or_infinity = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var trunc = require_math_trunc();
    module.exports = function(argument) {
        var number = +argument;
        return number !== number || number === 0 ? 0 : trunc(number);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-absolute-index.js
var require_to_absolute_index = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var toIntegerOrInfinity = require_to_integer_or_infinity();
    var max = Math.max;
    var min = Math.min;
    module.exports = function(index, length) {
        var integer = toIntegerOrInfinity(index);
        return integer < 0 ? max(integer + length, 0) : min(integer, length);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-length.js
var require_to_length = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var toIntegerOrInfinity = require_to_integer_or_infinity();
    var min = Math.min;
    module.exports = function(argument) {
        var len = toIntegerOrInfinity(argument);
        return len > 0 ? min(len, 9007199254740991) : 0;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/length-of-array-like.js
var require_length_of_array_like = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var toLength = require_to_length();
    module.exports = function(obj) {
        return toLength(obj.length);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/array-includes.js
var require_array_includes = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var toIndexedObject = require_to_indexed_object();
    var toAbsoluteIndex = require_to_absolute_index();
    var lengthOfArrayLike = require_length_of_array_like();
    var createMethod = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = lengthOfArrayLike(O);
            if (length === 0) return !IS_INCLUDES && -1;
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            if (IS_INCLUDES && el !== el) while(length > index){
                value = O[index++];
                if (value !== value) return true;
            }
            else for(; length > index; index++)if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            return !IS_INCLUDES && -1;
        };
    };
    module.exports = {
        includes: createMethod(true),
        indexOf: createMethod(false)
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/add-to-unscopables.js
var require_add_to_unscopables = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    module.exports = function() {};
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/modules/es.array.includes.js
var require_es_array_includes = /* @__PURE__ */ __commonJSMin(()=>{
    var $ = require_export();
    var $includes = require_array_includes().includes;
    var fails = require_fails();
    var addToUnscopables = require_add_to_unscopables();
    var BROKEN_ON_SPARSE = fails(function() {
        return !Array(1).includes();
    });
    var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function() {
        return [
            ,
            1
        ].includes(void 0, 1);
    });
    $({
        target: "Array",
        proto: true,
        forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX
    }, {
        includes: function includes(el) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    addToUnscopables("includes");
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/get-built-in-prototype-method.js
var require_get_built_in_prototype_method = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var globalThis1 = require_global_this();
    var path = require_path();
    module.exports = function(CONSTRUCTOR, METHOD) {
        var Namespace = path[CONSTRUCTOR + "Prototype"];
        var pureMethod = Namespace && Namespace[METHOD];
        if (pureMethod) return pureMethod;
        var NativeConstructor = globalThis1[CONSTRUCTOR];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        return NativePrototype && NativePrototype[METHOD];
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/es/array/virtual/includes.js
var require_includes$3 = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    require_es_array_includes();
    var getBuiltInPrototypeMethod = require_get_built_in_prototype_method();
    module.exports = getBuiltInPrototypeMethod("Array", "includes");
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/is-regexp.js
var require_is_regexp = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isObject = require_is_object();
    var classof = require_classof_raw();
    var MATCH = require_well_known_symbol()("match");
    module.exports = function(it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== void 0 ? !!isRegExp : classof(it) === "RegExp");
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/not-a-regexp.js
var require_not_a_regexp = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isRegExp = require_is_regexp();
    var $TypeError = TypeError;
    module.exports = function(it) {
        if (isRegExp(it)) throw new $TypeError("The method doesn't accept regular expressions");
        return it;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-string-tag-support.js
var require_to_string_tag_support = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var TO_STRING_TAG = require_well_known_symbol()("toStringTag");
    var test = {};
    test[TO_STRING_TAG] = "z";
    module.exports = String(test) === "[object z]";
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/classof.js
var require_classof = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
    var isCallable = require_is_callable();
    var classofRaw = require_classof_raw();
    var TO_STRING_TAG = require_well_known_symbol()("toStringTag");
    var $Object = Object;
    var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
    }()) === "Arguments";
    var tryGet = function(it, key) {
        try {
            return it[key];
        } catch (error) {}
    };
    module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
        var O, tag, result;
        return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/to-string.js
var require_to_string = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var classof = require_classof();
    var $String = String;
    module.exports = function(argument) {
        if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
        return $String(argument);
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/internals/correct-is-regexp-logic.js
var require_correct_is_regexp_logic = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var MATCH = require_well_known_symbol()("match");
    module.exports = function(METHOD_NAME) {
        var regexp = /./;
        try {
            "/./"[METHOD_NAME](regexp);
        } catch (error1) {
            try {
                regexp[MATCH] = false;
                return "/./"[METHOD_NAME](regexp);
            } catch (error2) {}
        }
        return false;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/modules/es.string.includes.js
var require_es_string_includes = /* @__PURE__ */ __commonJSMin(()=>{
    var $ = require_export();
    var uncurryThis = require_function_uncurry_this();
    var notARegExp = require_not_a_regexp();
    var requireObjectCoercible = require_require_object_coercible();
    var toString = require_to_string();
    var correctIsRegExpLogic = require_correct_is_regexp_logic();
    var stringIndexOf = uncurryThis("".indexOf);
    $({
        target: "String",
        proto: true,
        forced: !correctIsRegExpLogic("includes")
    }, {
        includes: function includes(searchString) {
            return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : void 0);
        }
    });
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/es/string/virtual/includes.js
var require_includes$2 = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    require_es_string_includes();
    var getBuiltInPrototypeMethod = require_get_built_in_prototype_method();
    module.exports = getBuiltInPrototypeMethod("String", "includes");
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/es/instance/includes.js
var require_includes$1 = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var isPrototypeOf = require_object_is_prototype_of();
    var arrayMethod = require_includes$3();
    var stringMethod = require_includes$2();
    var ArrayPrototype = Array.prototype;
    var StringPrototype = String.prototype;
    module.exports = function(it) {
        var own = it.includes;
        if (it === ArrayPrototype || isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.includes) return arrayMethod;
        if (typeof it == "string" || it === StringPrototype || isPrototypeOf(StringPrototype, it) && own === StringPrototype.includes) return stringMethod;
        return own;
    };
});
//#endregion
//#region node_modules/.pnpm/core-js-pure@3.49.0/node_modules/core-js-pure/stable/instance/includes.js
var require_includes = /* @__PURE__ */ __commonJSMin((exports, module)=>{
    var parent = require_includes$1();
    module.exports = parent;
});
//#endregion
//#region src/utils/utils.js
var utils_exports = /* @__PURE__ */ __exportAll({
    capitalize: ()=>capitalize,
    degrees: ()=>degrees,
    filter: ()=>filter,
    getOrigin: ()=>getOrigin,
    isDescriptive: ()=>isDescriptive,
    map: ()=>map,
    proportionalSize: ()=>proportionalSize,
    radians: ()=>radians,
    unCamelCase: ()=>unCamelCase,
    writeDataToDom: ()=>writeDataToDom
});
var import_includes = /* @__PURE__ */ __toESM(require_includes(), 1);
function map(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)result.push(block(array[i]));
    return result;
}
function filter(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)if (block(array[i])) result.push(array[i]);
    return result;
}
function radians(d) {
    return d % 360 * Math.PI / 180;
}
function degrees(r) {
    return r * 180 / Math.PI % 360;
}
function unCamelCase(s) {
    return s.replace(/([A-Z])/g, function(m, g) {
        return "-" + g.toLowerCase();
    });
}
function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
function proportionalSize(element, width, height, box) {
    if (width == null || height == null) {
        box = box || element.bbox();
        if (width == null) width = box.width / box.height * height;
        else if (height == null) height = box.height / box.width * width;
    }
    return {
        width: width,
        height: height
    };
}
/**
* This function adds support for string origins.
* It searches for an origin in o.origin o.ox and o.originX.
* This way, origin: {x: 'center', y: 50} can be passed as well as ox: 'center', oy: 50
**/ function getOrigin(o, element) {
    const origin = o.origin;
    let ox = o.ox != null ? o.ox : o.originX != null ? o.originX : "center";
    let oy = o.oy != null ? o.oy : o.originY != null ? o.originY : "center";
    if (origin != null) [ox, oy] = Array.isArray(origin) ? origin : typeof origin === "object" ? [
        origin.x,
        origin.y
    ] : [
        origin,
        origin
    ];
    const condX = typeof ox === "string";
    const condY = typeof oy === "string";
    if (condX || condY) {
        const { height, width, x, y } = element.bbox();
        if (condX) ox = (0, import_includes.default)(ox).call(ox, "left") ? x : (0, import_includes.default)(ox).call(ox, "right") ? x + width : x + width / 2;
        if (condY) oy = (0, import_includes.default)(oy).call(oy, "top") ? y : (0, import_includes.default)(oy).call(oy, "bottom") ? y + height : y + height / 2;
    }
    return [
        ox,
        oy
    ];
}
const descriptiveElements = /* @__PURE__ */ new Set([
    "desc",
    "metadata",
    "title"
]);
const isDescriptive = (element)=>descriptiveElements.has(element.nodeName);
const writeDataToDom = (element, data, defaults = {})=>{
    const cloned = {
        ...data
    };
    for(const key in cloned)if (cloned[key].valueOf() === defaults[key]) delete cloned[key];
    if (Object.keys(cloned).length) element.node.setAttribute("data-svgjs", JSON.stringify(cloned));
    else {
        element.node.removeAttribute("data-svgjs");
        element.node.removeAttribute("svgjs:data");
    }
};
//#endregion
//#region src/modules/core/namespaces.js
var namespaces_exports = /* @__PURE__ */ __exportAll({
    html: ()=>html,
    svg: ()=>svg,
    xlink: ()=>xlink,
    xmlns: ()=>xmlns
});
const svg = "http://www.w3.org/2000/svg";
const html = "http://www.w3.org/1999/xhtml";
const xmlns = "http://www.w3.org/2000/xmlns/";
const xlink = "http://www.w3.org/1999/xlink";
//#endregion
//#region src/utils/window.js
const globals = {
    window: typeof window === "undefined" ? null : window,
    document: typeof document === "undefined" ? null : document
};
function registerWindow(win = null, doc = null) {
    globals.window = win;
    globals.document = doc;
}
function withWindow(win, fn) {
    const oldWindow = globals.window;
    const oldDocument = globals.document;
    registerWindow(win, win.document);
    try {
        return fn(win, win.document);
    } finally{
        registerWindow(oldWindow, oldDocument);
    }
}
function getWindow() {
    return globals.window;
}
//#endregion
//#region src/types/Base.js
var Base = class {
};
//#endregion
//#region src/utils/adopter.js
const elements = {};
const root = "___SYMBOL___ROOT___";
function create(name, ns = svg) {
    return globals.document.createElementNS(ns, name);
}
function makeInstance(element, isHTML = false) {
    if (element instanceof Base) return element;
    if (typeof element === "object") return adopter(element);
    if (element == null) return new elements[root]();
    if (typeof element === "string" && element.trim().charAt(0) !== "<") return adopter(globals.document.querySelector(element));
    const wrapper = isHTML ? globals.document.createElement("div") : create("svg");
    wrapper.innerHTML = element.trim();
    element = adopter(wrapper.firstElementChild);
    wrapper.removeChild(wrapper.firstElementChild);
    return element;
}
function nodeOrNew(name, node) {
    return node && (node instanceof globals.window.Node || node.ownerDocument && node instanceof node.ownerDocument.defaultView.Node) ? node : create(name);
}
function adopt(node) {
    if (!node) return null;
    if (node.instance instanceof Base) return node.instance;
    if (node.nodeName === "#document-fragment") return new elements.Fragment(node);
    let className = capitalize(node.nodeName || "Dom");
    if (className === "LinearGradient" || className === "RadialGradient") className = "Gradient";
    else if (!elements[className]) className = "Dom";
    return new elements[className](node);
}
let adopter = adopt;
function mockAdopt(mock = adopt) {
    adopter = mock;
}
function register(element, name = element.name, asRoot = false) {
    elements[name] = element;
    if (asRoot) elements[root] = element;
    addMethodNames(Object.getOwnPropertyNames(element.prototype));
    return element;
}
function getClass(name) {
    return elements[name];
}
let did = 1e3;
function eid(name) {
    return "Svgjs" + capitalize(name) + did++;
}
function assignNewId(node) {
    for(let i = node.children.length - 1; i >= 0; i--)assignNewId(node.children[i]);
    if (node.id) {
        node.id = eid(node.nodeName);
        return node;
    }
    return node;
}
function extend(modules, methods) {
    let key, i;
    modules = Array.isArray(modules) ? modules : [
        modules
    ];
    for(i = modules.length - 1; i >= 0; i--)for(key in methods)modules[i].prototype[key] = methods[key];
}
function wrapWithAttrCheck(fn) {
    return function(...args) {
        const o = args[args.length - 1];
        if (o && o.constructor === Object && !(o instanceof Array)) return fn.apply(this, args.slice(0, -1)).attr(o);
        else return fn.apply(this, args);
    };
}
//#endregion
//#region src/modules/optional/arrange.js
function siblings() {
    return this.parent().children();
}
function position() {
    return this.parent().index(this);
}
function next() {
    return this.siblings()[this.position() + 1];
}
function prev() {
    return this.siblings()[this.position() - 1];
}
function forward() {
    const i = this.position();
    this.parent().add(this.remove(), i + 1);
    return this;
}
function backward() {
    const i = this.position();
    this.parent().add(this.remove(), i ? i - 1 : 0);
    return this;
}
function front() {
    this.parent().add(this.remove());
    return this;
}
function back() {
    this.parent().add(this.remove(), 0);
    return this;
}
function before(element) {
    element = makeInstance(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i);
    return this;
}
function after(element) {
    element = makeInstance(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i + 1);
    return this;
}
function insertBefore(element) {
    element = makeInstance(element);
    element.before(this);
    return this;
}
function insertAfter(element) {
    element = makeInstance(element);
    element.after(this);
    return this;
}
registerMethods("Dom", {
    siblings: siblings,
    position: position,
    next: next,
    prev: prev,
    forward: forward,
    backward: backward,
    front: front,
    back: back,
    before: before,
    after: after,
    insertBefore: insertBefore,
    insertAfter: insertAfter
});
//#endregion
//#region src/modules/core/regex.js
var regex_exports = /* @__PURE__ */ __exportAll({
    delimiter: ()=>delimiter,
    hex: ()=>hex,
    isBlank: ()=>isBlank,
    isHex: ()=>isHex,
    isImage: ()=>isImage,
    isNumber: ()=>isNumber,
    isPathLetter: ()=>isPathLetter,
    isRgb: ()=>isRgb,
    numberAndUnit: ()=>numberAndUnit,
    reference: ()=>reference,
    rgb: ()=>rgb,
    transforms: ()=>transforms,
    whitespace: ()=>whitespace
});
const numberAndUnit = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i;
const hex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
const rgb = /rgb\((\d+),(\d+),(\d+)\)/;
const reference = /^(#[^\s]+)$/;
const transforms = /\)\s*,?\s*/;
const whitespace = /\s/g;
const isHex = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i;
const isRgb = /^rgb\(/;
const isBlank = /^(\s+)?$/;
const isNumber = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
const isImage = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i;
const delimiter = /[\s,]+/;
const isPathLetter = /[MLHVCSQTAZ]/i;
//#endregion
//#region src/modules/optional/class.js
function classes() {
    const attr = this.attr("class");
    return attr == null ? [] : attr.trim().split(delimiter);
}
function hasClass(name) {
    return this.classes().indexOf(name) !== -1;
}
function addClass(name) {
    if (!this.hasClass(name)) {
        const array = this.classes();
        array.push(name);
        this.attr("class", array.join(" "));
    }
    return this;
}
function removeClass(name) {
    if (this.hasClass(name)) this.attr("class", this.classes().filter(function(c) {
        return c !== name;
    }).join(" "));
    return this;
}
function toggleClass(name) {
    return this.hasClass(name) ? this.removeClass(name) : this.addClass(name);
}
registerMethods("Dom", {
    classes: classes,
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass
});
//#endregion
//#region src/modules/optional/css.js
const cssName = (name)=>name.startsWith("--") ? name : unCamelCase(name);
function css(style, val) {
    const ret = {};
    if (arguments.length === 0) {
        const declaration = this.node.style;
        for(let i = 0; i < declaration.length; i++){
            const name = declaration.item(i);
            const value = declaration.getPropertyValue(name);
            const priority = declaration.getPropertyPriority(name);
            ret[name] = priority ? `${value} !${priority}` : value;
        }
        return ret;
    }
    if (arguments.length < 2) {
        if (Array.isArray(style)) {
            for (const name of style){
                const cased = cssName(name);
                ret[name] = this.node.style.getPropertyValue(cased);
            }
            return ret;
        }
        if (typeof style === "string") return this.node.style.getPropertyValue(cssName(style));
        if (typeof style === "object") for(const name in style)this.node.style.setProperty(cssName(name), style[name] == null || isBlank.test(style[name]) ? "" : style[name]);
    }
    if (arguments.length === 2) this.node.style.setProperty(cssName(style), val == null || isBlank.test(val) ? "" : val);
    return this;
}
function show() {
    return this.css("display", "");
}
function hide() {
    return this.css("display", "none");
}
function visible() {
    return this.css("display") !== "none";
}
registerMethods("Dom", {
    css: css,
    show: show,
    hide: hide,
    visible: visible
});
//#endregion
//#region src/modules/optional/data.js
function data(a, v, r) {
    if (a == null) return this.data(map(filter(this.node.attributes, (el)=>el.nodeName.indexOf("data-") === 0), (el)=>el.nodeName.slice(5)));
    else if (a instanceof Array) {
        const data = {};
        for (const key of a)data[key] = this.data(key);
        return data;
    } else if (typeof a === "object") for(v in a)this.data(v, a[v]);
    else if (arguments.length < 2) try {
        return JSON.parse(this.attr("data-" + a));
    } catch (e) {
        return this.attr("data-" + a);
    }
    else this.attr("data-" + a, v === null ? null : r === true || typeof v === "string" || typeof v === "number" ? v : JSON.stringify(v));
    return this;
}
registerMethods("Dom", {
    data: data
});
//#endregion
//#region src/modules/optional/memory.js
function remember(k, v) {
    if (typeof arguments[0] === "object") for(const key in k)this.remember(key, k[key]);
    else if (arguments.length === 1) return this.memory()[k];
    else this.memory()[k] = v;
    return this;
}
function forget() {
    if (arguments.length === 0) this._memory = {};
    else for(let i = arguments.length - 1; i >= 0; i--)delete this.memory()[arguments[i]];
    return this;
}
function memory() {
    return this._memory = this._memory || {};
}
registerMethods("Dom", {
    remember: remember,
    forget: forget,
    memory: memory
});
//#endregion
//#region src/types/Color.js
function sixDigitHex(hex) {
    return hex.length === 4 ? [
        "#",
        hex.substring(1, 2),
        hex.substring(1, 2),
        hex.substring(2, 3),
        hex.substring(2, 3),
        hex.substring(3, 4),
        hex.substring(3, 4)
    ].join("") : hex;
}
function componentHex(component) {
    const hex = Math.max(0, Math.min(255, Math.round(component))).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function is(object, space) {
    for(let i = space.length; i--;)if (object[space[i]] == null) return false;
    return true;
}
function getParameters(a, b) {
    const params = is(a, "rgb") ? {
        _a: a.r,
        _b: a.g,
        _c: a.b,
        _d: 0,
        space: "rgb"
    } : is(a, "xyz") ? {
        _a: a.x,
        _b: a.y,
        _c: a.z,
        _d: 0,
        space: "xyz"
    } : is(a, "hsl") ? {
        _a: a.h,
        _b: a.s,
        _c: a.l,
        _d: 0,
        space: "hsl"
    } : is(a, "lab") ? {
        _a: a.l,
        _b: a.a,
        _c: a.b,
        _d: 0,
        space: "lab"
    } : is(a, "lch") ? {
        _a: a.l,
        _b: a.c,
        _c: a.h,
        _d: 0,
        space: "lch"
    } : is(a, "cmyk") ? {
        _a: a.c,
        _b: a.m,
        _c: a.y,
        _d: a.k,
        space: "cmyk"
    } : {
        _a: 0,
        _b: 0,
        _c: 0,
        space: "rgb"
    };
    params.space = b || params.space;
    return params;
}
function cieSpace(space) {
    if (space === "lab" || space === "xyz" || space === "lch") return true;
    else return false;
}
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
var Color = class Color {
    constructor(...inputs){
        this.init(...inputs);
    }
    static isColor(color) {
        return color && (color instanceof Color || this.isRgb(color) || this.test(color));
    }
    static isRgb(color) {
        return color && typeof color.r === "number" && typeof color.g === "number" && typeof color.b === "number";
    }
    static random(mode = "vibrant", t) {
        const { random, round, sin, PI: pi } = Math;
        if (mode === "vibrant") {
            const l = 24 * random() + 57;
            const c = 38 * random() + 45;
            const h = 360 * random();
            return new Color(l, c, h, "lch");
        } else if (mode === "sine") {
            t = t == null ? random() : t;
            const r = round(80 * sin(2 * pi * t / .5 + .01) + 150);
            const g = round(50 * sin(2 * pi * t / .5 + 4.6) + 200);
            const b = round(100 * sin(2 * pi * t / .5 + 2.3) + 150);
            return new Color(r, g, b);
        } else if (mode === "pastel") {
            const l = 8 * random() + 86;
            const c = 17 * random() + 9;
            const h = 360 * random();
            return new Color(l, c, h, "lch");
        } else if (mode === "dark") {
            const l = 10 + 10 * random();
            const c = 50 * random() + 86;
            const h = 360 * random();
            return new Color(l, c, h, "lch");
        } else if (mode === "rgb") {
            const r = 255 * random();
            const g = 255 * random();
            const b = 255 * random();
            return new Color(r, g, b);
        } else if (mode === "lab") {
            const l = 100 * random();
            const a = 256 * random() - 128;
            const b = 256 * random() - 128;
            return new Color(l, a, b, "lab");
        } else if (mode === "grey") {
            const grey = 255 * random();
            return new Color(grey, grey, grey);
        } else throw new Error("Unsupported random color mode");
    }
    static test(color) {
        return typeof color === "string" && (isHex.test(color) || isRgb.test(color));
    }
    cmyk() {
        const { _a, _b, _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255);
        const k = Math.min(1 - r, 1 - g, 1 - b);
        if (k === 1) return new Color(0, 0, 0, 1, "cmyk");
        const c = (1 - r - k) / (1 - k);
        const m = (1 - g - k) / (1 - k);
        const y = (1 - b - k) / (1 - k);
        return new Color(c, m, y, k, "cmyk");
    }
    hsl() {
        const { _a, _b, _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255);
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;
        const isGrey = max === min;
        const delta = max - min;
        const s = isGrey ? 0 : l > .5 ? delta / (2 - max - min) : delta / (max + min);
        const h = isGrey ? 0 : max === r ? ((g - b) / delta + (g < b ? 6 : 0)) / 6 : max === g ? ((b - r) / delta + 2) / 6 : max === b ? ((r - g) / delta + 4) / 6 : 0;
        return new Color(360 * h, 100 * s, 100 * l, "hsl");
    }
    init(a = 0, b = 0, c = 0, d = 0, space = "rgb") {
        a = !a ? 0 : a;
        if (this.space) for(const component in this.space)delete this[this.space[component]];
        if (typeof a === "number") {
            space = typeof d === "string" ? d : space;
            d = typeof d === "string" ? 0 : d;
            Object.assign(this, {
                _a: a,
                _b: b,
                _c: c,
                _d: d,
                space: space
            });
        } else if (a instanceof Array) {
            this.space = b || (typeof a[3] === "string" ? a[3] : a[4]) || "rgb";
            Object.assign(this, {
                _a: a[0],
                _b: a[1],
                _c: a[2],
                _d: a[3] || 0
            });
        } else if (a instanceof Object) {
            const values = getParameters(a, b);
            Object.assign(this, values);
        } else if (typeof a === "string") {
            if (isRgb.test(a)) {
                const noWhitespace = a.replace(whitespace, "");
                const [_a, _b, _c] = rgb.exec(noWhitespace).slice(1, 4).map((v)=>parseInt(v));
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else if (isHex.test(a)) {
                const hexParse = (v)=>parseInt(v, 16);
                const [, _a, _b, _c] = hex.exec(sixDigitHex(a)).map(hexParse);
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else throw Error("Unsupported string format, can't construct Color");
        }
        const { _a, _b, _c, _d } = this;
        const components = this.space === "rgb" ? {
            r: _a,
            g: _b,
            b: _c
        } : this.space === "xyz" ? {
            x: _a,
            y: _b,
            z: _c
        } : this.space === "hsl" ? {
            h: _a,
            s: _b,
            l: _c
        } : this.space === "lab" ? {
            l: _a,
            a: _b,
            b: _c
        } : this.space === "lch" ? {
            l: _a,
            c: _b,
            h: _c
        } : this.space === "cmyk" ? {
            c: _a,
            m: _b,
            y: _c,
            k: _d
        } : {};
        Object.assign(this, components);
    }
    lab() {
        const { x, y, z } = this.xyz();
        const l = 116 * y - 16;
        const a = 500 * (x - y);
        const b = 200 * (y - z);
        return new Color(l, a, b, "lab");
    }
    lch() {
        const { l, a, b } = this.lab();
        const c = Math.sqrt(a ** 2 + b ** 2);
        let h = 180 * Math.atan2(b, a) / Math.PI;
        if (h < 0) {
            h *= -1;
            h = 360 - h;
        }
        return new Color(l, c, h, "lch");
    }
    rgb() {
        if (this.space === "rgb") return this;
        else if (cieSpace(this.space)) {
            let { x, y, z } = this;
            if (this.space === "lab" || this.space === "lch") {
                let { l, a, b } = this;
                if (this.space === "lch") {
                    const { c, h } = this;
                    const dToR = Math.PI / 180;
                    a = c * Math.cos(dToR * h);
                    b = c * Math.sin(dToR * h);
                }
                const yL = (l + 16) / 116;
                const xL = a / 500 + yL;
                const zL = yL - b / 200;
                const ct = 16 / 116;
                const mx = .008856;
                const nm = 7.787;
                x = .95047 * (xL ** 3 > mx ? xL ** 3 : (xL - ct) / nm);
                y = 1 * (yL ** 3 > mx ? yL ** 3 : (yL - ct) / nm);
                z = 1.08883 * (zL ** 3 > mx ? zL ** 3 : (zL - ct) / nm);
            }
            const rU = x * 3.2406 + y * -1.5372 + z * -0.4986;
            const gU = x * -0.9689 + y * 1.8758 + z * .0415;
            const bU = x * .0557 + y * -0.204 + z * 1.057;
            const pow = Math.pow;
            const bd = .0031308;
            const r = rU > bd ? 1.055 * pow(rU, 1 / 2.4) - .055 : 12.92 * rU;
            const g = gU > bd ? 1.055 * pow(gU, 1 / 2.4) - .055 : 12.92 * gU;
            const b = bU > bd ? 1.055 * pow(bU, 1 / 2.4) - .055 : 12.92 * bU;
            return new Color(255 * r, 255 * g, 255 * b);
        } else if (this.space === "hsl") {
            let { h, s, l } = this;
            h /= 360;
            s /= 100;
            l /= 100;
            if (s === 0) {
                l *= 255;
                return new Color(l, l, l);
            }
            const q = l < .5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            const r = 255 * hueToRgb(p, q, h + 1 / 3);
            const g = 255 * hueToRgb(p, q, h);
            const b = 255 * hueToRgb(p, q, h - 1 / 3);
            return new Color(r, g, b);
        } else if (this.space === "cmyk") {
            const { c, m, y, k } = this;
            const r = 255 * (1 - Math.min(1, c * (1 - k) + k));
            const g = 255 * (1 - Math.min(1, m * (1 - k) + k));
            const b = 255 * (1 - Math.min(1, y * (1 - k) + k));
            return new Color(r, g, b);
        } else return this;
    }
    toArray() {
        const { _a, _b, _c, _d, space } = this;
        return [
            _a,
            _b,
            _c,
            _d,
            space
        ];
    }
    toHex() {
        const [r, g, b] = this._clamped().map(componentHex);
        return `#${r}${g}${b}`;
    }
    toRgb() {
        const [rV, gV, bV] = this._clamped();
        return `rgb(${rV},${gV},${bV})`;
    }
    toString() {
        return this.toHex();
    }
    xyz() {
        const { _a: r255, _b: g255, _c: b255 } = this.rgb();
        const [r, g, b] = [
            r255,
            g255,
            b255
        ].map((v)=>v / 255);
        const rL = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92;
        const gL = g > .04045 ? Math.pow((g + .055) / 1.055, 2.4) : g / 12.92;
        const bL = b > .04045 ? Math.pow((b + .055) / 1.055, 2.4) : b / 12.92;
        const xU = (rL * .4124 + gL * .3576 + bL * .1805) / .95047;
        const yU = (rL * .2126 + gL * .7152 + bL * .0722) / 1;
        const zU = (rL * .0193 + gL * .1192 + bL * .9505) / 1.08883;
        const x = xU > .008856 ? Math.pow(xU, 1 / 3) : 7.787 * xU + 16 / 116;
        const y = yU > .008856 ? Math.pow(yU, 1 / 3) : 7.787 * yU + 16 / 116;
        const z = zU > .008856 ? Math.pow(zU, 1 / 3) : 7.787 * zU + 16 / 116;
        return new Color(x, y, z, "xyz");
    }
    _clamped() {
        const { _a, _b, _c } = this.rgb();
        const { max, min, round } = Math;
        const format = (v)=>max(0, min(round(v), 255));
        return [
            _a,
            _b,
            _c
        ].map(format);
    }
};
//#endregion
//#region src/types/Point.js
var Point = class Point {
    constructor(...args){
        this.init(...args);
    }
    clone() {
        return new Point(this);
    }
    init(x, y) {
        const base = {
            x: 0,
            y: 0
        };
        const source = Array.isArray(x) ? {
            x: x[0],
            y: x[1]
        } : typeof x === "object" ? {
            x: x.x,
            y: x.y
        } : {
            x: x,
            y: y
        };
        this.x = source.x == null ? base.x : source.x;
        this.y = source.y == null ? base.y : source.y;
        return this;
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    transformO(m) {
        if (!Matrix.isMatrixLike(m)) m = new Matrix(m);
        const { x, y } = this;
        this.x = m.a * x + m.c * y + m.e;
        this.y = m.b * x + m.d * y + m.f;
        return this;
    }
};
function point(x, y) {
    return new Point(x, y).transformO(this.screenCTM().inverseO());
}
//#endregion
//#region src/types/Matrix.js
function closeEnough(a, b, threshold) {
    return Math.abs(b - a) < (threshold || 1e-6);
}
var Matrix = class Matrix {
    constructor(...args){
        this.init(...args);
    }
    static formatTransforms(o) {
        const flipBoth = o.flip === "both" || o.flip === true;
        const flipX = o.flip && (flipBoth || o.flip === "x") ? -1 : 1;
        const flipY = o.flip && (flipBoth || o.flip === "y") ? -1 : 1;
        const skewX = o.skew && o.skew.length ? o.skew[0] : isFinite(o.skew) ? o.skew : isFinite(o.skewX) ? o.skewX : 0;
        const skewY = o.skew && o.skew.length ? o.skew[1] : isFinite(o.skew) ? o.skew : isFinite(o.skewY) ? o.skewY : 0;
        const scaleX = o.scale && o.scale.length ? o.scale[0] * flipX : isFinite(o.scale) ? o.scale * flipX : isFinite(o.scaleX) ? o.scaleX * flipX : flipX;
        const scaleY = o.scale && o.scale.length ? o.scale[1] * flipY : isFinite(o.scale) ? o.scale * flipY : isFinite(o.scaleY) ? o.scaleY * flipY : flipY;
        const shear = o.shear || 0;
        const theta = o.rotate || o.theta || 0;
        const origin = new Point(o.origin || o.around || o.ox || o.originX, o.oy || o.originY);
        const ox = origin.x;
        const oy = origin.y;
        const position = new Point(o.position ?? o.px ?? o.positionX ?? NaN, o.py ?? o.positionY ?? NaN);
        const px = position.x;
        const py = position.y;
        const translate = new Point(o.translate || o.tx || o.translateX, o.ty || o.translateY);
        const tx = translate.x;
        const ty = translate.y;
        const relative = new Point(o.relative || o.rx || o.relativeX, o.ry || o.relativeY);
        return {
            scaleX: scaleX,
            scaleY: scaleY,
            skewX: skewX,
            skewY: skewY,
            shear: shear,
            theta: theta,
            rx: relative.x,
            ry: relative.y,
            tx: tx,
            ty: ty,
            ox: ox,
            oy: oy,
            px: px,
            py: py
        };
    }
    static fromArray(a) {
        return {
            a: a[0],
            b: a[1],
            c: a[2],
            d: a[3],
            e: a[4],
            f: a[5]
        };
    }
    static isMatrixLike(o) {
        return o.a != null || o.b != null || o.c != null || o.d != null || o.e != null || o.f != null;
    }
    static matrixMultiply(l, r, o) {
        const a = l.a * r.a + l.c * r.b;
        const b = l.b * r.a + l.d * r.b;
        const c = l.a * r.c + l.c * r.d;
        const d = l.b * r.c + l.d * r.d;
        const e = l.e + l.a * r.e + l.c * r.f;
        const f = l.f + l.b * r.e + l.d * r.f;
        o.a = a;
        o.b = b;
        o.c = c;
        o.d = d;
        o.e = e;
        o.f = f;
        return o;
    }
    around(cx, cy, matrix) {
        return this.clone().aroundO(cx, cy, matrix);
    }
    aroundO(cx, cy, matrix) {
        const dx = cx || 0;
        const dy = cy || 0;
        return this.translateO(-dx, -dy).lmultiplyO(matrix).translateO(dx, dy);
    }
    clone() {
        return new Matrix(this);
    }
    decompose(cx = 0, cy = 0) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f;
        const determinant = a * d - b * c;
        const ccw = determinant > 0 ? 1 : -1;
        const sx = ccw * Math.sqrt(a * a + b * b);
        const thetaRad = Math.atan2(ccw * b, ccw * a);
        const theta = 180 / Math.PI * thetaRad;
        const lam = (a * c + b * d) / determinant;
        return {
            scaleX: sx,
            scaleY: c * sx / (lam * a - b) || d * sx / (lam * b + a),
            shear: lam,
            rotate: theta,
            translateX: e - cx + cx * a + cy * c,
            translateY: f - cy + cx * b + cy * d,
            originX: cx,
            originY: cy,
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
    equals(other) {
        if (other === this) return true;
        const comp = new Matrix(other);
        return closeEnough(this.a, comp.a) && closeEnough(this.b, comp.b) && closeEnough(this.c, comp.c) && closeEnough(this.d, comp.d) && closeEnough(this.e, comp.e) && closeEnough(this.f, comp.f);
    }
    flip(axis, around) {
        return this.clone().flipO(axis, around);
    }
    flipO(axis, around) {
        return axis === "x" ? this.scaleO(-1, 1, around, 0) : axis === "y" ? this.scaleO(1, -1, 0, around) : this.scaleO(-1, -1, axis, around || axis);
    }
    init(source) {
        const base = Matrix.fromArray([
            1,
            0,
            0,
            1,
            0,
            0
        ]);
        source = source instanceof Element ? source.matrixify() : typeof source === "string" ? Matrix.fromArray(source.split(delimiter).map(parseFloat)) : Array.isArray(source) ? Matrix.fromArray(source) : typeof source === "object" && Matrix.isMatrixLike(source) ? source : typeof source === "object" ? new Matrix().transform(source) : arguments.length === 6 ? Matrix.fromArray([].slice.call(arguments)) : base;
        this.a = source.a != null ? source.a : base.a;
        this.b = source.b != null ? source.b : base.b;
        this.c = source.c != null ? source.c : base.c;
        this.d = source.d != null ? source.d : base.d;
        this.e = source.e != null ? source.e : base.e;
        this.f = source.f != null ? source.f : base.f;
        return this;
    }
    inverse() {
        return this.clone().inverseO();
    }
    inverseO() {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f;
        const det = a * d - b * c;
        if (!det) throw new Error("Cannot invert " + this);
        const na = d / det;
        const nb = -b / det;
        const nc = -c / det;
        const nd = a / det;
        const ne = -(na * e + nc * f);
        const nf = -(nb * e + nd * f);
        this.a = na;
        this.b = nb;
        this.c = nc;
        this.d = nd;
        this.e = ne;
        this.f = nf;
        return this;
    }
    lmultiply(matrix) {
        return this.clone().lmultiplyO(matrix);
    }
    lmultiplyO(matrix) {
        const r = this;
        const l = matrix instanceof Matrix ? matrix : new Matrix(matrix);
        return Matrix.matrixMultiply(l, r, this);
    }
    multiply(matrix) {
        return this.clone().multiplyO(matrix);
    }
    multiplyO(matrix) {
        const l = this;
        const r = matrix instanceof Matrix ? matrix : new Matrix(matrix);
        return Matrix.matrixMultiply(l, r, this);
    }
    rotate(r, cx, cy) {
        return this.clone().rotateO(r, cx, cy);
    }
    rotateO(r, cx = 0, cy = 0) {
        r = radians(r);
        const cos = Math.cos(r);
        const sin = Math.sin(r);
        const { a, b, c, d, e, f } = this;
        this.a = a * cos - b * sin;
        this.b = b * cos + a * sin;
        this.c = c * cos - d * sin;
        this.d = d * cos + c * sin;
        this.e = e * cos - f * sin + cy * sin - cx * cos + cx;
        this.f = f * cos + e * sin - cx * sin - cy * cos + cy;
        return this;
    }
    scale() {
        return this.clone().scaleO(...arguments);
    }
    scaleO(x, y = x, cx = 0, cy = 0) {
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        }
        const { a, b, c, d, e, f } = this;
        this.a = a * x;
        this.b = b * y;
        this.c = c * x;
        this.d = d * y;
        this.e = e * x - cx * x + cx;
        this.f = f * y - cy * y + cy;
        return this;
    }
    shear(a, cx, cy) {
        return this.clone().shearO(a, cx, cy);
    }
    shearO(lx, cx = 0, cy = 0) {
        const { a, b, c, d, e, f } = this;
        this.a = a + b * lx;
        this.c = c + d * lx;
        this.e = e + f * lx - cy * lx;
        return this;
    }
    skew() {
        return this.clone().skewO(...arguments);
    }
    skewO(x, y = x, cx = 0, cy = 0) {
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        }
        x = radians(x);
        y = radians(y);
        const lx = Math.tan(x);
        const ly = Math.tan(y);
        const { a, b, c, d, e, f } = this;
        this.a = a + b * lx;
        this.b = b + a * ly;
        this.c = c + d * lx;
        this.d = d + c * ly;
        this.e = e + f * lx - cy * lx;
        this.f = f + e * ly - cx * ly;
        return this;
    }
    skewX(x, cx, cy) {
        return this.skew(x, 0, cx, cy);
    }
    skewY(y, cx, cy) {
        return this.skew(0, y, cx, cy);
    }
    toArray() {
        return [
            this.a,
            this.b,
            this.c,
            this.d,
            this.e,
            this.f
        ];
    }
    toString() {
        return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
    }
    transform(o) {
        if (Matrix.isMatrixLike(o)) return new Matrix(o).multiplyO(this);
        const t = Matrix.formatTransforms(o);
        const current = this;
        const { x: ox, y: oy } = new Point(t.ox, t.oy).transform(current);
        const transformer = new Matrix().translateO(t.rx, t.ry).lmultiplyO(current).translateO(-ox, -oy).scaleO(t.scaleX, t.scaleY).skewO(t.skewX, t.skewY).shearO(t.shear).rotateO(t.theta).translateO(ox, oy);
        if (isFinite(t.px) || isFinite(t.py)) {
            const origin = new Point(ox, oy).transform(transformer);
            const dx = isFinite(t.px) ? t.px - origin.x : 0;
            const dy = isFinite(t.py) ? t.py - origin.y : 0;
            transformer.translateO(dx, dy);
        }
        transformer.translateO(t.tx, t.ty);
        return transformer;
    }
    translate(x, y) {
        return this.clone().translateO(x, y);
    }
    translateO(x, y) {
        this.e += x || 0;
        this.f += y || 0;
        return this;
    }
    valueOf() {
        return {
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
};
function ctm() {
    return new Matrix(this.node.getCTM());
}
function screenCTM() {
    try {
        if (typeof this.isRoot === "function" && !this.isRoot()) {
            const rect = this.rect(1, 1);
            const m = rect.node.getScreenCTM();
            rect.remove();
            return new Matrix(m);
        }
        return new Matrix(this.node.getScreenCTM());
    } catch (e) {
        console.warn(`Cannot get CTM from SVG node ${this.node.nodeName}. Is the element rendered?`);
        return new Matrix();
    }
}
register(Matrix, "Matrix");
//#endregion
//#region src/modules/core/parser.js
function parser() {
    if (!parser.nodes || parser.nodes.svg.node.ownerDocument !== globals.document) {
        const svg = makeInstance().size(2, 0);
        svg.node.style.cssText = [
            "opacity: 0",
            "position: absolute",
            "left: -100%",
            "top: -100%",
            "overflow: hidden"
        ].join(";");
        svg.attr("focusable", "false");
        svg.attr("aria-hidden", "true");
        parser.nodes = {
            svg: svg,
            path: svg.path().node
        };
    }
    if (!parser.nodes.svg.node.parentNode) parser.nodes.svg.addTo(globals.document.body || globals.document.documentElement);
    return parser.nodes;
}
//#endregion
//#region src/types/Box.js
function isNulledBox(box) {
    return !box.width && !box.height && !box.x && !box.y;
}
function domContains(node) {
    return node === globals.document || (globals.document.documentElement.contains || function(node) {
        while(node.parentNode)node = node.parentNode;
        return node === globals.document;
    }).call(globals.document.documentElement, node);
}
var Box = class Box {
    constructor(...args){
        this.init(...args);
    }
    addOffset() {
        this.x += globals.window.pageXOffset;
        this.y += globals.window.pageYOffset;
        return new Box(this);
    }
    init(source) {
        source = typeof source === "string" ? source.split(delimiter).map(parseFloat) : Array.isArray(source) ? source : typeof source === "object" ? [
            source.left != null ? source.left : source.x,
            source.top != null ? source.top : source.y,
            source.width,
            source.height
        ] : arguments.length === 4 ? [].slice.call(arguments) : [
            0,
            0,
            0,
            0
        ];
        this.x = source[0] || 0;
        this.y = source[1] || 0;
        this.width = this.w = source[2] || 0;
        this.height = this.h = source[3] || 0;
        this.x2 = this.x + this.w;
        this.y2 = this.y + this.h;
        this.cx = this.x + this.w / 2;
        this.cy = this.y + this.h / 2;
        return this;
    }
    isNulled() {
        return isNulledBox(this);
    }
    merge(box) {
        const x = Math.min(this.x, box.x);
        const y = Math.min(this.y, box.y);
        const width = Math.max(this.x + this.width, box.x + box.width) - x;
        const height = Math.max(this.y + this.height, box.y + box.height) - y;
        return new Box(x, y, width, height);
    }
    toArray() {
        return [
            this.x,
            this.y,
            this.width,
            this.height
        ];
    }
    toString() {
        return this.x + " " + this.y + " " + this.width + " " + this.height;
    }
    transform(m) {
        if (!(m instanceof Matrix)) m = new Matrix(m);
        let xMin = Infinity;
        let xMax = -Infinity;
        let yMin = Infinity;
        let yMax = -Infinity;
        [
            new Point(this.x, this.y),
            new Point(this.x2, this.y),
            new Point(this.x, this.y2),
            new Point(this.x2, this.y2)
        ].forEach(function(p) {
            p = p.transform(m);
            xMin = Math.min(xMin, p.x);
            xMax = Math.max(xMax, p.x);
            yMin = Math.min(yMin, p.y);
            yMax = Math.max(yMax, p.y);
        });
        return new Box(xMin, yMin, xMax - xMin, yMax - yMin);
    }
};
function getBox(el, getBBoxFn, retry) {
    let box;
    try {
        box = getBBoxFn(el.node);
        if (isNulledBox(box) && !domContains(el.node)) throw new Error("Element not in the dom");
    } catch (e) {
        box = retry(el);
    }
    return box;
}
function bbox() {
    const getBBox = (node)=>node.getBBox();
    const retry = (el)=>{
        try {
            const clone = el.clone().addTo(parser().svg).show();
            const box = clone.node.getBBox();
            clone.remove();
            return box;
        } catch (e) {
            throw new Error(`Getting bbox of element "${el.node.nodeName}" is not possible: ${e.toString()}`);
        }
    };
    const box = getBox(this, getBBox, retry);
    return new Box(box);
}
function rbox(el) {
    const getRBox = (node)=>node.getBoundingClientRect();
    const retry = (el)=>{
        throw new Error(`Getting rbox of element "${el.node.nodeName}" is not possible`);
    };
    const box = getBox(this, getRBox, retry);
    const rbox = new Box(box);
    if (el) return rbox.transform(el.screenCTM().inverseO());
    return rbox.addOffset();
}
function inside(x, y) {
    const box = this.bbox();
    return x > box.x && y > box.y && x < box.x + box.width && y < box.y + box.height;
}
registerMethods({
    viewbox: {
        viewbox (x, y, width, height) {
            if (x == null) return new Box(this.attr("viewBox"));
            return this.attr("viewBox", new Box(x, y, width, height));
        },
        zoom (level, point) {
            let { width, height } = this.attr([
                "width",
                "height"
            ]);
            if (!width && !height || typeof width === "string" || typeof height === "string") {
                width = this.node.clientWidth;
                height = this.node.clientHeight;
            }
            if (!width || !height) throw new Error("Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element");
            const v = this.viewbox();
            const zoomX = width / v.width;
            const zoomY = height / v.height;
            const zoom = Math.min(zoomX, zoomY);
            if (level == null) return zoom;
            let zoomAmount = zoom / level;
            if (zoomAmount === Infinity) zoomAmount = Number.MAX_SAFE_INTEGER / 100;
            point = point || new Point(width / 2 / zoomX + v.x, height / 2 / zoomY + v.y);
            const box = new Box(v).transform(new Matrix({
                scale: zoomAmount,
                origin: point
            }));
            return this.viewbox(box);
        }
    }
});
register(Box, "Box");
//#endregion
//#region src/types/List.js
var List = class extends Array {
    constructor(arr = [], ...args){
        super(arr, ...args);
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...arr);
    }
};
extend([
    List
], {
    each (fnOrMethodName, ...args) {
        if (typeof fnOrMethodName === "function") return this.map((el, i, arr)=>{
            return fnOrMethodName.call(el, el, i, arr);
        });
        else return this.map((el)=>{
            return el[fnOrMethodName](...args);
        });
    },
    toArray () {
        return Array.prototype.concat.apply([], this);
    }
});
const reserved = [
    "toArray",
    "constructor",
    "each"
];
List.extend = function(methods) {
    methods = methods.reduce((obj, name)=>{
        if ((0, import_includes.default)(reserved).call(reserved, name)) return obj;
        if (name[0] === "_") return obj;
        if (name in Array.prototype) obj["$" + name] = Array.prototype[name];
        obj[name] = function(...attrs) {
            return this.each(name, ...attrs);
        };
        return obj;
    }, {});
    extend([
        List
    ], methods);
};
//#endregion
//#region src/modules/core/references.js
function getReferenceId(value) {
    let referenceValue = (value + "").trim();
    const url = referenceValue.match(/^url\((.*)\)$/i);
    if (url) {
        referenceValue = url[1].trim();
        const quote = referenceValue[0];
        if (quote === "\"" || quote === "'") {
            if (referenceValue[referenceValue.length - 1] !== quote) return null;
            referenceValue = referenceValue.slice(1, -1);
        }
    }
    const match = referenceValue.match(reference);
    return match ? match[1].slice(1) : null;
}
function findById(rootNode, id) {
    const selector = `#${globals.window.CSS.escape(id)}`;
    if (rootNode.nodeType === 1 && rootNode.matches(selector)) return rootNode;
    return rootNode.querySelector(selector);
}
function resolveReference(node, value) {
    const id = getReferenceId(value);
    return id ? findById(node.getRootNode(), id) : null;
}
function findReferences(node, attribute, selector = `[${attribute}]`) {
    const id = node.getAttribute("id");
    const rootNode = node.getRootNode();
    if (!id || findById(rootNode, id) !== node) return new List();
    const references = [];
    if (rootNode.nodeType === 1 && rootNode.matches(selector) && getReferenceId(rootNode.getAttribute(attribute)) === id) references.push(adopt(rootNode));
    for (const element of rootNode.querySelectorAll(selector))if (getReferenceId(element.getAttribute(attribute)) === id) references.push(adopt(element));
    return new List(references);
}
//#endregion
//#region src/modules/core/selector.js
function baseFind(query, parent) {
    return new List(map((parent || globals.document).querySelectorAll(query), function(node) {
        return adopt(node);
    }));
}
function find(query) {
    return baseFind(query, this.node);
}
function findOne(query) {
    return adopt(this.node.querySelector(query));
}
//#endregion
//#region src/modules/core/event.js
let listenerId = 0;
const eventStore = /* @__PURE__ */ new WeakMap();
const listenerIds = /* @__PURE__ */ new WeakMap();
const createEventMap = ()=>Object.create(null);
function getEvents(instance) {
    const holder = instance.getEventHolder();
    let bag = eventStore.get(holder);
    if (!bag) {
        bag = createEventMap();
        eventStore.set(holder, bag);
    }
    return bag;
}
function getEventTarget(instance) {
    return instance.getEventTarget();
}
function clearEvents(instance) {
    eventStore.delete(instance.getEventHolder());
}
function on(node, events, listener, binding, options) {
    const l = listener.bind(binding || node);
    const listenerOptions = options || false;
    const instance = makeInstance(node);
    const bag = getEvents(instance);
    const n = getEventTarget(instance);
    events = Array.isArray(events) ? events : events.split(delimiter);
    let id = listenerIds.get(listener);
    if (!id) {
        id = ++listenerId;
        listenerIds.set(listener, id);
    }
    events.forEach(function(event) {
        const ev = event.split(".")[0];
        const ns = event.split(".")[1] || "*";
        bag[ev] = bag[ev] || createEventMap();
        bag[ev][ns] = bag[ev][ns] || createEventMap();
        bag[ev][ns][id] = bag[ev][ns][id] || [];
        bag[ev][ns][id].push({
            listener: l,
            options: listenerOptions
        });
        n.addEventListener(ev, l, listenerOptions);
    });
}
function off(node, events, listener, options) {
    const instance = makeInstance(node);
    const bag = getEvents(instance);
    const n = getEventTarget(instance);
    if (typeof listener === "function") {
        listener = listenerIds.get(listener);
        if (!listener) return;
    }
    events = Array.isArray(events) ? events : (events || "").split(delimiter);
    events.forEach(function(event) {
        const ev = event && event.split(".")[0];
        const ns = event && event.split(".")[1];
        let namespace, l;
        if (listener) {
            if (bag[ev] && bag[ev][ns || "*"]) {
                const listeners = bag[ev][ns || "*"][listener];
                if (!listeners) return;
                listeners.forEach(function(registration) {
                    n.removeEventListener(ev, registration.listener, registration.options ?? options ?? false);
                });
                delete bag[ev][ns || "*"][listener];
            }
        } else if (ev && ns) {
            if (bag[ev] && bag[ev][ns]) {
                for(l in bag[ev][ns])off(n, [
                    ev,
                    ns
                ].join("."), l);
                delete bag[ev][ns];
            }
        } else if (ns) {
            for(event in bag)for(namespace in bag[event])if (ns === namespace) off(n, [
                event,
                ns
            ].join("."));
        } else if (ev) {
            if (bag[ev]) {
                for(namespace in bag[ev])off(n, [
                    ev,
                    namespace
                ].join("."));
                delete bag[ev];
            }
        } else {
            for(event in bag)off(n, event);
            clearEvents(instance);
        }
    });
}
function dispatch(node, event, data, options) {
    const n = getEventTarget(node);
    if (event instanceof globals.window.Event) n.dispatchEvent(event);
    else {
        event = new globals.window.CustomEvent(event, {
            detail: data,
            cancelable: true,
            ...options
        });
        n.dispatchEvent(event);
    }
    return event;
}
//#endregion
//#region src/types/EventTarget.js
var EventTarget = class extends Base {
    addEventListener() {}
    dispatch(event, data, options) {
        return dispatch(this, event, data, options);
    }
    dispatchEvent(event) {
        const events = getEvents(this)[event.type];
        if (!events) return true;
        for(const i in events)for(const j in events[i])events[i][j].forEach(function(registration) {
            registration.listener(event);
        });
        return !event.defaultPrevented;
    }
    fire(event, data, options) {
        this.dispatch(event, data, options);
        return this;
    }
    getEventHolder() {
        return this;
    }
    getEventTarget() {
        return this;
    }
    off(event, listener, options) {
        off(this, event, listener, options);
        return this;
    }
    on(event, listener, binding, options) {
        on(this, event, listener, binding, options);
        return this;
    }
    removeEventListener() {}
};
register(EventTarget, "EventTarget");
//#endregion
//#region src/modules/core/defaults.js
var defaults_exports = /* @__PURE__ */ __exportAll({
    attrs: ()=>attrs,
    noop: ()=>noop,
    timeline: ()=>timeline
});
function noop() {}
const timeline = {
    duration: 400,
    ease: ">",
    delay: 0
};
const attrs = {
    "fill-opacity": 1,
    "stroke-opacity": 1,
    "stroke-width": 0,
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    fill: "#000000",
    stroke: "#000000",
    opacity: 1,
    x: 0,
    y: 0,
    cx: 0,
    cy: 0,
    width: 0,
    height: 0,
    r: 0,
    rx: 0,
    ry: 0,
    offset: 0,
    "stop-opacity": 1,
    "stop-color": "#000000",
    "text-anchor": "start"
};
//#endregion
//#region src/types/SVGArray.js
var SVGArray = class extends Array {
    constructor(...args){
        super(...args);
        this.init(...args);
    }
    clone() {
        return new this.constructor(this);
    }
    init(arr) {
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...this.parse(arr));
        return this;
    }
    parse(array = []) {
        if (array instanceof Array) return array;
        return array.trim().split(delimiter).map(parseFloat);
    }
    toArray() {
        return Array.prototype.concat.apply([], this);
    }
    toSet() {
        return new Set(this);
    }
    toString() {
        return this.join(" ");
    }
    valueOf() {
        const ret = [];
        ret.push(...this);
        return ret;
    }
};
//#endregion
//#region src/types/SVGNumber.js
var SVGNumber = class SVGNumber {
    constructor(...args){
        this.init(...args);
    }
    convert(unit) {
        return new SVGNumber(this.value, unit);
    }
    divide(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this / number, this.unit || number.unit);
    }
    init(value, unit) {
        unit = Array.isArray(value) ? value[1] : unit;
        value = Array.isArray(value) ? value[0] : value;
        this.value = 0;
        this.unit = unit || "";
        if (typeof value === "number") this.value = isNaN(value) ? 0 : !isFinite(value) ? value < 0 ? -340000000000000000000000000000000000000 : 34e37 : value;
        else if (typeof value === "string") {
            unit = value.match(numberAndUnit);
            if (unit) {
                this.value = parseFloat(unit[1]);
                if (unit[5] === "%") this.value /= 100;
                else if (unit[5] === "s") this.value *= 1e3;
                this.unit = unit[5];
            }
        } else if (value instanceof SVGNumber) {
            this.value = value.valueOf();
            this.unit = value.unit;
        }
        return this;
    }
    minus(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this - number, this.unit || number.unit);
    }
    plus(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this + number, this.unit || number.unit);
    }
    times(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this * number, this.unit || number.unit);
    }
    toArray() {
        return [
            this.value,
            this.unit
        ];
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return (this.unit === "%" ? ~~(this.value * 1e8) / 1e6 : this.unit === "s" ? this.value / 1e3 : this.value) + this.unit;
    }
    valueOf() {
        return this.value;
    }
};
//#endregion
//#region src/modules/core/attr.js
const colorAttributes = /* @__PURE__ */ new Set([
    "fill",
    "stroke",
    "color",
    "bgcolor",
    "stop-color",
    "flood-color",
    "lighting-color"
]);
const hooks = [];
function registerAttrHook(fn) {
    hooks.push(fn);
}
function attr(attr, val, ns) {
    if (attr == null) {
        attr = {};
        val = this.node.attributes;
        for (const node of val)attr[node.nodeName] = isNumber.test(node.nodeValue) ? parseFloat(node.nodeValue) : node.nodeValue;
        return attr;
    } else if (attr instanceof Array) return attr.reduce((last, curr)=>{
        last[curr] = this.attr(curr);
        return last;
    }, {});
    else if (typeof attr === "object" && attr.constructor === Object) for(val in attr)this.attr(val, attr[val]);
    else if (val === null) this.node.removeAttribute(attr);
    else if (val == null) {
        val = this.node.getAttribute(attr);
        return val == null ? attrs[attr] : isNumber.test(val) ? parseFloat(val) : val;
    } else {
        val = hooks.reduce((_val, hook)=>{
            return hook(attr, _val, this);
        }, val);
        if (typeof val === "number") val = new SVGNumber(val);
        else if (colorAttributes.has(attr) && Color.isColor(val)) val = new Color(val);
        else if (val.constructor === Array) val = new SVGArray(val);
        if (attr === "leading") {
            if (this.leading) this.leading(val);
        } else typeof ns === "string" ? this.node.setAttributeNS(ns, attr, val.toString()) : this.node.setAttribute(attr, val.toString());
        if (this.rebuild && (attr === "font-size" || attr === "x")) this.rebuild();
    }
    return this;
}
//#endregion
//#region src/elements/Dom.js
var Dom = class Dom extends EventTarget {
    constructor(node, attrs){
        super();
        this.node = node;
        this.type = node.nodeName;
        if (attrs && node !== attrs) this.attr(attrs);
    }
    add(element, i) {
        element = makeInstance(element);
        if (element.removeNamespace && this.node instanceof globals.window.SVGElement) element.removeNamespace();
        if (i == null) this.node.appendChild(element.node);
        else if (element.node !== this.node.childNodes[i]) this.node.insertBefore(element.node, this.node.childNodes[i]);
        return this;
    }
    addTo(parent, i) {
        return makeInstance(parent).put(this, i);
    }
    children() {
        return new List(map(this.node.children, function(node) {
            return adopt(node);
        }));
    }
    clear() {
        while(this.node.hasChildNodes())this.node.removeChild(this.node.lastChild);
        return this;
    }
    clone(deep = true, assignNewIds = true) {
        this.writeDataToDom();
        let nodeClone = this.node.cloneNode(deep);
        if (assignNewIds) nodeClone = assignNewId(nodeClone);
        return new this.constructor(nodeClone);
    }
    each(block, deep) {
        const children = this.children();
        let i, il;
        for(i = 0, il = children.length; i < il; i++){
            block.apply(children[i], [
                i,
                children
            ]);
            if (deep) children[i].each(block, deep);
        }
        return this;
    }
    element(nodeName, attrs) {
        return this.put(new Dom(create(nodeName), attrs));
    }
    first() {
        return adopt(this.node.firstChild);
    }
    get(i) {
        return adopt(this.node.childNodes[i]);
    }
    getEventHolder() {
        return this.node;
    }
    getEventTarget() {
        return this.node;
    }
    has(element) {
        return this.index(element) >= 0;
    }
    html(htmlOrFn, outerHTML) {
        return this.xml(htmlOrFn, outerHTML, html);
    }
    id(id) {
        if (typeof id === "undefined" && !this.node.id) this.node.id = eid(this.type);
        return this.attr("id", id);
    }
    index(element) {
        return [].slice.call(this.node.childNodes).indexOf(element.node);
    }
    last() {
        return adopt(this.node.lastChild);
    }
    matches(selector) {
        const el = this.node;
        const matcher = el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector || null;
        return matcher && matcher.call(el, selector);
    }
    parent(type) {
        let parent = this;
        if (!parent.node.parentNode) return null;
        parent = adopt(parent.node.parentNode);
        if (!type) return parent;
        do if (typeof type === "string" ? parent.matches(type) : parent instanceof type) return parent;
        while (parent = adopt(parent.node.parentNode));
        return parent;
    }
    put(element, i) {
        element = makeInstance(element);
        this.add(element, i);
        return element;
    }
    putIn(parent, i) {
        return makeInstance(parent).add(this, i);
    }
    remove() {
        if (this.parent()) this.parent().removeElement(this);
        return this;
    }
    removeElement(element) {
        this.node.removeChild(element.node);
        return this;
    }
    replace(element) {
        element = makeInstance(element);
        if (this.node.parentNode) this.node.parentNode.replaceChild(element.node, this.node);
        return element;
    }
    round(precision = 2, map = null) {
        const factor = 10 ** precision;
        const attrs = this.attr(map);
        for(const i in attrs)if (typeof attrs[i] === "number") attrs[i] = Math.round(attrs[i] * factor) / factor;
        this.attr(attrs);
        return this;
    }
    svg(svgOrFn, outerSVG) {
        return this.xml(svgOrFn, outerSVG, svg);
    }
    toString() {
        return this.id();
    }
    words(text) {
        this.node.textContent = text;
        return this;
    }
    wrap(node) {
        const parent = this.parent();
        if (!parent) return this.addTo(node);
        const position = parent.index(this);
        return parent.put(node, position).put(this);
    }
    writeDataToDom() {
        this.each(function() {
            this.writeDataToDom();
        });
        return this;
    }
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        }
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            outerXML = outerXML == null ? true : outerXML;
            this.writeDataToDom();
            let current = this;
            if (xmlOrFn != null) {
                current = adopt(current.node.cloneNode(true));
                if (outerXML) {
                    const result = xmlOrFn(current);
                    current = result || current;
                    if (result === false) return "";
                }
                current.each(function() {
                    const result = xmlOrFn(this);
                    const _this = result || this;
                    if (result === false) this.remove();
                    else if (result && this !== _this) this.replace(_this);
                }, true);
            }
            return outerXML ? current.node.outerHTML : current.node.innerHTML;
        }
        outerXML = outerXML == null ? false : outerXML;
        const well = create("wrapper", ns);
        const fragment = globals.document.createDocumentFragment();
        well.innerHTML = xmlOrFn;
        for(let len = well.children.length; len--;)fragment.appendChild(well.firstElementChild);
        const parent = this.parent();
        return outerXML ? this.replace(fragment) && parent : this.add(fragment);
    }
};
extend(Dom, {
    attr: attr,
    find: find,
    findOne: findOne
});
register(Dom, "Dom");
//#endregion
//#region src/elements/Element.js
var Element = class extends Dom {
    constructor(node, attrs){
        super(node, attrs);
        this.dom = {};
        this.node.instance = this;
        if (node.hasAttribute("data-svgjs") || node.hasAttribute("svgjs:data")) this.setData(JSON.parse(node.getAttribute("data-svgjs")) ?? JSON.parse(node.getAttribute("svgjs:data")) ?? {});
    }
    center(x, y) {
        return this.cx(x).cy(y);
    }
    cx(x) {
        return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2);
    }
    cy(y) {
        return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2);
    }
    defs() {
        const root = this.root();
        return root && root.defs();
    }
    dmove(x, y) {
        return this.dx(x).dy(y);
    }
    dx(x = 0) {
        return this.x(new SVGNumber(x).plus(this.x()));
    }
    dy(y = 0) {
        return this.y(new SVGNumber(y).plus(this.y()));
    }
    getEventHolder() {
        return this;
    }
    height(height) {
        return this.attr("height", height);
    }
    move(x, y) {
        return this.x(x).y(y);
    }
    parents(until = this.root()) {
        const isSelector = typeof until === "string";
        const root = this.root();
        const rootNode = root && root.node;
        if (!isSelector) until = until && makeInstance(until).node;
        const parents = new List();
        let parent = this;
        while((parent = parent.parent()) && parent.node !== globals.document && parent.node.nodeName !== "#document-fragment"){
            parents.push(parent);
            if (!isSelector && parent.node === until) break;
            if (isSelector && parent.matches(until)) break;
            if (rootNode && parent.node === rootNode) return null;
        }
        return parents;
    }
    reference(attr) {
        attr = this.attr(attr);
        if (!attr) return null;
        const target = resolveReference(this.node, attr);
        return target ? makeInstance(target) : null;
    }
    root() {
        const p = this.parent(getClass(root));
        return p && p.root();
    }
    setData(o) {
        this.dom = o;
        return this;
    }
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.width(new SVGNumber(p.width)).height(new SVGNumber(p.height));
    }
    width(width) {
        return this.attr("width", width);
    }
    writeDataToDom(defaults) {
        writeDataToDom(this, this.dom, defaults);
        return super.writeDataToDom();
    }
    x(x) {
        return this.attr("x", x);
    }
    y(y) {
        return this.attr("y", y);
    }
};
extend(Element, {
    bbox: bbox,
    rbox: rbox,
    inside: inside,
    point: point,
    ctm: ctm,
    screenCTM: screenCTM
});
register(Element, "Element");
//#endregion
//#region src/modules/optional/sugar.js
const sugar = {
    stroke: [
        "color",
        "width",
        "opacity",
        "linecap",
        "linejoin",
        "miterlimit",
        "dasharray",
        "dashoffset"
    ],
    fill: [
        "color",
        "opacity",
        "rule"
    ],
    prefix: function(t, a) {
        return a === "color" ? t : t + "-" + a;
    }
};
[
    "fill",
    "stroke"
].forEach(function(m) {
    const extension = {};
    let i;
    extension[m] = function(o) {
        if (typeof o === "undefined") return this.attr(m);
        if (typeof o === "string" || o instanceof Color || Color.isRgb(o) || o instanceof Element) this.attr(m, o);
        else for(i = sugar[m].length - 1; i >= 0; i--)if (o[sugar[m][i]] != null) this.attr(sugar.prefix(m, sugar[m][i]), o[sugar[m][i]]);
        return this;
    };
    registerMethods([
        "Element",
        "Runner"
    ], extension);
});
registerMethods([
    "Element",
    "Runner"
], {
    matrix: function(mat, b, c, d, e, f) {
        if (mat == null) return new Matrix(this);
        return this.attr("transform", new Matrix(mat, b, c, d, e, f));
    },
    rotate: function(angle, cx, cy) {
        return this.transform({
            rotate: angle,
            ox: cx,
            oy: cy
        }, true);
    },
    skew: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            skew: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            skew: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    shear: function(lam, cx, cy) {
        return this.transform({
            shear: lam,
            ox: cx,
            oy: cy
        }, true);
    },
    scale: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            scale: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            scale: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    translate: function(x, y) {
        return this.transform({
            translate: [
                x,
                y
            ]
        }, true);
    },
    relative: function(x, y) {
        return this.transform({
            relative: [
                x,
                y
            ]
        }, true);
    },
    flip: function(direction = "both", origin = "center") {
        if ("xybothtrue".indexOf(direction) === -1) {
            origin = direction;
            direction = "both";
        }
        return this.transform({
            flip: direction,
            origin: origin
        }, true);
    },
    opacity: function(value) {
        return this.attr("opacity", value);
    }
});
registerMethods("radius", {
    radius: function(x, y = x) {
        return (this._element || this).type === "radialGradient" ? this.attr("r", new SVGNumber(x)) : this.rx(x).ry(y);
    }
});
registerMethods("Path", {
    length: function() {
        return this.node.getTotalLength();
    },
    pointAt: function(length) {
        return new Point(this.node.getPointAtLength(length));
    }
});
registerMethods([
    "Element",
    "Runner"
], {
    font: function(a, v) {
        if (typeof a === "object") {
            for(v in a)this.font(v, a[v]);
            return this;
        }
        return a === "leading" ? this.leading(v) : a === "anchor" ? this.attr("text-anchor", v) : a === "size" || a === "family" || a === "weight" || a === "stretch" || a === "variant" || a === "style" ? this.attr("font-" + a, v) : this.attr(a, v);
    }
});
registerMethods("Element", [
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mouseover",
    "mouseout",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "touchstart",
    "touchmove",
    "touchleave",
    "touchend",
    "touchcancel",
    "contextmenu",
    "wheel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel"
].reduce(function(last, event) {
    const fn = function(f) {
        if (f === null) this.off(event);
        else this.on(event, f);
        return this;
    };
    last[event] = fn;
    return last;
}, {}));
//#endregion
//#region src/modules/optional/transform.js
function untransform() {
    return this.attr("transform", null);
}
function matrixify() {
    return (this.attr("transform") || "").split(transforms).slice(0, -1).map(function(str) {
        const kv = str.trim().split("(");
        return [
            kv[0].trim(),
            kv[1].split(delimiter).map(function(str) {
                return parseFloat(str);
            })
        ];
    }).reverse().reduce(function(matrix, transform) {
        if (transform[0] === "matrix") return matrix.lmultiply(Matrix.fromArray(transform[1]));
        return matrix[transform[0]].apply(matrix, transform[1]);
    }, new Matrix());
}
function toParent(parent, i) {
    if (this === parent) return this;
    if (isDescriptive(this.node)) return this.addTo(parent, i);
    const ctm = this.screenCTM();
    const pCtm = parent.screenCTM().inverse();
    this.addTo(parent, i).untransform().transform(pCtm.multiply(ctm));
    return this;
}
function toRoot(i) {
    return this.toParent(this.root(), i);
}
function transform(o, relative) {
    if (o == null || typeof o === "string") {
        const decomposed = new Matrix(this).decompose();
        return o == null ? decomposed : decomposed[o];
    }
    if (!Matrix.isMatrixLike(o)) o = {
        ...o,
        origin: getOrigin(o, this)
    };
    const result = new Matrix(relative === true ? this : relative || false).transform(o);
    return this.attr("transform", result);
}
registerMethods("Element", {
    untransform: untransform,
    matrixify: matrixify,
    toParent: toParent,
    toRoot: toRoot,
    transform: transform
});
//#endregion
//#region src/elements/Container.js
var Container = class Container extends Element {
    flatten() {
        this.each(function() {
            if (this instanceof Container) return this.flatten().ungroup();
        });
        return this;
    }
    ungroup(parent = this.parent(), index = parent.index(this)) {
        index = index === -1 ? parent.children().length : index;
        this.each(function(i, children) {
            return children[children.length - i - 1].toParent(parent, index);
        });
        return this.remove();
    }
};
register(Container, "Container");
//#endregion
//#region src/elements/Defs.js
var Defs = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("defs", node), attrs);
    }
    flatten() {
        return this;
    }
    ungroup() {
        return this;
    }
};
register(Defs, "Defs");
//#endregion
//#region src/elements/Shape.js
var Shape = class extends Element {
};
register(Shape, "Shape");
//#endregion
//#region src/modules/core/circled.js
var circled_exports = /* @__PURE__ */ __exportAll({
    cx: ()=>cx$1,
    cy: ()=>cy$1,
    height: ()=>height$2,
    rx: ()=>rx,
    ry: ()=>ry,
    width: ()=>width$2,
    x: ()=>x$3,
    y: ()=>y$3
});
function rx(rx) {
    return this.attr("rx", rx);
}
function ry(ry) {
    return this.attr("ry", ry);
}
function x$3(x) {
    return x == null ? this.cx() - this.rx() : this.cx(x + this.rx());
}
function y$3(y) {
    return y == null ? this.cy() - this.ry() : this.cy(y + this.ry());
}
function cx$1(x) {
    return this.attr("cx", x);
}
function cy$1(y) {
    return this.attr("cy", y);
}
function width$2(width) {
    return width == null ? this.rx() * 2 : this.rx(new SVGNumber(width).divide(2));
}
function height$2(height) {
    return height == null ? this.ry() * 2 : this.ry(new SVGNumber(height).divide(2));
}
//#endregion
//#region src/elements/Ellipse.js
var Ellipse = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("ellipse", node), attrs);
    }
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.rx(new SVGNumber(p.width).divide(2)).ry(new SVGNumber(p.height).divide(2));
    }
};
extend(Ellipse, circled_exports);
registerMethods("Container", {
    ellipse: wrapWithAttrCheck(function(width = 0, height = width) {
        return this.put(new Ellipse()).size(width, height).move(0, 0);
    })
});
register(Ellipse, "Ellipse");
//#endregion
//#region src/elements/Fragment.js
var Fragment = class extends Dom {
    constructor(node = globals.document.createDocumentFragment()){
        super(node);
    }
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        }
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            const wrapper = new Dom(create("wrapper", ns));
            wrapper.add(this.node.cloneNode(true));
            return wrapper.xml(false, ns);
        }
        return super.xml(xmlOrFn, false, ns);
    }
};
register(Fragment, "Fragment");
//#endregion
//#region src/modules/core/gradiented.js
var gradiented_exports = /* @__PURE__ */ __exportAll({
    from: ()=>from,
    to: ()=>to
});
function from(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        fx: new SVGNumber(x),
        fy: new SVGNumber(y)
    }) : this.attr({
        x1: new SVGNumber(x),
        y1: new SVGNumber(y)
    });
}
function to(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        cx: new SVGNumber(x),
        cy: new SVGNumber(y)
    }) : this.attr({
        x2: new SVGNumber(x),
        y2: new SVGNumber(y)
    });
}
//#endregion
//#region src/elements/Gradient.js
var Gradient = class extends Container {
    constructor(type, attrs){
        super(nodeOrNew(type + "Gradient", typeof type === "string" ? null : type), attrs);
    }
    attr(a, b, c) {
        if (a === "transform") a = "gradientTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new Box();
    }
    targets() {
        return findReferences(this.node, "fill");
    }
    toString() {
        return this.url();
    }
    update(block) {
        this.clear();
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
};
extend(Gradient, gradiented_exports);
registerMethods({
    Container: {
        gradient (...args) {
            return this.defs().gradient(...args);
        }
    },
    Defs: {
        gradient: wrapWithAttrCheck(function(type, block) {
            return this.put(new Gradient(type)).update(block);
        })
    }
});
register(Gradient, "Gradient");
//#endregion
//#region src/elements/Pattern.js
var Pattern = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("pattern", node), attrs);
    }
    attr(a, b, c) {
        if (a === "transform") a = "patternTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new Box();
    }
    targets() {
        return findReferences(this.node, "fill");
    }
    toString() {
        return this.url();
    }
    update(block) {
        this.clear();
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
};
registerMethods({
    Container: {
        pattern (...args) {
            return this.defs().pattern(...args);
        }
    },
    Defs: {
        pattern: wrapWithAttrCheck(function(width, height, block) {
            return this.put(new Pattern()).update(block).attr({
                x: 0,
                y: 0,
                width: width,
                height: height,
                patternUnits: "userSpaceOnUse"
            });
        })
    }
});
register(Pattern, "Pattern");
//#endregion
//#region src/elements/Image.js
var Image = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("image", node), attrs);
    }
    load(url, callback) {
        if (!url) return this;
        const img = new globals.window.Image();
        on(img, "load", function(e) {
            const p = this.parent(Pattern);
            if (this.width() === 0 && this.height() === 0) this.size(img.width, img.height);
            if (p instanceof Pattern) {
                if (p.width() === 0 && p.height() === 0) p.size(this.width(), this.height());
            }
            if (typeof callback === "function") callback.call(this, e);
        }, this);
        on(img, "load error", function() {
            off(img);
        });
        return this.attr("href", img.src = url, xlink);
    }
};
registerAttrHook(function(attr, val, _this) {
    if (attr === "fill" || attr === "stroke") {
        if (isImage.test(val)) val = _this.root().defs().image(val);
    }
    if (val instanceof Image) val = _this.root().defs().pattern(0, 0, (pattern)=>{
        pattern.add(val);
    });
    return val;
});
registerMethods({
    Container: {
        image: wrapWithAttrCheck(function(source, callback) {
            return this.put(new Image()).size(0, 0).load(source, callback);
        })
    }
});
register(Image, "Image");
//#endregion
//#region src/types/PointArray.js
var PointArray = class extends SVGArray {
    bbox() {
        let maxX = -Infinity;
        let maxY = -Infinity;
        let minX = Infinity;
        let minY = Infinity;
        this.forEach(function(el) {
            maxX = Math.max(el[0], maxX);
            maxY = Math.max(el[1], maxY);
            minX = Math.min(el[0], minX);
            minY = Math.min(el[1], minY);
        });
        return new Box(minX, minY, maxX - minX, maxY - minY);
    }
    move(x, y) {
        const box = this.bbox();
        x -= box.x;
        y -= box.y;
        if (!isNaN(x) && !isNaN(y)) for(let i = this.length - 1; i >= 0; i--)this[i] = [
            this[i][0] + x,
            this[i][1] + y
        ];
        return this;
    }
    parse(array = [
        0,
        0
    ]) {
        const points = [];
        if (array instanceof Array) array = Array.prototype.concat.apply([], array);
        else array = array.trim().split(delimiter).map(parseFloat);
        if (array.length % 2 !== 0) array.pop();
        for(let i = 0, len = array.length; i < len; i = i + 2)points.push([
            array[i],
            array[i + 1]
        ]);
        return points;
    }
    size(width, height) {
        let i;
        const box = this.bbox();
        for(i = this.length - 1; i >= 0; i--){
            if (box.width) this[i][0] = (this[i][0] - box.x) * width / box.width + box.x;
            if (box.height) this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
        }
        return this;
    }
    toLine() {
        return {
            x1: this[0][0],
            y1: this[0][1],
            x2: this[1][0],
            y2: this[1][1]
        };
    }
    toString() {
        const array = [];
        for(let i = 0, il = this.length; i < il; i++)array.push(this[i].join(","));
        return array.join(" ");
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    transformO(m) {
        if (!Matrix.isMatrixLike(m)) m = new Matrix(m);
        for(let i = this.length; i--;){
            const [x, y] = this[i];
            this[i][0] = m.a * x + m.c * y + m.e;
            this[i][1] = m.b * x + m.d * y + m.f;
        }
        return this;
    }
};
//#endregion
//#region src/modules/core/pointed.js
var pointed_exports = /* @__PURE__ */ __exportAll({
    MorphArray: ()=>MorphArray,
    height: ()=>height$1,
    width: ()=>width$1,
    x: ()=>x$2,
    y: ()=>y$2
});
const MorphArray = PointArray;
function x$2(x) {
    return x == null ? this.bbox().x : this.move(x, this.bbox().y);
}
function y$2(y) {
    return y == null ? this.bbox().y : this.move(this.bbox().x, y);
}
function width$1(width) {
    const b = this.bbox();
    return width == null ? b.width : this.size(width, b.height);
}
function height$1(height) {
    const b = this.bbox();
    return height == null ? b.height : this.size(b.width, height);
}
//#endregion
//#region src/elements/Line.js
var Line = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("line", node), attrs);
    }
    array() {
        return new PointArray([
            [
                this.attr("x1"),
                this.attr("y1")
            ],
            [
                this.attr("x2"),
                this.attr("y2")
            ]
        ]);
    }
    move(x, y) {
        return this.attr(this.array().move(x, y).toLine());
    }
    plot(x1, y1, x2, y2) {
        if (x1 == null) return this.array();
        else if (typeof y1 !== "undefined") x1 = {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
        else x1 = new PointArray(x1).toLine();
        return this.attr(x1);
    }
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.attr(this.array().size(p.width, p.height).toLine());
    }
};
extend(Line, pointed_exports);
registerMethods({
    Container: {
        line: wrapWithAttrCheck(function(...args) {
            return Line.prototype.plot.apply(this.put(new Line()), args[0] != null ? args : [
                0,
                0,
                0,
                0
            ]);
        })
    }
});
register(Line, "Line");
//#endregion
//#region src/elements/Marker.js
var Marker = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("marker", node), attrs);
    }
    height(height) {
        return this.attr("markerHeight", height);
    }
    orient(orient) {
        return this.attr("orient", orient);
    }
    ref(x, y) {
        return this.attr("refX", x).attr("refY", y);
    }
    toString() {
        return "url(#" + this.id() + ")";
    }
    update(block) {
        this.clear();
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    width(width) {
        return this.attr("markerWidth", width);
    }
};
registerMethods({
    Container: {
        marker (...args) {
            return this.defs().marker(...args);
        }
    },
    Defs: {
        marker: wrapWithAttrCheck(function(width, height, block) {
            return this.put(new Marker()).size(width, height).ref(width / 2, height / 2).viewbox(0, 0, width, height).attr("orient", "auto").update(block);
        })
    },
    marker: {
        marker (marker, width, height, block) {
            let attr = [
                "marker"
            ];
            if (marker !== "all") attr.push(marker);
            attr = attr.join("-");
            marker = arguments[1] instanceof Marker ? arguments[1] : this.defs().marker(width, height, block);
            return this.attr(attr, marker);
        }
    }
});
register(Marker, "Marker");
//#endregion
//#region src/animation/Controller.js
/***
Base Class
==========
The base stepper class that will be
***/ function makeSetterGetter(k, f) {
    return function(v) {
        if (v == null) return this[k];
        this[k] = v;
        if (f) f.call(this);
        return this;
    };
}
const easing = {
    "-": function(pos) {
        return pos;
    },
    "<>": function(pos) {
        return -Math.cos(pos * Math.PI) / 2 + .5;
    },
    ">": function(pos) {
        return Math.sin(pos * Math.PI / 2);
    },
    "<": function(pos) {
        return -Math.cos(pos * Math.PI / 2) + 1;
    },
    bezier: function(x1, y1, x2, y2) {
        return function(t) {
            if (t < 0) {
                if (x1 > 0) return y1 / x1 * t;
                else if (x2 > 0) return y2 / x2 * t;
                else return 0;
            } else if (t > 1) {
                if (x2 < 1) return (1 - y2) / (1 - x2) * t + (y2 - x2) / (1 - x2);
                else if (x1 < 1) return (1 - y1) / (1 - x1) * t + (y1 - x1) / (1 - x1);
                else return 1;
            } else return 3 * t * (1 - t) ** 2 * y1 + 3 * t ** 2 * (1 - t) * y2 + t ** 3;
        };
    },
    steps: function(steps, stepPosition = "end") {
        stepPosition = stepPosition.split("-").reverse()[0];
        let jumps = steps;
        if (stepPosition === "none") --jumps;
        else if (stepPosition === "both") ++jumps;
        return (t, beforeFlag = false)=>{
            let step = Math.floor(t * steps);
            const jumping = t * step % 1 === 0;
            if (stepPosition === "start" || stepPosition === "both") ++step;
            if (beforeFlag && jumping) --step;
            if (t >= 0 && step < 0) step = 0;
            if (t <= 1 && step > jumps) step = jumps;
            return step / jumps;
        };
    }
};
var Stepper = class {
    done() {
        return false;
    }
};
/***
Easing Functions
================
***/ var Ease = class extends Stepper {
    constructor(fn = timeline.ease){
        super();
        this.ease = easing[fn] || fn;
    }
    step(from, to, pos) {
        if (typeof from !== "number") return pos < 1 ? from : to;
        return from + (to - from) * this.ease(pos);
    }
};
/***
Controller Types
================
***/ var Controller = class extends Stepper {
    constructor(fn){
        super();
        this.stepper = fn;
    }
    done(c) {
        return c.done;
    }
    step(current, target, dt, c) {
        return this.stepper(current, target, dt, c);
    }
};
function recalculate() {
    const duration = (this._duration || 500) / 1e3;
    const overshoot = this._overshoot || 0;
    const eps = 1e-10;
    const pi = Math.PI;
    const os = Math.log(overshoot / 100 + eps);
    const zeta = -os / Math.sqrt(pi * pi + os * os);
    const wn = 3.9 / (zeta * duration);
    this.d = 2 * zeta * wn;
    this.k = wn * wn;
}
var Spring = class extends Controller {
    constructor(duration = 500, overshoot = 0){
        super();
        this.duration(duration).overshoot(overshoot);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        if (dt > 100) dt = 16;
        dt /= 1e3;
        const velocity = c.velocity || 0;
        const acceleration = -this.d * velocity - this.k * (current - target);
        const newPosition = current + velocity * dt + acceleration * dt * dt / 2;
        c.velocity = velocity + acceleration * dt;
        c.done = Math.abs(target - newPosition) + Math.abs(velocity) < .002;
        return c.done ? target : newPosition;
    }
};
extend(Spring, {
    duration: makeSetterGetter("_duration", recalculate),
    overshoot: makeSetterGetter("_overshoot", recalculate)
});
var PID = class extends Controller {
    constructor(p = .1, i = .01, d = 0, windup = 1e3){
        super();
        this.p(p).i(i).d(d).windup(windup);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        const p = target - current;
        let i = (c.integral || 0) + p * dt;
        const d = (p - (c.error || 0)) / dt;
        const windup = this._windup;
        if (windup !== false) i = Math.max(-windup, Math.min(i, windup));
        c.error = p;
        c.integral = i;
        c.done = Math.abs(p) < .001;
        return c.done ? target : current + (this.P * p + this.I * i + this.D * d);
    }
};
extend(PID, {
    windup: makeSetterGetter("_windup"),
    p: makeSetterGetter("P"),
    i: makeSetterGetter("I"),
    d: makeSetterGetter("D")
});
//#endregion
//#region src/utils/pathParser.js
const segmentParameters = {
    M: 2,
    L: 2,
    H: 1,
    V: 1,
    C: 6,
    S: 4,
    Q: 4,
    T: 2,
    A: 7,
    Z: 0
};
const pathHandlers = {
    M: function(c, p, p0) {
        p.x = p0.x = c[0];
        p.y = p0.y = c[1];
        return [
            "M",
            p.x,
            p.y
        ];
    },
    L: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "L",
            c[0],
            c[1]
        ];
    },
    H: function(c, p) {
        p.x = c[0];
        return [
            "H",
            c[0]
        ];
    },
    V: function(c, p) {
        p.y = c[0];
        return [
            "V",
            c[0]
        ];
    },
    C: function(c, p) {
        p.x = c[4];
        p.y = c[5];
        return [
            "C",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5]
        ];
    },
    S: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "S",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    Q: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "Q",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    T: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "T",
            c[0],
            c[1]
        ];
    },
    Z: function(c, p, p0) {
        p.x = p0.x;
        p.y = p0.y;
        return [
            "Z"
        ];
    },
    A: function(c, p) {
        p.x = c[5];
        p.y = c[6];
        return [
            "A",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5],
            c[6]
        ];
    }
};
const mlhvqtcsaz = "mlhvqtcsaz".split("");
for(let i = 0, il = mlhvqtcsaz.length; i < il; ++i)pathHandlers[mlhvqtcsaz[i]] = function(i) {
    return function(c, p, p0) {
        if (i === "H") c[0] = c[0] + p.x;
        else if (i === "V") c[0] = c[0] + p.y;
        else if (i === "A") {
            c[5] = c[5] + p.x;
            c[6] = c[6] + p.y;
        } else for(let j = 0, jl = c.length; j < jl; ++j)c[j] = c[j] + (j % 2 ? p.y : p.x);
        return pathHandlers[i](c, p, p0);
    };
}(mlhvqtcsaz[i].toUpperCase());
function makeAbsolut(parser) {
    return pathHandlers[parser.segment[0]](parser.segment.slice(1), parser.p, parser.p0);
}
function segmentComplete(parser) {
    return parser.segment.length && parser.segment.length - 1 === segmentParameters[parser.segment[0].toUpperCase()];
}
function startNewSegment(parser, token) {
    parser.inNumber && finalizeNumber(parser, false);
    const pathLetter = isPathLetter.test(token);
    if (pathLetter) parser.segment = [
        token
    ];
    else {
        const lastCommand = parser.lastCommand;
        const small = lastCommand.toLowerCase();
        parser.segment = [
            small === "m" ? lastCommand === small ? "l" : "L" : lastCommand
        ];
    }
    parser.inSegment = true;
    parser.lastCommand = parser.segment[0];
    return pathLetter;
}
function finalizeNumber(parser, inNumber) {
    if (!parser.inNumber) throw new Error("Parser Error");
    parser.number && parser.segment.push(parseFloat(parser.number));
    parser.inNumber = inNumber;
    parser.number = "";
    parser.pointSeen = false;
    parser.hasExponent = false;
    if (segmentComplete(parser)) finalizeSegment(parser);
}
function finalizeSegment(parser) {
    parser.inSegment = false;
    if (parser.absolute) parser.segment = makeAbsolut(parser);
    parser.segments.push(parser.segment);
}
function isArcFlag(parser) {
    if (!parser.segment.length) return false;
    const isArc = parser.segment[0].toUpperCase() === "A";
    const length = parser.segment.length;
    return isArc && (length === 4 || length === 5);
}
function isExponential(parser) {
    return parser.lastToken.toUpperCase() === "E";
}
const pathDelimiters = /* @__PURE__ */ new Set([
    " ",
    ",",
    "	",
    "\n",
    "\r",
    "\f"
]);
function pathParser(d, toAbsolute = true) {
    let index = 0;
    let token = "";
    const parser = {
        segment: [],
        inNumber: false,
        number: "",
        lastToken: "",
        inSegment: false,
        segments: [],
        pointSeen: false,
        hasExponent: false,
        absolute: toAbsolute,
        p0: new Point(),
        p: new Point()
    };
    while(parser.lastToken = token, token = d.charAt(index++)){
        if (!parser.inSegment) {
            if (startNewSegment(parser, token)) continue;
        }
        if (token === ".") {
            if (parser.pointSeen || parser.hasExponent) {
                finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.inNumber = true;
            parser.pointSeen = true;
            parser.number += token;
            continue;
        }
        if (!isNaN(parseInt(token))) {
            if (parser.number === "0" || isArcFlag(parser)) {
                parser.inNumber = true;
                parser.number = token;
                finalizeNumber(parser, true);
                continue;
            }
            parser.inNumber = true;
            parser.number += token;
            continue;
        }
        if (pathDelimiters.has(token)) {
            if (parser.inNumber) finalizeNumber(parser, false);
            continue;
        }
        if (token === "-" || token === "+") {
            if (parser.inNumber && !isExponential(parser)) {
                finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.number += token;
            parser.inNumber = true;
            continue;
        }
        if (token.toUpperCase() === "E") {
            parser.number += token;
            parser.hasExponent = true;
            continue;
        }
        if (isPathLetter.test(token)) {
            if (parser.inNumber) finalizeNumber(parser, false);
            else if (!segmentComplete(parser)) throw new Error("parser Error");
            else finalizeSegment(parser);
            --index;
        }
    }
    if (parser.inNumber) finalizeNumber(parser, false);
    if (parser.inSegment && segmentComplete(parser)) finalizeSegment(parser);
    return parser.segments;
}
//#endregion
//#region src/types/PathArray.js
function arrayToString(a) {
    let s = "";
    for(let i = 0, il = a.length; i < il; i++){
        s += a[i][0];
        if (a[i][1] != null) {
            s += a[i][1];
            if (a[i][2] != null) {
                s += " ";
                s += a[i][2];
                if (a[i][3] != null) {
                    s += " ";
                    s += a[i][3];
                    s += " ";
                    s += a[i][4];
                    if (a[i][5] != null) {
                        s += " ";
                        s += a[i][5];
                        s += " ";
                        s += a[i][6];
                        if (a[i][7] != null) {
                            s += " ";
                            s += a[i][7];
                        }
                    }
                }
            }
        }
    }
    return s + " ";
}
var PathArray = class extends SVGArray {
    bbox() {
        parser().path.setAttribute("d", this.toString());
        return new Box(parser.nodes.path.getBBox());
    }
    move(x, y) {
        const box = this.bbox();
        x -= box.x;
        y -= box.y;
        if (!isNaN(x) && !isNaN(y)) for(let l, i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] += x;
                this[i][2] += y;
            } else if (l === "H") this[i][1] += x;
            else if (l === "V") this[i][1] += y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] += x;
                this[i][2] += y;
                this[i][3] += x;
                this[i][4] += y;
                if (l === "C") {
                    this[i][5] += x;
                    this[i][6] += y;
                }
            } else if (l === "A") {
                this[i][6] += x;
                this[i][7] += y;
            }
        }
        return this;
    }
    parse(d = "M0 0") {
        if (Array.isArray(d)) d = Array.prototype.concat.apply([], d).toString();
        return pathParser(d);
    }
    size(width, height) {
        const box = this.bbox();
        let i, l;
        box.width = box.width === 0 ? 1 : box.width;
        box.height = box.height === 0 ? 1 : box.height;
        for(i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
            } else if (l === "H") this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
            else if (l === "V") this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
                this[i][3] = (this[i][3] - box.x) * width / box.width + box.x;
                this[i][4] = (this[i][4] - box.y) * height / box.height + box.y;
                if (l === "C") {
                    this[i][5] = (this[i][5] - box.x) * width / box.width + box.x;
                    this[i][6] = (this[i][6] - box.y) * height / box.height + box.y;
                }
            } else if (l === "A") {
                this[i][1] = this[i][1] * width / box.width;
                this[i][2] = this[i][2] * height / box.height;
                this[i][6] = (this[i][6] - box.x) * width / box.width + box.x;
                this[i][7] = (this[i][7] - box.y) * height / box.height + box.y;
            }
        }
        return this;
    }
    toString() {
        return arrayToString(this);
    }
};
//#endregion
//#region src/animation/Morphable.js
const getClassForType = (value)=>{
    const type = typeof value;
    if (type === "number") return SVGNumber;
    else if (type === "string") {
        if (Color.isColor(value)) return Color;
        else if (delimiter.test(value)) return isPathLetter.test(value) ? PathArray : SVGArray;
        else if (numberAndUnit.test(value)) return SVGNumber;
        else return NonMorphable;
    } else if (morphableTypes.indexOf(value.constructor) > -1) return value.constructor;
    else if (Array.isArray(value)) return SVGArray;
    else if (type === "object") return ObjectBag;
    else return NonMorphable;
};
var Morphable = class {
    constructor(stepper){
        this._stepper = stepper || new Ease("-");
        this._from = null;
        this._to = null;
        this._type = null;
        this._context = null;
        this._morphObj = null;
    }
    at(pos) {
        return this._morphObj.morph(this._from, this._to, pos, this._stepper, this._context);
    }
    done() {
        return this._context.map(this._stepper.done).reduce(function(last, curr) {
            return last && curr;
        }, true);
    }
    from(val) {
        if (val == null) return this._from;
        this._from = this._set(val);
        return this;
    }
    stepper(stepper) {
        if (stepper == null) return this._stepper;
        this._stepper = stepper;
        return this;
    }
    to(val) {
        if (val == null) return this._to;
        this._to = this._set(val);
        return this;
    }
    type(type) {
        if (type == null) return this._type;
        this._type = type;
        return this;
    }
    _set(value) {
        if (!this._type) this.type(getClassForType(value));
        let result = new this._type(value);
        if (this._type === Color) result = this._to ? result[this._to[4]]() : this._from ? result[this._from[4]]() : result;
        if (this._type === ObjectBag) result = this._to ? result.align(this._to) : this._from ? result.align(this._from) : result;
        result = result.toConsumable();
        this._morphObj = this._morphObj || new this._type();
        this._context = this._context || Array.apply(null, Array(result.length)).map(Object).map(function(o) {
            o.done = true;
            return o;
        });
        return result;
    }
};
var NonMorphable = class {
    constructor(...args){
        this.init(...args);
    }
    init(val) {
        val = Array.isArray(val) ? val[0] : val;
        this.value = val;
        return this;
    }
    toArray() {
        return [
            this.value
        ];
    }
    valueOf() {
        return this.value;
    }
};
var TransformBag = class TransformBag {
    constructor(...args){
        this.init(...args);
    }
    init(obj) {
        if (Array.isArray(obj)) obj = {
            scaleX: obj[0],
            scaleY: obj[1],
            shear: obj[2],
            rotate: obj[3],
            translateX: obj[4],
            translateY: obj[5],
            originX: obj[6],
            originY: obj[7]
        };
        Object.assign(this, TransformBag.defaults, obj);
        return this;
    }
    toArray() {
        const v = this;
        return [
            v.scaleX,
            v.scaleY,
            v.shear,
            v.rotate,
            v.translateX,
            v.translateY,
            v.originX,
            v.originY
        ];
    }
};
TransformBag.defaults = {
    scaleX: 1,
    scaleY: 1,
    shear: 0,
    rotate: 0,
    translateX: 0,
    translateY: 0,
    originX: 0,
    originY: 0
};
const sortByKey = (a, b)=>{
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
};
var ObjectBag = class {
    constructor(...args){
        this.init(...args);
    }
    align(other) {
        const values = this.values;
        for(let i = 0, il = values.length; i < il; ++i){
            if (values[i + 1] === other[i + 1]) {
                if (values[i + 1] === Color && other[i + 7] !== values[i + 7]) {
                    const space = other[i + 7];
                    const color = new Color(this.values.splice(i + 3, 5))[space]().toArray();
                    this.values.splice(i + 3, 0, ...color);
                }
                i += values[i + 2] + 2;
                continue;
            }
            if (!other[i + 1]) return this;
            const defaultObject = new other[i + 1]().toArray();
            const toDelete = values[i + 2] + 3;
            values.splice(i, toDelete, other[i], other[i + 1], other[i + 2], ...defaultObject);
            i += values[i + 2] + 2;
        }
        return this;
    }
    init(objOrArr) {
        this.values = [];
        if (Array.isArray(objOrArr)) {
            this.values = objOrArr.slice();
            return;
        }
        objOrArr = objOrArr || {};
        const entries = [];
        for(const i in objOrArr){
            const Type = getClassForType(objOrArr[i]);
            const val = new Type(objOrArr[i]).toArray();
            entries.push([
                i,
                Type,
                val.length,
                ...val
            ]);
        }
        entries.sort(sortByKey);
        this.values = entries.reduce((last, curr)=>last.concat(curr), []);
        return this;
    }
    toArray() {
        return this.values;
    }
    valueOf() {
        const obj = {};
        const arr = this.values;
        while(arr.length){
            const key = arr.shift();
            const Type = arr.shift();
            const num = arr.shift();
            obj[key] = new Type(arr.splice(0, num));
        }
        return obj;
    }
};
const morphableTypes = [
    NonMorphable,
    TransformBag,
    ObjectBag
];
function registerMorphableType(type = []) {
    morphableTypes.push(...[].concat(type));
}
function makeMorphable() {
    extend(morphableTypes, {
        to (val) {
            return new Morphable().type(this.constructor).from(this.toArray()).to(val);
        },
        fromArray (arr) {
            this.init(arr);
            return this;
        },
        toConsumable () {
            return this.toArray();
        },
        morph (from, to, pos, stepper, context) {
            const mapper = function(i, index) {
                return stepper.step(i, to[index], pos, context[index], context);
            };
            return this.fromArray(from.map(mapper));
        }
    });
}
//#endregion
//#region src/elements/Path.js
var Path = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("path", node), attrs);
    }
    array() {
        return this._array || (this._array = new PathArray(this.attr("d")));
    }
    clear() {
        delete this._array;
        return this;
    }
    height(height) {
        return height == null ? this.bbox().height : this.size(this.bbox().width, height);
    }
    move(x, y) {
        return this.attr("d", this.array().move(x, y));
    }
    plot(d) {
        return d == null ? this.array() : this.clear().attr("d", typeof d === "string" ? d : this._array = new PathArray(d));
    }
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.attr("d", this.array().size(p.width, p.height));
    }
    width(width) {
        return width == null ? this.bbox().width : this.size(width, this.bbox().height);
    }
    x(x) {
        return x == null ? this.bbox().x : this.move(x, this.bbox().y);
    }
    y(y) {
        return y == null ? this.bbox().y : this.move(this.bbox().x, y);
    }
};
Path.prototype.MorphArray = PathArray;
registerMethods({
    Container: {
        path: wrapWithAttrCheck(function(d) {
            return this.put(new Path()).plot(d || new PathArray());
        })
    }
});
register(Path, "Path");
//#endregion
//#region src/modules/core/poly.js
var poly_exports = /* @__PURE__ */ __exportAll({
    array: ()=>array,
    clear: ()=>clear,
    move: ()=>move$2,
    plot: ()=>plot,
    size: ()=>size$1
});
function array() {
    return this._array || (this._array = new PointArray(this.attr("points")));
}
function clear() {
    delete this._array;
    return this;
}
function move$2(x, y) {
    return this.attr("points", this.array().move(x, y));
}
function plot(p) {
    return p == null ? this.array() : this.clear().attr("points", typeof p === "string" ? p : this._array = new PointArray(p));
}
function size$1(width, height) {
    const p = proportionalSize(this, width, height);
    return this.attr("points", this.array().size(p.width, p.height));
}
//#endregion
//#region src/elements/Polygon.js
var Polygon = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("polygon", node), attrs);
    }
};
registerMethods({
    Container: {
        polygon: wrapWithAttrCheck(function(p) {
            return this.put(new Polygon()).plot(p || new PointArray());
        })
    }
});
extend(Polygon, pointed_exports);
extend(Polygon, poly_exports);
register(Polygon, "Polygon");
//#endregion
//#region src/elements/Polyline.js
var Polyline = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("polyline", node), attrs);
    }
};
registerMethods({
    Container: {
        polyline: wrapWithAttrCheck(function(p) {
            return this.put(new Polyline()).plot(p || new PointArray());
        })
    }
});
extend(Polyline, pointed_exports);
extend(Polyline, poly_exports);
register(Polyline, "Polyline");
//#endregion
//#region src/elements/Rect.js
var Rect = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("rect", node), attrs);
    }
};
extend(Rect, {
    rx: rx,
    ry: ry
});
registerMethods({
    Container: {
        rect: wrapWithAttrCheck(function(width, height) {
            return this.put(new Rect()).size(width, height);
        })
    }
});
register(Rect, "Rect");
//#endregion
//#region src/animation/Queue.js
var Queue = class {
    constructor(){
        this._first = null;
        this._last = null;
    }
    first() {
        return this._first && this._first.value;
    }
    last() {
        return this._last && this._last.value;
    }
    push(value) {
        const item = typeof value.next !== "undefined" ? value : {
            value: value,
            next: null,
            prev: null
        };
        if (this._last) {
            item.prev = this._last;
            this._last.next = item;
            this._last = item;
        } else {
            this._last = item;
            this._first = item;
        }
        return item;
    }
    remove(item) {
        if (item.prev) item.prev.next = item.next;
        if (item.next) item.next.prev = item.prev;
        if (item === this._last) this._last = item.prev;
        if (item === this._first) this._first = item.next;
        item.prev = null;
        item.next = null;
    }
    shift() {
        const remove = this._first;
        if (!remove) return null;
        this._first = remove.next;
        if (this._first) this._first.prev = null;
        this._last = this._first ? this._last : null;
        return remove.value;
    }
};
//#endregion
//#region src/animation/Animator.js
const Animator = {
    nextDraw: null,
    frames: new Queue(),
    timeouts: new Queue(),
    immediates: new Queue(),
    timer: ()=>globals.window.performance || globals.window.Date,
    frame (fn) {
        const node = Animator.frames.push({
            run: fn
        });
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        return node;
    },
    timeout (fn, delay) {
        delay = delay || 0;
        const time = Animator.timer().now() + delay;
        const node = Animator.timeouts.push({
            run: fn,
            time: time
        });
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        return node;
    },
    immediate (fn) {
        const node = Animator.immediates.push(fn);
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        return node;
    },
    cancelFrame (node) {
        node != null && Animator.frames.remove(node);
    },
    clearTimeout (node) {
        node != null && Animator.timeouts.remove(node);
    },
    cancelImmediate (node) {
        node != null && Animator.immediates.remove(node);
    },
    _draw (now) {
        try {
            let nextTimeout = null;
            const lastTimeout = Animator.timeouts.last();
            while(nextTimeout = Animator.timeouts.shift()){
                if (now >= nextTimeout.time) nextTimeout.run();
                else Animator.timeouts.push(nextTimeout);
                if (nextTimeout === lastTimeout) break;
            }
            let nextFrame = null;
            const lastFrame = Animator.frames.last();
            while(nextFrame !== lastFrame && (nextFrame = Animator.frames.shift()))nextFrame.run(now);
            let nextImmediate = null;
            while(nextImmediate = Animator.immediates.shift())nextImmediate();
        } finally{
            const pending = Animator.timeouts.first() || Animator.frames.first() || Animator.immediates.first();
            Animator.nextDraw = pending ? globals.window.requestAnimationFrame(Animator._draw) : null;
        }
    }
};
//#endregion
//#region src/animation/Timeline.js
const makeSchedule = function(runnerInfo) {
    const start = runnerInfo.start;
    const duration = runnerInfo.runner.duration();
    return {
        start: start,
        duration: duration,
        end: start + duration,
        runner: runnerInfo.runner
    };
};
const defaultSource = function() {
    const w = globals.window;
    return (w.performance || w.Date).now();
};
var Timeline = class extends EventTarget {
    constructor(timeSource = defaultSource){
        super();
        this._timeSource = timeSource;
        this.terminate();
    }
    active() {
        return !!this._nextFrame;
    }
    finish() {
        this._finishing = true;
        try {
            this.time(this.getEndTimeOfTimeline() + 1);
        } finally{
            this._finishing = false;
        }
        return this.pause();
    }
    getEndTime() {
        const lastRunnerInfo = this.getLastRunnerInfo();
        const lastDuration = lastRunnerInfo ? lastRunnerInfo.runner.duration() : 0;
        return (lastRunnerInfo ? lastRunnerInfo.start : this._time) + lastDuration;
    }
    getEndTimeOfTimeline() {
        const endTimes = this._runners.map((i)=>i.start + i.runner.duration());
        return Math.max(0, ...endTimes);
    }
    getLastRunnerInfo() {
        return this.getRunnerInfoById(this._lastRunnerId);
    }
    getRunnerInfoById(id) {
        return this._runners[this._runnerIds.indexOf(id)] || null;
    }
    pause() {
        this._paused = true;
        return this._continue();
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    play() {
        this._paused = false;
        return this.updateTime()._continue();
    }
    reverse(yes) {
        const currentSpeed = this.speed();
        if (yes == null) return this.speed(-currentSpeed);
        const positive = Math.abs(currentSpeed);
        return this.speed(yes ? -positive : positive);
    }
    schedule(runner, delay, when) {
        if (runner == null) return this._runners.map(makeSchedule);
        let absoluteStartTime = 0;
        const endTime = this.getEndTime();
        delay = delay || 0;
        if (when == null || when === "last" || when === "after") absoluteStartTime = endTime;
        else if (when === "absolute" || when === "start") {
            absoluteStartTime = delay;
            delay = 0;
        } else if (when === "now") absoluteStartTime = this._time;
        else if (when === "relative") {
            const runnerInfo = this.getRunnerInfoById(runner.id);
            if (runnerInfo) {
                absoluteStartTime = runnerInfo.start + delay;
                delay = 0;
            }
        } else if (when === "with-last") {
            const lastRunnerInfo = this.getLastRunnerInfo();
            absoluteStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
        } else throw new Error("Invalid value for the \"when\" parameter");
        runner.unschedule();
        runner.timeline(this);
        runner._retired = false;
        const persist = runner.persist();
        const runnerInfo = {
            persist: persist === null ? this._persist : persist,
            start: absoluteStartTime + delay,
            runner: runner
        };
        this._lastRunnerId = runner.id;
        runner._runnerInfo = runnerInfo;
        this._runners.push(runnerInfo);
        this._runners.sort((a, b)=>a.start - b.start);
        this._runnerIds = this._runners.map((info)=>info.runner.id);
        this.updateTime()._continue();
        return this;
    }
    seek(dt) {
        return this.time(this._time + dt);
    }
    source(fn) {
        if (fn == null) return this._timeSource;
        this._timeSource = fn;
        return this;
    }
    speed(speed) {
        if (speed == null) return this._speed;
        this._speed = speed;
        return this;
    }
    stop() {
        this.time(0);
        return this.pause();
    }
    time(time) {
        if (time == null) return this._time;
        this._time = time;
        return this._continue(true);
    }
    unschedule(runner) {
        const index = this._runnerIds.indexOf(runner.id);
        if (index < 0) return this;
        this._runners.splice(index, 1);
        this._runnerIds.splice(index, 1);
        runner.timeline(null);
        runner._runnerInfo = null;
        runner._retired = true;
        return this;
    }
    updateTime() {
        if (!this.active()) this._lastSourceTime = this._timeSource();
        return this;
    }
    _continue(immediateStep = false) {
        Animator.cancelFrame(this._nextFrame);
        this._nextFrame = null;
        if (immediateStep) return this._stepImmediate();
        if (this._paused) return this;
        this._nextFrame = Animator.frame(this._step);
        return this;
    }
    _stepFn(immediateStep = false) {
        const generation = this._generation;
        const time = this._timeSource();
        let dtSource = time - this._lastSourceTime;
        if (immediateStep) dtSource = 0;
        const dtTime = this._speed * dtSource + (this._time - this._lastStepTime);
        this._lastSourceTime = time;
        if (!immediateStep) {
            this._time += dtTime;
            this._time = this._time < 0 ? 0 : this._time;
        }
        this._lastStepTime = this._time;
        this.fire("time", this._time);
        const scheduled = this._runners.slice();
        for(let k = scheduled.length; k--;){
            const runnerInfo = scheduled[k];
            if (runnerInfo.runner._runnerInfo !== runnerInfo) continue;
            const runner = runnerInfo.runner;
            if (this._time - runnerInfo.start < 0) runner.reset(true);
        }
        let runnersLeft = false;
        for (const runnerInfo of this._runners.slice()){
            if (runnerInfo.runner._runnerInfo !== runnerInfo) continue;
            const runner = runnerInfo.runner;
            let dt = dtTime;
            const dtToStart = this._time - runnerInfo.start;
            if (dtToStart < 0) {
                runnersLeft = true;
                continue;
            } else if (dtToStart === 0) {
                runner.reset();
                runnersLeft = true;
                continue;
            } else if (dtToStart < dt) dt = dtToStart;
            if (!runner.active()) continue;
            const finished = (this._finishing && runner._isDeclarative ? runner.finish() : runner.step(dt)).done;
            if (runner._runnerInfo !== runnerInfo) continue;
            if (!finished) runnersLeft = true;
            else if (runnerInfo.persist !== true) {
                if (runner.duration() - runner.time() + this._time + runnerInfo.persist <= this._time) runner.unschedule();
            }
        }
        if (generation !== this._generation) return this;
        if (!runnersLeft) runnersLeft = this._runners.some(({ start, runner })=>start >= this._time || runner.active() && !runner.done);
        if (runnersLeft && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0) this._continue();
        else {
            this.pause();
            this.fire("finished");
        }
        return this;
    }
    terminate() {
        Animator.cancelFrame(this._nextFrame);
        this._generation = (this._generation || 0) + 1;
        this._startTime = 0;
        this._speed = 1;
        this._persist = 0;
        for (const { runner } of this._runners || []){
            runner._retired = true;
            runner._runnerInfo = null;
        }
        this._nextFrame = null;
        this._paused = true;
        this._finishing = false;
        this._runners = [];
        this._runnerIds = [];
        this._lastRunnerId = -1;
        this._time = 0;
        this._lastSourceTime = 0;
        this._lastStepTime = 0;
        this._step = this._stepFn.bind(this, false);
        this._stepImmediate = this._stepFn.bind(this, true);
    }
};
registerMethods({
    Element: {
        timeline: function(timeline) {
            if (timeline == null) {
                this._timeline = this._timeline || new Timeline();
                return this._timeline;
            } else {
                this._timeline = timeline;
                return this;
            }
        }
    }
});
//#endregion
//#region src/animation/Runner.js
var Runner = class Runner extends EventTarget {
    constructor(options){
        super();
        this.id = Runner.id++;
        options = options == null ? timeline.duration : options;
        options = typeof options === "function" ? new Controller(options) : options;
        this._element = null;
        this._timeline = null;
        this._runnerInfo = null;
        this.done = false;
        this._queue = [];
        this._duration = typeof options === "number" && options;
        this._isDeclarative = options instanceof Controller;
        this._stepper = this._isDeclarative ? options : new Ease();
        this._history = {};
        this.enabled = true;
        this._time = 0;
        this._lastTime = 0;
        this._reseted = true;
        this.transforms = new Matrix();
        this._isAbsoluteTransform = false;
        this._hasTransform = false;
        this._transformInitialised = false;
        this._transformActive = false;
        this._retired = false;
        this._reverse = false;
        this._swing = false;
        this._wait = 0;
        this._times = 1;
        this._persist = this._isDeclarative ? true : null;
    }
    static sanitise(duration, delay, when) {
        let times = 1;
        let swing = false;
        let wait = 0;
        duration = duration ?? timeline.duration;
        delay = delay ?? timeline.delay;
        when = when || "last";
        if (typeof duration === "object" && !(duration instanceof Stepper)) {
            delay = duration.delay ?? delay;
            when = duration.when ?? when;
            swing = duration.swing || swing;
            times = duration.times ?? times;
            wait = duration.wait ?? wait;
            duration = duration.duration ?? timeline.duration;
        }
        return {
            duration: duration,
            delay: delay,
            swing: swing,
            times: times,
            wait: wait,
            when: when
        };
    }
    active(enabled) {
        if (enabled == null) return this.enabled;
        this.enabled = enabled;
        return this;
    }
    addTransform(transform) {
        this.transforms.lmultiplyO(transform);
        this._transformInitialised = true;
        this._transformActive = true;
        return this;
    }
    after(fn) {
        return this.on("finished", fn);
    }
    animate(duration, delay, when) {
        const o = Runner.sanitise(duration, delay, when);
        const runner = new Runner(o.duration);
        if (this._timeline) runner.timeline(this._timeline);
        if (this._element) runner.element(this._element);
        return runner.loop(o).schedule(o.delay, o.when);
    }
    clearTransform() {
        this.transforms = new Matrix();
        return this;
    }
    delay(delay) {
        return this.animate(0, delay);
    }
    duration() {
        return this._times * (this._wait + this._duration) - this._wait;
    }
    during(fn) {
        return this.queue(null, fn);
    }
    ease(fn) {
        this._stepper = new Ease(fn);
        return this;
    }
    element(element) {
        if (element == null) return this._element;
        this._element = element;
        element._prepareRunner();
        return this;
    }
    finish() {
        if (!this._isDeclarative) return this.time(this.duration());
        const time = this._time;
        this.step(Infinity);
        this._time = time;
        return this;
    }
    loop(times, swing, wait) {
        if (typeof times === "object") {
            swing = times.swing;
            wait = times.wait;
            times = times.times;
        }
        this._times = times || Infinity;
        this._swing = swing || false;
        this._wait = wait || 0;
        if (this._times === true) this._times = Infinity;
        return this;
    }
    loops(p) {
        const loopDuration = this._duration + this._wait;
        if (p == null) {
            const loopsDone = Math.floor(this._time / loopDuration);
            const position = (this._time - loopsDone * loopDuration) / this._duration;
            return Math.min(loopsDone + position, this._times);
        }
        const whole = Math.floor(p);
        const partial = p % 1;
        const time = loopDuration * whole + this._duration * partial;
        return this.time(time);
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    position(p) {
        const x = this._time;
        const d = this._duration;
        const w = this._wait;
        const t = this._times;
        const s = this._swing;
        const r = this._reverse;
        let position;
        if (p == null) {
            const f = function(x) {
                const swinging = s * Math.floor(x % (2 * (w + d)) / (w + d));
                const backwards = swinging && !r || !swinging && r;
                const uncliped = Math.pow(-1, backwards) * (x % (w + d)) / d + backwards;
                return Math.max(Math.min(uncliped, 1), 0);
            };
            const endTime = t * (w + d) - w;
            position = x <= 0 ? Math.round(f(1e-5)) : x < endTime ? f(x) : Math.round(f(endTime - 1e-5));
            return position;
        }
        const loopsDone = Math.floor(this.loops());
        const swingForward = s && loopsDone % 2 === 0;
        position = loopsDone + (swingForward && !r || r && swingForward ? p : 1 - p);
        return this.loops(position);
    }
    progress(p) {
        if (p == null) return Math.min(1, this._time / this.duration());
        return this.time(p * this.duration());
    }
    queue(initFn, runFn, retargetFn, isTransform) {
        if (this._isDeclarative) this.done = false;
        this._queue.push({
            initialiser: initFn || noop,
            runner: runFn || noop,
            retarget: retargetFn,
            isTransform: isTransform,
            initialised: false,
            finished: false
        });
        this.timeline() && this.timeline()._continue();
        return this;
    }
    reset(deactivateTransform = false) {
        if (this._reseted) {
            const transformActive = !deactivateTransform && this._hasTransform && this.position() !== 0;
            if (transformActive && !this._transformInitialised) {
                this.step(0);
                this._reseted = true;
                return this;
            }
            if (transformActive !== this._transformActive) {
                this._transformActive = transformActive;
                this._element && this._element._addRunner(this);
            }
            return this;
        }
        if (!this._reseted) {
            this.time(0);
            this._reseted = true;
        }
        if (deactivateTransform && this._transformActive) {
            this._transformActive = false;
            this._element && this._element._addRunner(this);
        }
        return this;
    }
    reverse(reverse) {
        this._reverse = reverse == null ? !this._reverse : reverse;
        return this;
    }
    schedule(timeline, delay, when) {
        if (!(timeline instanceof Timeline)) {
            when = delay;
            delay = timeline;
            timeline = this.timeline();
        }
        if (!timeline) throw Error("Runner cannot be scheduled without timeline");
        timeline.schedule(this, delay, when);
        return this;
    }
    step(dt) {
        if (!this.enabled) return this;
        const wasDone = this.done;
        dt = dt == null ? 16 : dt;
        this._time += dt;
        const position = this.position();
        const running = this._lastPosition !== position && this._time >= 0;
        this._lastPosition = position;
        const duration = this.duration();
        const justStarted = this._lastTime <= 0 && this._time > 0;
        this._lastTime = this._time;
        if (justStarted) this.fire("start", this);
        const declarative = this._isDeclarative;
        this.done = !declarative && this._time >= duration;
        this._reseted = false;
        const transformActive = this._hasTransform && (this._time > 0 || position !== 0);
        this._transformActive = transformActive;
        let converged = false;
        if (running || declarative) {
            this._initialise(running);
            this.transforms = new Matrix();
            converged = this._run(declarative ? dt : position);
            this._transformActive = transformActive;
            this.fire("step", this);
        }
        this.done = this.done || converged && declarative;
        if (this.done && !wasDone) this.fire("finished", this);
        return this;
    }
    time(time) {
        if (time == null) return this._time;
        const dt = time - this._time;
        this.step(dt);
        return this;
    }
    timeline(timeline) {
        if (typeof timeline === "undefined") return this._timeline;
        this._timeline = timeline;
        return this;
    }
    unschedule() {
        const timeline = this.timeline();
        timeline && timeline.unschedule(this);
        return this;
    }
    _initialise(running) {
        if (!running && !this._isDeclarative) return;
        for(let i = 0, len = this._queue.length; i < len; ++i){
            const current = this._queue[i];
            const needsIt = this._isDeclarative || !current.initialised && running;
            running = !current.finished;
            if (needsIt && running) {
                current.initialiser.call(this);
                current.initialised = true;
            }
        }
    }
    _rememberMorpher(method, morpher) {
        this._history[method] = {
            morpher: morpher,
            caller: this._queue[this._queue.length - 1]
        };
        if (this._isDeclarative) {
            const timeline = this.timeline();
            timeline && timeline.play();
        }
    }
    _run(positionOrDt) {
        let allfinished = true;
        for(let i = 0, len = this._queue.length; i < len; ++i){
            const current = this._queue[i];
            if (this._isDeclarative && current.finished && !current.isTransform) continue;
            const converged = current.runner.call(this, positionOrDt);
            current.finished = current.finished || converged === true;
            allfinished = allfinished && current.finished;
        }
        return allfinished;
    }
    _tryRetarget(method, target, extra) {
        if (this._history[method]) {
            if (!this._history[method].caller.initialised) {
                const index = this._queue.indexOf(this._history[method].caller);
                this._queue.splice(index, 1);
                return false;
            }
            if (this._history[method].caller.retarget) this._history[method].caller.retarget.call(this, target, extra);
            else this._history[method].morpher.to(target);
            this._history[method].caller.finished = false;
            if (this._isDeclarative) this.done = false;
            const timeline = this.timeline();
            timeline && timeline.play();
            return true;
        }
        return false;
    }
};
Runner.id = 0;
var FakeRunner = class {
    constructor(transforms = new Matrix(), id = -1, done = true, isAbsoluteTransform = false){
        this.transforms = transforms;
        this.id = id;
        this.done = done;
        this._isAbsoluteTransform = isAbsoluteTransform;
        this._transformActive = true;
        this._retired = true;
    }
};
extend([
    Runner,
    FakeRunner
], {
    mergeWith (runner) {
        return new FakeRunner(this._isAbsoluteTransform ? this.transforms : runner.transforms.lmultiply(this.transforms), runner.id, true, runner._isAbsoluteTransform || this._isAbsoluteTransform);
    }
});
const lmultiply = (last, curr)=>last.lmultiplyO(curr);
const getRunnerTransform = (runner)=>runner.transforms;
const isActiveTransform = (runner)=>runner._transformActive;
function activeTransformRunners(runners) {
    const activeRunners = runners.filter(isActiveTransform);
    let firstRunner = 0;
    for(let i = 0; i < activeRunners.length; ++i)if (activeRunners[i]._isAbsoluteTransform) firstRunner = i;
    return activeRunners.slice(firstRunner);
}
function mergeTransforms() {
    const netTransform = activeTransformRunners(this._transformationRunners.runners).map(getRunnerTransform).reduce(lmultiply, new Matrix());
    this.transform(netTransform);
    this._transformationRunners.merge();
    if (this._transformationRunners.length() === 1) this._frameId = null;
}
var RunnerArray = class {
    constructor(){
        this.runners = [];
    }
    add(runner) {
        var _context;
        if ((0, import_includes.default)(_context = this.runners).call(_context, runner)) return;
        this.runners.push(runner);
        return this;
    }
    edit(id, newRunner) {
        const index = this.runners.findIndex((runner)=>runner.id === id);
        if (index >= 0) this.runners.splice(index, 1, newRunner);
        return this;
    }
    getByID(id) {
        return this.runners.find((runner)=>runner.id === id);
    }
    length() {
        return this.runners.length;
    }
    merge() {
        let lastRunner = null;
        for(let i = 0; i < this.runners.length; ++i){
            const runner = this.runners[i];
            if (lastRunner && runner.done && lastRunner.done && runner._retired && lastRunner._retired) {
                this.remove(runner.id);
                const newRunner = runner.mergeWith(lastRunner);
                this.edit(lastRunner.id, newRunner);
                lastRunner = newRunner;
                --i;
            } else lastRunner = runner;
        }
        return this;
    }
    remove(id) {
        const index = this.runners.findIndex((runner)=>runner.id === id);
        if (index >= 0) this.runners.splice(index, 1);
        return this;
    }
};
registerMethods({
    Element: {
        animate (duration, delay, when) {
            const o = Runner.sanitise(duration, delay, when);
            const timeline = this.timeline();
            return new Runner(o.duration).loop(o).element(this).timeline(timeline.play()).schedule(o.delay, o.when);
        },
        delay (by, when) {
            return this.animate(0, by, when);
        },
        _currentTransform (current) {
            const runners = this._transformationRunners.runners;
            const currentIndex = runners.indexOf(current);
            return activeTransformRunners(runners.slice(0, currentIndex + 1)).map(getRunnerTransform).reduce(lmultiply, new Matrix());
        },
        _addRunner (runner) {
            if (this._transformationRunners.length() === 1 && this._transformationRunners.runners[0].id === -1) this._transformationRunners.runners[0].transforms = new Matrix(this);
            this._transformationRunners.add(runner);
            Animator.cancelImmediate(this._frameId);
            this._frameId = Animator.immediate(mergeTransforms.bind(this));
        },
        _prepareRunner () {
            if (this._frameId == null) this._transformationRunners = new RunnerArray().add(new FakeRunner(new Matrix(this)));
        }
    }
});
const difference = (a, b)=>a.filter((x)=>!(0, import_includes.default)(b).call(b, x));
extend(Runner, {
    attr (a, v) {
        return this.styleAttr("attr", a, v);
    },
    css (s, v) {
        return this.styleAttr("css", s, v);
    },
    styleAttr (type, nameOrAttrs, val) {
        if (typeof nameOrAttrs === "string") return this.styleAttr(type, {
            [nameOrAttrs]: val
        });
        const attrs = nameOrAttrs;
        const history = this._history[type];
        if (history && !history.caller.initialised && history.caller.retarget) {
            history.caller.retarget.call(this, attrs);
            return this;
        }
        if (this._tryRetarget(type, attrs)) return this;
        let morpher = new Morphable(this._stepper).to(attrs);
        let keys = Object.keys(attrs);
        this.queue(function() {
            morpher = morpher.from(this.element()[type](keys));
        }, function(pos) {
            this.element()[type](morpher.at(pos).valueOf());
            return morpher.done();
        }, function(newToAttrs) {
            const differences = difference(Object.keys(newToAttrs), keys);
            if (differences.length && morpher.from() != null) {
                const addedFromAttrs = this.element()[type](differences);
                const oldFromAttrs = new ObjectBag(morpher.from()).valueOf();
                Object.assign(oldFromAttrs, addedFromAttrs);
                morpher.from(oldFromAttrs);
            }
            const mergedToAttrs = new ObjectBag(morpher.to()).valueOf();
            Object.assign(mergedToAttrs, newToAttrs);
            morpher.to(mergedToAttrs);
            keys = Object.keys(mergedToAttrs);
        });
        this._rememberMorpher(type, morpher);
        return this;
    },
    zoom (level, point) {
        if (this._tryRetarget("zoom", level, point)) return this;
        let morpher = new Morphable(this._stepper).to(new SVGNumber(level));
        this.queue(function() {
            morpher = morpher.from(this.element().zoom());
        }, function(pos) {
            this.element().zoom(morpher.at(pos), point);
            return morpher.done();
        }, function(newLevel, newPoint) {
            point = newPoint;
            morpher.to(newLevel);
        });
        this._rememberMorpher("zoom", morpher);
        return this;
    },
    /**
	** absolute transformations
	**/ transform (transforms, relative, affine) {
        relative = transforms.relative || relative;
        this._hasTransform = true;
        this._isAbsoluteTransform = this._isAbsoluteTransform || !relative;
        if (this._isDeclarative && !relative && this._tryRetarget("transform", transforms)) return this;
        const isMatrix = Matrix.isMatrixLike(transforms);
        affine = transforms.affine != null ? transforms.affine : affine != null ? affine : !isMatrix;
        const morpher = new Morphable(this._stepper).type(affine ? TransformBag : Matrix);
        const matrixMorpher = affine ? new Morphable(this._stepper).type(Matrix) : morpher;
        let origin;
        let element;
        let current;
        let currentAngle;
        let startTransform;
        function setup() {
            element = element || this.element();
            origin = origin || getOrigin(transforms, element);
            startTransform = new Matrix(relative ? void 0 : element);
            element._addRunner(this);
        }
        function run(pos) {
            if (!relative) this.clearTransform();
            const { x, y } = new Point(origin).transform(element._currentTransform(this));
            const targetTransforms = {
                ...transforms,
                origin: [
                    x,
                    y
                ]
            };
            if (targetTransforms.relative === true) delete targetTransforms.relative;
            let target = new Matrix(targetTransforms);
            let start = this._isDeclarative && current ? current : startTransform;
            let activeMorpher = morpher;
            if (affine) {
                const targetParameters = target.decompose(x, y);
                const startParameters = start.decompose(x, y);
                if (!new TransformBag(targetParameters).toArray().concat(new TransformBag(startParameters).toArray()).every(Number.isFinite)) activeMorpher = matrixMorpher;
                else {
                    target = targetParameters;
                    start = startParameters;
                    const rTarget = target.rotate;
                    const rCurrent = start.rotate;
                    const possibilities = [
                        rTarget - 360,
                        rTarget,
                        rTarget + 360
                    ];
                    const distances = possibilities.map((a)=>Math.abs(a - rCurrent));
                    const shortest = Math.min(...distances);
                    const index = distances.indexOf(shortest);
                    target.rotate = possibilities[index];
                }
            }
            if (relative && activeMorpher === morpher) {
                if (!isMatrix) target.rotate = transforms.rotate || 0;
                if (this._isDeclarative && currentAngle) start.rotate = currentAngle;
            }
            activeMorpher.from(start);
            activeMorpher.to(target);
            const affineParameters = activeMorpher.at(pos);
            currentAngle = affineParameters.rotate;
            current = new Matrix(affineParameters);
            this.addTransform(current);
            element._addRunner(this);
            return activeMorpher.done();
        }
        function retarget(newTransforms) {
            origin = getOrigin(newTransforms, element);
            transforms = {
                ...newTransforms
            };
        }
        this.queue(setup, run, retarget, true);
        this._isDeclarative && this._rememberMorpher("transform", morpher);
        return this;
    },
    x (x) {
        return this._queueNumber("x", x);
    },
    y (y) {
        return this._queueNumber("y", y);
    },
    ax (x) {
        return this._queueNumber("ax", x);
    },
    ay (y) {
        return this._queueNumber("ay", y);
    },
    dx (x = 0) {
        return this._queueNumberDelta("x", x);
    },
    dy (y = 0) {
        return this._queueNumberDelta("y", y);
    },
    dmove (x, y) {
        return this.dx(x).dy(y);
    },
    _queueNumberDelta (method, to) {
        to = new SVGNumber(to);
        if (this._tryRetarget(method, to)) return this;
        const morpher = new Morphable(this._stepper).to(to);
        let from = null;
        this.queue(function() {
            from = this.element()[method]();
            morpher.from(from);
            morpher.to(from + to);
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        }, function(newTo) {
            morpher.to(from + new SVGNumber(newTo));
        });
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueObject (method, to) {
        if (this._tryRetarget(method, to)) return this;
        const morpher = new Morphable(this._stepper).to(to);
        this.queue(function() {
            morpher.from(this.element()[method]());
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        });
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueNumber (method, value) {
        return this._queueObject(method, new SVGNumber(value));
    },
    cx (x) {
        return this._queueNumber("cx", x);
    },
    cy (y) {
        return this._queueNumber("cy", y);
    },
    move (x, y) {
        return this.x(x).y(y);
    },
    amove (x, y) {
        return this.ax(x).ay(y);
    },
    center (x, y) {
        return this.cx(x).cy(y);
    },
    size (width, height) {
        const size = proportionalSize(this._element, width, height);
        return this.width(size.width).height(size.height);
    },
    width (width) {
        return this._queueNumber("width", width);
    },
    height (height) {
        return this._queueNumber("height", height);
    },
    plot (a, b, c, d) {
        if (arguments.length === 4) return this.plot([
            a,
            b,
            c,
            d
        ]);
        if (this._tryRetarget("plot", a)) return this;
        const morpher = new Morphable(this._stepper).type(this._element.MorphArray).to(a);
        this.queue(function() {
            morpher.from(this._element.array());
        }, function(pos) {
            this._element.plot(morpher.at(pos));
            return morpher.done();
        });
        this._rememberMorpher("plot", morpher);
        return this;
    },
    leading (value) {
        return this._queueNumber("leading", value);
    },
    viewbox (x, y, width, height) {
        return this._queueObject("viewbox", new Box(x, y, width, height));
    },
    update (o) {
        if (typeof o !== "object") return this.update({
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        });
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", o.offset);
        return this;
    }
});
extend(Runner, {
    rx: rx,
    ry: ry,
    from: from,
    to: to
});
register(Runner, "Runner");
//#endregion
//#region src/elements/Svg.js
var Svg = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("svg", node), attrs);
        this.namespace();
    }
    defs() {
        if (!this.isRoot()) return this.root().defs();
        return adopt(this.node.querySelector("defs")) || this.put(new Defs());
    }
    isRoot() {
        return !this.node.parentNode || !(this.node.parentNode instanceof globals.window.SVGElement) && this.node.parentNode.nodeName !== "#document-fragment";
    }
    namespace() {
        if (!this.isRoot()) return this.root().namespace();
        return this.attr({
            xmlns: svg,
            version: "1.1"
        }).attr("xmlns:xlink", xlink, xmlns);
    }
    removeNamespace() {
        return this.attr({
            xmlns: null,
            version: null
        }).attr("xmlns:xlink", null, xmlns).attr("xmlns:svgjs", null, xmlns);
    }
    root() {
        if (this.isRoot()) return this;
        return super.root();
    }
};
registerMethods({
    Container: {
        nested: wrapWithAttrCheck(function() {
            return this.put(new Svg());
        })
    }
});
register(Svg, "Svg", true);
//#endregion
//#region src/elements/Symbol.js
var Symbol$1 = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("symbol", node), attrs);
    }
};
registerMethods({
    Container: {
        symbol: wrapWithAttrCheck(function() {
            return this.put(new Symbol$1());
        })
    }
});
register(Symbol$1, "Symbol");
//#endregion
//#region src/modules/core/textable.js
var textable_exports = /* @__PURE__ */ __exportAll({
    amove: ()=>amove,
    ax: ()=>ax,
    ay: ()=>ay,
    build: ()=>build,
    center: ()=>center,
    cx: ()=>cx,
    cy: ()=>cy,
    length: ()=>length,
    move: ()=>move$1,
    plain: ()=>plain,
    x: ()=>x$1,
    y: ()=>y$1
});
function plain(text) {
    if (this._build === false) this.clear();
    this.node.appendChild(globals.document.createTextNode(text));
    return this;
}
function length() {
    return this.node.getComputedTextLength();
}
function x$1(x, box = this.bbox()) {
    if (x == null) return box.x;
    return this.attr("x", this.attr("x") + x - box.x);
}
function y$1(y, box = this.bbox()) {
    if (y == null) return box.y;
    return this.attr("y", this.attr("y") + y - box.y);
}
function move$1(x, y, box = this.bbox()) {
    return this.x(x, box).y(y, box);
}
function cx(x, box = this.bbox()) {
    if (x == null) return box.cx;
    return this.attr("x", this.attr("x") + x - box.cx);
}
function cy(y, box = this.bbox()) {
    if (y == null) return box.cy;
    return this.attr("y", this.attr("y") + y - box.cy);
}
function center(x, y, box = this.bbox()) {
    return this.cx(x, box).cy(y, box);
}
function ax(x) {
    return this.attr("x", x);
}
function ay(y) {
    return this.attr("y", y);
}
function amove(x, y) {
    return this.ax(x).ay(y);
}
function build(build) {
    this._build = !!build;
    return this;
}
//#endregion
//#region src/elements/Text.js
var Text = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("text", node), attrs);
        this.dom.leading = this.dom.leading ?? new SVGNumber(1.3);
        this._rebuild = true;
        this._build = false;
    }
    leading(value) {
        if (value == null) return this.dom.leading;
        this.dom.leading = new SVGNumber(value);
        return this.rebuild();
    }
    rebuild(rebuild) {
        if (typeof rebuild === "boolean") this._rebuild = rebuild;
        if (this._rebuild) {
            const self1 = this;
            let blankLineOffset = 0;
            const leading = this.dom.leading;
            this.each(function(i) {
                if (isDescriptive(this.node)) return;
                const fontSize = globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
                const dy = leading * new SVGNumber(fontSize);
                if (this.dom.newLined) {
                    this.attr("x", self1.attr("x"));
                    if (this.text() === "\n") blankLineOffset += dy;
                    else {
                        this.attr("dy", i ? dy + blankLineOffset : 0);
                        blankLineOffset = 0;
                    }
                }
            });
            this.fire("rebuild");
        }
        return this;
    }
    setData(o) {
        this.dom = o;
        this.dom.leading = new SVGNumber(o.leading || 1.3);
        return this;
    }
    writeDataToDom() {
        return super.writeDataToDom({
            leading: 1.3
        });
    }
    text(text) {
        if (text === void 0) {
            const children = this.node.childNodes;
            let firstLine = 0;
            text = "";
            for(let i = 0, len = children.length; i < len; ++i){
                if (children[i].nodeName === "textPath" || isDescriptive(children[i])) {
                    if (i === 0) firstLine = i + 1;
                    continue;
                }
                if (i !== firstLine && children[i].nodeType !== 3 && adopt(children[i]).dom.newLined === true) text += "\n";
                text += children[i].textContent;
            }
            return text;
        }
        this.clear().build(true);
        if (typeof text === "function") text.call(this, this);
        else {
            text = (text + "").split("\n");
            for(let j = 0, jl = text.length; j < jl; j++)this.newLine(text[j]);
        }
        return this.build(false).rebuild();
    }
};
extend(Text, textable_exports);
registerMethods({
    Container: {
        text: wrapWithAttrCheck(function(text = "") {
            return this.put(new Text()).text(text);
        }),
        plain: wrapWithAttrCheck(function(text = "") {
            return this.put(new Text()).plain(text);
        })
    }
});
register(Text, "Text");
//#endregion
//#region src/elements/Tspan.js
var Tspan = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("tspan", node), attrs);
        this._build = false;
    }
    dx(dx) {
        return this.attr("dx", dx);
    }
    dy(dy) {
        return this.attr("dy", dy);
    }
    newLine() {
        this.dom.newLined = true;
        const text = this.parent();
        if (!(text instanceof Text)) return this;
        const i = text.index(this);
        const fontSize = globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
        const dy = text.dom.leading * new SVGNumber(fontSize);
        return this.dy(i ? dy : 0).attr("x", text.x());
    }
    text(text) {
        if (text == null) return this.node.textContent + (this.dom.newLined ? "\n" : "");
        if (typeof text === "function") {
            this.clear().build(true);
            text.call(this, this);
            this.build(false);
        } else this.plain(text);
        return this;
    }
};
extend(Tspan, textable_exports);
registerMethods({
    Tspan: {
        tspan: wrapWithAttrCheck(function(text = "") {
            const tspan = new Tspan();
            if (!this._build) this.clear();
            return this.put(tspan).text(text);
        })
    },
    Text: {
        newLine: function(text = "") {
            return this.tspan(text).newLine();
        }
    }
});
register(Tspan, "Tspan");
//#endregion
//#region src/elements/Circle.js
var Circle = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("circle", node), attrs);
    }
    radius(r) {
        return this.attr("r", r);
    }
    rx(rx) {
        return this.attr("r", rx);
    }
    ry(ry) {
        return this.rx(ry);
    }
    size(size) {
        return this.radius(new SVGNumber(size).divide(2));
    }
};
extend(Circle, {
    x: x$3,
    y: y$3,
    cx: cx$1,
    cy: cy$1,
    width: width$2,
    height: height$2
});
registerMethods({
    Container: {
        circle: wrapWithAttrCheck(function(size = 0) {
            return this.put(new Circle()).size(size).move(0, 0);
        })
    }
});
register(Circle, "Circle");
//#endregion
//#region src/elements/ClipPath.js
var ClipPath = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("clipPath", node), attrs);
    }
    remove() {
        this.targets().forEach(function(el) {
            el.unclip();
        });
        return super.remove();
    }
    targets() {
        return findReferences(this.node, "clip-path");
    }
};
registerMethods({
    Container: {
        clip: wrapWithAttrCheck(function() {
            return this.defs().put(new ClipPath());
        })
    },
    Element: {
        clipper () {
            return this.reference("clip-path");
        },
        clipWith (element) {
            const clipper = element instanceof ClipPath ? element : this.parent().clip().add(element);
            return this.attr("clip-path", "url(#" + clipper.id() + ")");
        },
        unclip () {
            return this.attr("clip-path", null);
        }
    }
});
register(ClipPath, "ClipPath");
//#endregion
//#region src/elements/ForeignObject.js
var ForeignObject = class extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("foreignObject", node), attrs);
    }
};
registerMethods({
    Container: {
        foreignObject: wrapWithAttrCheck(function(width, height) {
            return this.put(new ForeignObject()).size(width, height);
        })
    }
});
register(ForeignObject, "ForeignObject");
//#endregion
//#region src/modules/core/containerGeometry.js
var containerGeometry_exports = /* @__PURE__ */ __exportAll({
    dmove: ()=>dmove,
    dx: ()=>dx,
    dy: ()=>dy,
    height: ()=>height,
    move: ()=>move,
    size: ()=>size,
    width: ()=>width,
    x: ()=>x,
    y: ()=>y
});
function dmove(dx, dy) {
    this.children().forEach((child)=>{
        let bbox;
        try {
            bbox = child.node instanceof getWindow().SVGSVGElement ? new Box(child.attr([
                "x",
                "y",
                "width",
                "height"
            ])) : child.bbox();
        } catch (e) {
            return;
        }
        const m = new Matrix(child);
        const matrix = m.translate(dx, dy).transform(m.inverse());
        const p = new Point(bbox.x, bbox.y).transform(matrix);
        child.dmove(p.x - bbox.x, p.y - bbox.y);
    });
    return this;
}
function dx(dx) {
    return this.dmove(dx, 0);
}
function dy(dy) {
    return this.dmove(0, dy);
}
function height(height1, box = this.bbox()) {
    if (height1 == null) return box.height;
    return this.size(box.width, height1, box);
}
function move(x = 0, y = 0, box = this.bbox()) {
    const dx = x - box.x;
    const dy = y - box.y;
    return this.dmove(dx, dy);
}
function size(width, height, box = this.bbox()) {
    const p = proportionalSize(this, width, height, box);
    const scaleX = p.width / box.width;
    const scaleY = p.height / box.height;
    this.children().forEach((child)=>{
        const o = new Point(box).transform(new Matrix(child).inverse());
        child.scale(scaleX, scaleY, o.x, o.y);
    });
    return this;
}
function width(width1, box = this.bbox()) {
    if (width1 == null) return box.width;
    return this.size(width1, box.height, box);
}
function x(x1, box = this.bbox()) {
    if (x1 == null) return box.x;
    return this.move(x1, box.y, box);
}
function y(y1, box = this.bbox()) {
    if (y1 == null) return box.y;
    return this.move(box.x, y1, box);
}
//#endregion
//#region src/elements/G.js
var G = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("g", node), attrs);
    }
};
extend(G, containerGeometry_exports);
registerMethods({
    Container: {
        group: wrapWithAttrCheck(function() {
            return this.put(new G());
        })
    }
});
register(G, "G");
//#endregion
//#region src/elements/A.js
var A = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("a", node), attrs);
    }
    target(target) {
        return this.attr("target", target);
    }
    to(url) {
        return this.attr("href", url, xlink);
    }
};
extend(A, containerGeometry_exports);
registerMethods({
    Container: {
        link: wrapWithAttrCheck(function(url) {
            return this.put(new A()).to(url);
        })
    },
    Element: {
        unlink () {
            const link = this.linker();
            if (!link) return this;
            const parent = link.parent();
            if (!parent) return this.remove();
            const index = parent.index(link);
            parent.add(this, index);
            link.remove();
            return this;
        },
        linkTo (url) {
            let link = this.linker();
            if (!link) {
                link = new A();
                this.wrap(link);
            }
            if (typeof url === "function") url.call(link, link);
            else link.to(url);
            return this;
        },
        linker () {
            const link = this.parent();
            if (link && link.node.nodeName.toLowerCase() === "a") return link;
            return null;
        }
    }
});
register(A, "A");
//#endregion
//#region src/elements/Mask.js
var Mask = class extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("mask", node), attrs);
    }
    remove() {
        this.targets().forEach(function(el) {
            el.unmask();
        });
        return super.remove();
    }
    targets() {
        return findReferences(this.node, "mask");
    }
};
registerMethods({
    Container: {
        mask: wrapWithAttrCheck(function() {
            return this.defs().put(new Mask());
        })
    },
    Element: {
        masker () {
            return this.reference("mask");
        },
        maskWith (element) {
            const masker = element instanceof Mask ? element : this.parent().mask().add(element);
            return this.attr("mask", "url(#" + masker.id() + ")");
        },
        unmask () {
            return this.attr("mask", null);
        }
    }
});
register(Mask, "Mask");
//#endregion
//#region src/elements/Stop.js
var Stop = class extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("stop", node), attrs);
    }
    update(o) {
        if (typeof o === "number" || o instanceof SVGNumber) o = {
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        };
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", new SVGNumber(o.offset));
        return this;
    }
};
registerMethods({
    Gradient: {
        stop: function(offset, color, opacity) {
            return this.put(new Stop()).update(offset, color, opacity);
        }
    }
});
register(Stop, "Stop");
//#endregion
//#region src/elements/Style.js
function cssRule(selector, rule) {
    if (!selector) return "";
    if (!rule) return selector;
    let ret = selector + "{";
    for(const i in rule)ret += unCamelCase(i) + ":" + rule[i] + ";";
    ret += "}";
    return ret;
}
var Style = class extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("style", node), attrs);
    }
    addText(w = "") {
        this.node.textContent += w;
        return this;
    }
    font(name, src, params = {}) {
        return this.rule("@font-face", {
            fontFamily: name,
            src: src,
            ...params
        });
    }
    rule(selector, obj) {
        return this.addText(cssRule(selector, obj));
    }
};
registerMethods("Dom", {
    style (selector, obj) {
        return this.put(new Style()).rule(selector, obj);
    },
    fontface (name, src, params) {
        return this.put(new Style()).font(name, src, params);
    }
});
register(Style, "Style");
//#endregion
//#region src/elements/TextPath.js
var TextPath = class extends Text {
    constructor(node, attrs = node){
        super(nodeOrNew("textPath", node), attrs);
    }
    array() {
        const track = this.track();
        return track ? track.array() : null;
    }
    plot(d) {
        const track = this.track();
        let pathArray = null;
        if (track) pathArray = track.plot(d);
        return d == null ? pathArray : this;
    }
    track() {
        return this.reference("href");
    }
};
registerMethods({
    Container: {
        textPath: wrapWithAttrCheck(function(text, path) {
            if (!(text instanceof Text)) text = this.text(text);
            return text.path(path);
        })
    },
    Text: {
        path: wrapWithAttrCheck(function(track, importNodes = true) {
            const textPath = new TextPath();
            if (!(track instanceof Path)) track = this.defs().path(track);
            textPath.attr("href", "#" + track, xlink);
            let node;
            if (importNodes) while(node = this.node.firstChild)textPath.node.appendChild(node);
            return this.put(textPath);
        }),
        textPath () {
            return this.findOne("textPath");
        }
    },
    Path: {
        text: wrapWithAttrCheck(function(text) {
            if (!(text instanceof Text)) text = new Text().addTo(this.parent()).text(text);
            return text.path(this);
        }),
        targets () {
            return findReferences(this.node, "href", "textPath");
        }
    }
});
TextPath.prototype.MorphArray = PathArray;
register(TextPath, "TextPath");
//#endregion
//#region src/elements/Use.js
var Use = class extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("use", node), attrs);
    }
    use(element, file) {
        return this.attr("href", (file || "") + "#" + element, xlink);
    }
};
registerMethods({
    Container: {
        use: wrapWithAttrCheck(function(element, file) {
            return this.put(new Use()).use(element, file);
        })
    }
});
register(Use, "Use");
//#endregion
//#region src/main.js
const SVG = makeInstance;
extend([
    Svg,
    Symbol$1,
    Image,
    Pattern,
    Marker
], getMethodsFor("viewbox"));
extend([
    Line,
    Polyline,
    Polygon,
    Path
], getMethodsFor("marker"));
extend(Text, getMethodsFor("Text"));
extend(Path, getMethodsFor("Path"));
extend(Defs, getMethodsFor("Defs"));
extend([
    Text,
    Tspan
], getMethodsFor("Tspan"));
extend([
    Rect,
    Ellipse,
    Gradient,
    Runner
], getMethodsFor("radius"));
extend(EventTarget, getMethodsFor("EventTarget"));
extend(Dom, getMethodsFor("Dom"));
extend(Element, getMethodsFor("Element"));
extend(Shape, getMethodsFor("Shape"));
extend([
    Container,
    Fragment
], getMethodsFor("Container"));
extend(Gradient, getMethodsFor("Gradient"));
extend(Runner, getMethodsFor("Runner"));
List.extend(getMethodNames());
registerMorphableType([
    SVGNumber,
    Color,
    Box,
    Matrix,
    SVGArray,
    PointArray,
    PathArray,
    Point
]);
makeMorphable();

});

parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

const $16061e18e8668e97$var$l = (r)=>Number.isFinite(r) && !Number.isNaN(r), $16061e18e8668e97$var$p = (r)=>typeof r == "object" && r !== null, $16061e18e8668e97$export$4a2fc57c50159605 = (r)=>$16061e18e8668e97$var$p(r) && $16061e18e8668e97$var$l(r.q) && $16061e18e8668e97$var$l(r.r), $16061e18e8668e97$var$V = (r)=>typeof r == "function", $16061e18e8668e97$export$5f412d7ebda1688b = (r)=>$16061e18e8668e97$var$p(r) && $16061e18e8668e97$var$l(r.col) && $16061e18e8668e97$var$l(r.row), $16061e18e8668e97$export$aff838a5553f2a92 = (r)=>$16061e18e8668e97$var$p(r) && $16061e18e8668e97$var$l(r.x) && $16061e18e8668e97$var$l(r.y), $16061e18e8668e97$export$62b73b2f8f623580 = (r)=>Array.isArray(r) && $16061e18e8668e97$var$l(r[0]) && $16061e18e8668e97$var$l(r[1]), $16061e18e8668e97$export$3a43594cd0df40e7 = (r, t)=>t + r * (t & 1) >> 1;
function $16061e18e8668e97$var$X(r, t) {
    return (r % t + t) % t;
}
const $16061e18e8668e97$var$D = (r, t)=>$16061e18e8668e97$var$X(r + t, 8), $16061e18e8668e97$export$e195c7dd99a3273 = ([r, t, e = -r - t])=>({
        q: r,
        r: t,
        s: e
    });
function $16061e18e8668e97$export$5a7599915cc08e63({ q: r, r: t, s: e }) {
    const n = $16061e18e8668e97$var$l(r), s = $16061e18e8668e97$var$l(t), o = $16061e18e8668e97$var$l(e);
    if (n && s && o) return {
        q: r,
        r: t,
        s: e
    };
    if (n && s) return {
        q: r,
        r: t,
        s: -r - t
    };
    if (n && o) return {
        q: r,
        r: -r - e,
        s: e
    };
    if (s && o) return {
        q: -t - e,
        r: t,
        s: e
    };
    throw new TypeError(`Can't determine three cube coordinates from less than two coordinates. Received: { q: ${r}, r: ${t}, s: ${e} }.`);
}
var $16061e18e8668e97$export$df54d73aa0ec5e82 = /* @__PURE__ */ ((r)=>(r.FLAT = "FLAT", r.POINTY = "POINTY", r))($16061e18e8668e97$export$df54d73aa0ec5e82 || {});
function $16061e18e8668e97$export$ddb142a71bcca22e(r, t) {
    if ($16061e18e8668e97$var$p(r) && r.xRadius > 0 && r.yRadius > 0) return r;
    if ($16061e18e8668e97$var$p(r) && r.width > 0 && r.height > 0) {
        const { width: e, height: n } = r;
        return t === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? {
            xRadius: e / Math.sqrt(3),
            yRadius: n / 2
        } : {
            xRadius: e / 2,
            yRadius: n / Math.sqrt(3)
        };
    }
    if (r > 0) return {
        xRadius: r,
        yRadius: r
    };
    throw new TypeError(`Invalid dimensions: ${JSON.stringify(r)}. Dimensions must be expressed as an Ellipse ({ xRadius: number, yRadius: number }), a Rectangle ({ width: number, height: number }) or a number.`);
}
function $16061e18e8668e97$export$b5ff3e9144a6a1f8(r, t) {
    if ($16061e18e8668e97$export$aff838a5553f2a92(r)) return r;
    if (!t) throw new TypeError(`Supply a bounding box ({ width: number, height: number }). Received: ${JSON.stringify(t)}`);
    if (r === "topLeft") return {
        x: t.width * -0.5,
        y: t.height * -0.5
    };
    throw new TypeError(`Invalid origin: ${JSON.stringify(r)}. Origin must be expressed as a Point ({ x: number, y: number }) or the string 'topLeft'.`);
}
class $16061e18e8668e97$export$9ccf03a0aa23a1ca {
    static get settings() {
        const { dimensions: t, orientation: e, origin: n, offset: s } = this.prototype;
        return {
            dimensions: t,
            orientation: e,
            origin: n,
            offset: s
        };
    }
    /**
   * This returns a point relative to the __top left corner__ of the hex with coordinates `[0, 0]`, ignoring any `origin` you may have set.
   *
   * @deprecated This probably doesn't do what you expect. If you want the center coordinates of a hex, use `hex.x` and `hex.y` instead.
   * See https://github.com/flauwekeul/honeycomb/discussions/95#discussioncomment-5158862.
   */ get center() {
        const { width: t, height: e, x: n, y: s } = this;
        return {
            x: t / 2 - n,
            y: e / 2 - s
        };
    }
    get col() {
        return $16061e18e8668e97$export$a601f2d860327e6(this).col;
    }
    // todo: add to docs that this always returns corners relative to Hex(0, 0)
    get corners() {
        const { orientation: t, width: e, height: n, x: s, y: o } = this;
        return t === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? $16061e18e8668e97$var$rt(e, n, s, o) : $16061e18e8668e97$var$et(e, n, s, o);
    }
    get dimensions() {
        return $16061e18e8668e97$export$3f150b911d514c91.dimensions;
    }
    get height() {
        const { orientation: t, dimensions: { yRadius: e } } = this;
        return t === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? e * 2 : e * Math.sqrt(3);
    }
    get isFlat() {
        return this.orientation === $16061e18e8668e97$export$df54d73aa0ec5e82.FLAT;
    }
    get isPointy() {
        return this.orientation === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY;
    }
    get orientation() {
        return $16061e18e8668e97$export$3f150b911d514c91.orientation;
    }
    get origin() {
        return $16061e18e8668e97$export$3f150b911d514c91.origin;
    }
    get offset() {
        return $16061e18e8668e97$export$3f150b911d514c91.offset;
    }
    get row() {
        return $16061e18e8668e97$export$a601f2d860327e6(this).row;
    }
    get width() {
        const { orientation: t, dimensions: { xRadius: e } } = this;
        return t === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? e * Math.sqrt(3) : e * 2;
    }
    get x() {
        return $16061e18e8668e97$export$28c74c99a0791a0a(this).x;
    }
    get y() {
        return $16061e18e8668e97$export$28c74c99a0791a0a(this).y;
    }
    get s() {
        return -this.q - this.r;
    }
    q;
    r;
    constructor(t = [
        0,
        0
    ]){
        const { q: e, r: n } = $16061e18e8668e97$export$454a134ad9167cca(this, t);
        this.q = e, this.r = n;
    }
    clone(t = this) {
        return new this.constructor(t);
    }
    equals(t) {
        return $16061e18e8668e97$export$e9bab7fafb253603(this, $16061e18e8668e97$export$5f412d7ebda1688b(t) ? $16061e18e8668e97$export$c0bea532a78866f7(this, t) : t);
    }
    toString() {
        return `${this.constructor.name}(${this.q},${this.r})`;
    }
    translate(t) {
        return $16061e18e8668e97$export$d73ee8ef04f5226a(this, t);
    }
}
const $16061e18e8668e97$export$3f150b911d514c91 = {
    dimensions: {
        xRadius: 1,
        yRadius: 1
    },
    orientation: $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY,
    origin: {
        x: 0,
        y: 0
    },
    offset: -1
}, $16061e18e8668e97$var$rt = (r, t, e, n)=>[
        {
            x: e + r * 0.5,
            y: n - t * 0.25
        },
        {
            x: e + r * 0.5,
            y: n + t * 0.25
        },
        {
            x: e,
            y: n + t * 0.5
        },
        {
            x: e - r * 0.5,
            y: n + t * 0.25
        },
        {
            x: e - r * 0.5,
            y: n - t * 0.25
        },
        {
            x: e,
            y: n - t * 0.5
        }
    ], $16061e18e8668e97$var$et = (r, t, e, n)=>[
        {
            x: e + r * 0.25,
            y: n - t * 0.5
        },
        {
            x: e + r * 0.5,
            y: n
        },
        {
            x: e + r * 0.25,
            y: n + t * 0.5
        },
        {
            x: e - r * 0.25,
            y: n + t * 0.5
        },
        {
            x: e - r * 0.5,
            y: n
        },
        {
            x: e - r * 0.25,
            y: n - t * 0.5
        }
    ];
function $16061e18e8668e97$export$98781bdbfe5970f1(r) {
    const { dimensions: t, orientation: e, origin: n, offset: s } = {
        ...$16061e18e8668e97$export$3f150b911d514c91,
        ...r
    };
    return class extends $16061e18e8668e97$export$9ccf03a0aa23a1ca {
        get dimensions() {
            return $16061e18e8668e97$export$ddb142a71bcca22e(t, e);
        }
        get orientation() {
            return e;
        }
        get origin() {
            return $16061e18e8668e97$export$b5ff3e9144a6a1f8(n, this);
        }
        get offset() {
            return s;
        }
    };
}
function $16061e18e8668e97$export$e9bab7fafb253603(r, t) {
    if ($16061e18e8668e97$export$5f412d7ebda1688b(r) && $16061e18e8668e97$export$5f412d7ebda1688b(t)) return r.col === t.col && r.row === t.row;
    if (Object.hasOwn(r, "col") || Object.hasOwn(t, "col")) throw new Error(`Can't compare coordinates where one are offset coordinates. Either pass two offset coordinates or two axial/cube coordinates. Received: ${JSON.stringify(r)} and ${JSON.stringify(t)}`);
    const e = $16061e18e8668e97$export$62b73b2f8f623580(r) ? $16061e18e8668e97$export$e195c7dd99a3273(r) : r, n = $16061e18e8668e97$export$62b73b2f8f623580(t) ? $16061e18e8668e97$export$e195c7dd99a3273(t) : t;
    return e.q === n.q && e.r === n.r;
}
const $16061e18e8668e97$var$ot = (r, t, e)=>({
        col: r + $16061e18e8668e97$export$3a43594cd0df40e7(e, t),
        row: t
    }), $16061e18e8668e97$var$it = (r, t, e)=>({
        col: r,
        row: t + $16061e18e8668e97$export$3a43594cd0df40e7(e, r)
    }), $16061e18e8668e97$export$a601f2d860327e6 = ({ q: r, r: t, offset: e, isPointy: n })=>n ? $16061e18e8668e97$var$ot(r, t, e) : $16061e18e8668e97$var$it(r, t, e), $16061e18e8668e97$export$28c74c99a0791a0a = ({ orientation: r, dimensions: { xRadius: t, yRadius: e }, origin: { x: n, y: s }, q: o, r: i })=>r === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? {
        x: t * Math.sqrt(3) * (o + i / 2) - n,
        y: e * 3 / 2 * i - s
    } : {
        x: t * 3 / 2 * o - n,
        y: e * Math.sqrt(3) * (i + o / 2) - s
    }, $16061e18e8668e97$export$a9e5df9e571261f9 = (r, t, e)=>{
    const n = r - $16061e18e8668e97$export$3a43594cd0df40e7(e, t), s = t, o = -n - s;
    return {
        q: n,
        r: s,
        s: o
    };
}, $16061e18e8668e97$export$cccfc2ad6da275bc = (r, t, e)=>{
    const n = r, s = t - $16061e18e8668e97$export$3a43594cd0df40e7(e, r), o = -n - s;
    return {
        q: n,
        r: s,
        s: o
    };
}, $16061e18e8668e97$export$c0bea532a78866f7 = ({ offset: r, orientation: t }, { col: e, row: n })=>t === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? $16061e18e8668e97$export$a9e5df9e571261f9(e, n, r) : $16061e18e8668e97$export$cccfc2ad6da275bc(e, n, r), $16061e18e8668e97$export$2077e0241d6afd3c = (r)=>{
    const { q: t, r: e, s: n } = $16061e18e8668e97$export$5a7599915cc08e63(r);
    let s = Math.round(t), o = Math.round(e), i = Math.round(n);
    const c = Math.abs(t - s), u = Math.abs(e - o), h = Math.abs(n - i);
    return c > u && c > h ? s = -o - i : u > h ? o = -s - i : i = -s - o, {
        q: s,
        r: o,
        s: i
    };
}, $16061e18e8668e97$export$a44d5a34add2fecb = ({ dimensions: { xRadius: r, yRadius: t }, origin: e, orientation: n }, { x: s, y: o })=>(s += e.x, o += e.y, n === $16061e18e8668e97$export$df54d73aa0ec5e82.POINTY ? $16061e18e8668e97$export$2077e0241d6afd3c({
        q: Math.sqrt(3) * s / (3 * r) - o / (3 * t),
        r: 2 / 3 * (o / t)
    }) : $16061e18e8668e97$export$2077e0241d6afd3c({
        q: 2 / 3 * (s / r),
        r: Math.sqrt(3) * o / (3 * t) - s / (3 * r)
    }));
function $16061e18e8668e97$export$454a134ad9167cca(r, t) {
    return $16061e18e8668e97$export$62b73b2f8f623580(t) ? $16061e18e8668e97$export$e195c7dd99a3273(t) : $16061e18e8668e97$export$5f412d7ebda1688b(t) ? $16061e18e8668e97$export$c0bea532a78866f7(r, t) : $16061e18e8668e97$export$5a7599915cc08e63(t);
}
function $16061e18e8668e97$export$d73ee8ef04f5226a(r, t) {
    const { q: e, r: n, s: s } = $16061e18e8668e97$export$5a7599915cc08e63(r), { q: o, r: i, s: c } = $16061e18e8668e97$export$5a7599915cc08e63(t), u = {
        q: e + o,
        r: n + i,
        s: s + c
    };
    return r instanceof $16061e18e8668e97$export$9ccf03a0aa23a1ca ? r.clone(u) : u;
}
function $16061e18e8668e97$export$9f17032d917177de(r, t, e) {
    const { q: n, r: s, s: o } = $16061e18e8668e97$export$454a134ad9167cca(r, t), { q: i, r: c, s: u } = $16061e18e8668e97$export$454a134ad9167cca(r, e);
    return Math.max(Math.abs(n - i), Math.abs(s - c), Math.abs(o - u));
}
var $16061e18e8668e97$export$9bdec6016cc824e2 = /* @__PURE__ */ ((r)=>(r.CLOCKWISE = "CLOCKWISE", r.COUNTERCLOCKWISE = "COUNTERCLOCKWISE", r))($16061e18e8668e97$export$9bdec6016cc824e2 || {}), $16061e18e8668e97$export$cacd6541cfeeb6c1 = /* @__PURE__ */ ((r)=>(r[r.N = 0] = "N", r[r.NE = 1] = "NE", r[r.E = 2] = "E", r[r.SE = 3] = "SE", r[r.S = 4] = "S", r[r.SW = 5] = "SW", r[r.W = 6] = "W", r[r.NW = 7] = "NW", r))($16061e18e8668e97$export$cacd6541cfeeb6c1 || {});
const $16061e18e8668e97$var$ht = [
    null,
    // ambiguous
    {
        q: 1,
        r: -1
    },
    // NE
    {
        q: 1,
        r: 0
    },
    // E
    {
        q: 0,
        r: 1
    },
    // SE
    null,
    // ambiguous
    {
        q: -1,
        r: 1
    },
    // SW
    {
        q: -1,
        r: 0
    },
    // W
    {
        q: 0,
        r: -1
    }
], $16061e18e8668e97$var$ft = [
    {
        q: 0,
        r: -1
    },
    // N
    {
        q: 1,
        r: -1
    },
    // NE
    null,
    // ambiguous
    {
        q: 1,
        r: 0
    },
    // SE
    {
        q: 0,
        r: 1
    },
    // S
    {
        q: -1,
        r: 1
    },
    // SW
    null,
    // ambiguous
    {
        q: -1,
        r: 0
    }
], $16061e18e8668e97$var$at = ({ offset: r, q: t, r: e, col: n, row: s }, o)=>{
    if (o === $16061e18e8668e97$export$cacd6541cfeeb6c1.S || o === $16061e18e8668e97$export$cacd6541cfeeb6c1.N) {
        const c = o === $16061e18e8668e97$export$cacd6541cfeeb6c1.S ? s + 1 : s - 1;
        return $16061e18e8668e97$export$a9e5df9e571261f9(n, c, r);
    }
    const i = $16061e18e8668e97$var$ht[o];
    return {
        q: t + i.q,
        r: e + i.r
    };
}, $16061e18e8668e97$var$lt = ({ offset: r, q: t, r: e, col: n, row: s }, o)=>{
    if (o === $16061e18e8668e97$export$cacd6541cfeeb6c1.E || o === $16061e18e8668e97$export$cacd6541cfeeb6c1.W) {
        const c = o === $16061e18e8668e97$export$cacd6541cfeeb6c1.E ? n + 1 : n - 1;
        return $16061e18e8668e97$export$cccfc2ad6da275bc(c, s, r);
    }
    const i = $16061e18e8668e97$var$ft[o];
    return {
        q: t + i.q,
        r: e + i.r
    };
}, $16061e18e8668e97$export$8af18edf8bddf28e = (r, t)=>r.clone(r.isPointy ? $16061e18e8668e97$var$at(r, t) : $16061e18e8668e97$var$lt(r, t));
function $16061e18e8668e97$export$ee1b3e54f0441b22(r) {
    return Array.isArray(r) ? function(e, n) {
        const s = [];
        let o = n;
        for (const i of r)for (const c of i(e, o))s.push(o = c);
        return s;
    } : r;
}
const $16061e18e8668e97$export$254918dfc77d0923 = (...r)=>(t)=>r.map(t);
function $16061e18e8668e97$export$53f1d5ea8de3d7c(r) {
    return $16061e18e8668e97$var$gt(r) ? $16061e18e8668e97$var$xt(r) : $16061e18e8668e97$var$dt(r);
}
function $16061e18e8668e97$var$gt(r) {
    return r.direction in $16061e18e8668e97$export$cacd6541cfeeb6c1;
}
function $16061e18e8668e97$var$xt({ start: r, direction: t, length: e }) {
    return function(s, o) {
        const i = [];
        let u = s(r ?? o);
        !r && o && (u = $16061e18e8668e97$export$8af18edf8bddf28e(u, t));
        for(let h = 0; h < e; h++)i.push(u), u = $16061e18e8668e97$export$8af18edf8bddf28e(u, t);
        return i;
    };
}
function $16061e18e8668e97$var$dt({ start: r, stop: t }) {
    return function(n, s) {
        const o = [], i = n(r ?? s), c = $16061e18e8668e97$var$B(i), u = $16061e18e8668e97$var$B($16061e18e8668e97$export$454a134ad9167cca(i, t)), h = $16061e18e8668e97$var$mt(c, u), f = $16061e18e8668e97$export$9f17032d917177de(i, i, t), y = 1 / Math.max(f, 1);
        let m = !r && s ? 1 : 0;
        for(m; m <= f; m++){
            const O = $16061e18e8668e97$export$2077e0241d6afd3c(h(y * m));
            o.push(n(O));
        }
        return o;
    };
}
function $16061e18e8668e97$var$B({ q: r, r: t, s: e }) {
    return {
        q: r + 1e-6,
        r: t + 1e-6,
        s: e + -0.000002
    };
}
function $16061e18e8668e97$var$mt(r, t) {
    return (e)=>{
        const n = r.q * (1 - e) + t.q * e, s = r.r * (1 - e) + t.r * e;
        return {
            q: n,
            r: s
        };
    };
}
const $16061e18e8668e97$export$d947e5f4f4c48d48 = (r)=>(t, e)=>[
            $16061e18e8668e97$export$8af18edf8bddf28e(t(e), r)
        ];
function $16061e18e8668e97$export$c9e6f32e3575988f(r, t, { includeSource: e = !0 } = {}) {
    return function(s, o) {
        const i = [];
        for (const c of $16061e18e8668e97$export$ee1b3e54f0441b22(r)(s, o)){
            e && i.push(c);
            for (const u of $16061e18e8668e97$export$ee1b3e54f0441b22(t)(s, c))i.push(u);
        }
        return i;
    };
}
function $16061e18e8668e97$export$405b065079b7caf2(r, t) {
    return function(n, s) {
        const { width: o, height: i, start: c, direction: u = $16061e18e8668e97$export$cacd6541cfeeb6c1.E } = t ? $16061e18e8668e97$var$qt(r, t, n()) : r, h = c ?? s ?? [
            0,
            0
        ], f = $16061e18e8668e97$export$c9e6f32e3575988f($16061e18e8668e97$export$53f1d5ea8de3d7c({
            start: h,
            direction: $16061e18e8668e97$var$D(u, 2),
            length: i
        }), $16061e18e8668e97$export$53f1d5ea8de3d7c({
            direction: u,
            length: o - 1
        }))(n, h);
        return !c && s ? f.slice(1) : f;
    };
}
function $16061e18e8668e97$var$qt(r, t, { isPointy: e, offset: n }) {
    const { col: s, row: o } = $16061e18e8668e97$var$K(r, e, n), { col: i, row: c } = $16061e18e8668e97$var$K(t, e, n), u = s < i ? "A" : "B", h = o < c ? "A" : "B", f = u + h, { swapWidthHeight: y, direction: m } = $16061e18e8668e97$var$yt[f], O = Math.abs(s - i) + 1, g = Math.abs(o - c) + 1;
    return {
        width: y ? g : O,
        height: y ? O : g,
        start: r,
        direction: m
    };
}
function $16061e18e8668e97$var$K(r, t, e) {
    if ($16061e18e8668e97$export$5f412d7ebda1688b(r)) return r;
    const { q: n, r: s } = $16061e18e8668e97$export$62b73b2f8f623580(r) ? $16061e18e8668e97$export$e195c7dd99a3273(r) : $16061e18e8668e97$export$5a7599915cc08e63(r);
    return $16061e18e8668e97$export$a601f2d860327e6({
        q: n,
        r: s,
        isPointy: t,
        offset: e
    });
}
const $16061e18e8668e97$var$yt = {
    AA: {
        swapWidthHeight: !1,
        direction: $16061e18e8668e97$export$cacd6541cfeeb6c1.E
    },
    AB: {
        swapWidthHeight: !0,
        direction: $16061e18e8668e97$export$cacd6541cfeeb6c1.N
    },
    BA: {
        swapWidthHeight: !0,
        direction: $16061e18e8668e97$export$cacd6541cfeeb6c1.S
    },
    BB: {
        swapWidthHeight: !1,
        direction: $16061e18e8668e97$export$cacd6541cfeeb6c1.W
    }
};
function $16061e18e8668e97$export$76d90c956114f2c2(r, t) {
    return $16061e18e8668e97$export$ee1b3e54f0441b22(Array.from({
        length: r
    }, ()=>$16061e18e8668e97$export$ee1b3e54f0441b22(t)));
}
function $16061e18e8668e97$export$e7d0da6968da5dd(r) {
    const { center: t, rotation: e = $16061e18e8668e97$export$9bdec6016cc824e2.CLOCKWISE } = r;
    return function(s, o) {
        const i = e.toUpperCase(), c = [];
        let { radius: u } = r;
        const h = $16061e18e8668e97$var$l(u);
        let f;
        h ? f = s(t).translate({
            q: u,
            s: -u
        }) : (f = s(r.start ?? o), u = $16061e18e8668e97$export$9f17032d917177de(f, t, f));
        const { q: y, r: m, s: O } = $16061e18e8668e97$export$454a134ad9167cca(f, t);
        let g = s({
            q: y,
            r: m - u,
            s: O + u
        });
        if (i === $16061e18e8668e97$export$9bdec6016cc824e2.CLOCKWISE) for(let d = 0; d < 6; d++)for(let w = 0; w < u; w++){
            const { q: A, r: M } = $16061e18e8668e97$var$Q[d];
            g = s({
                q: g.q + A,
                r: g.r + M
            }), c.push(g);
        }
        else for(let d = 5; d >= 0; d--)for(let w = 0; w < u; w++){
            const { q: A, r: M } = $16061e18e8668e97$var$Q[d];
            g = s({
                q: g.q - A,
                r: g.r - M
            }), c.push(g);
        }
        const k = h ? !1 : !r.start && o, Y = c.findIndex((d)=>d.equals(f));
        return c.slice(Y + (k ? 1 : 0)).concat(c.slice(0, Y));
    };
}
const $16061e18e8668e97$var$Q = [
    {
        q: 1,
        r: 0
    },
    {
        q: 0,
        r: 1
    },
    {
        q: -1,
        r: 1
    },
    {
        q: -1,
        r: 0
    },
    {
        q: 0,
        r: -1
    },
    {
        q: 1,
        r: -1
    }
];
function $16061e18e8668e97$export$a70866d5e0158cdc({ radius: r, start: t, rotation: e }) {
    return function(s, o) {
        const i = t ?? o ?? [
            0,
            0
        ], c = !t && o ? r : r + 1;
        return $16061e18e8668e97$export$c9e6f32e3575988f($16061e18e8668e97$export$53f1d5ea8de3d7c({
            start: t,
            direction: $16061e18e8668e97$export$cacd6541cfeeb6c1.N,
            length: c
        }), $16061e18e8668e97$export$e7d0da6968da5dd({
            center: i,
            rotation: e
        }))(s, o);
    };
}
class $16061e18e8668e97$export$ef2184bd89960b14 {
    static fromIterable(t) {
        const e = t[Symbol.iterator]().next().value;
        if (!e) throw new TypeError(`Can't create grid from empty iterable: ${JSON.stringify(t)}`);
        return new $16061e18e8668e97$export$ef2184bd89960b14(e.constructor, t);
    }
    static fromJSON({ hexSettings: t, coordinates: e }, n) {
        if (n) {
            const o = e.map(n), i = o.length > 0 ? o[0].constructor : n({
                q: 0,
                r: 0
            }, 0, [
                {
                    q: 0,
                    r: 0
                }
            ]).constructor;
            return new $16061e18e8668e97$export$ef2184bd89960b14(i, o);
        }
        const s = $16061e18e8668e97$export$98781bdbfe5970f1(t);
        return new $16061e18e8668e97$export$ef2184bd89960b14(s, e.map((o)=>new s(o)));
    }
    get size() {
        return this.#r.size;
    }
    get pixelWidth() {
        if (this.size === 0) return 0;
        const { isPointy: t, width: e } = this.hexPrototype, n = this.toArray(), { 0: s, length: o, [o - 1]: i } = t ? n.sort((c, u)=>u.s - c.s || c.q - u.q) : n.sort((c, u)=>c.q - u.q);
        return i.x - s.x + e;
    }
    get pixelHeight() {
        if (this.size === 0) return 0;
        const { isPointy: t, height: e } = this.hexPrototype, n = this.toArray(), { 0: s, length: o, [o - 1]: i } = t ? n.sort((c, u)=>c.r - u.r) : n.sort((c, u)=>u.s - c.s || c.r - u.r);
        return i.y - s.y + e;
    }
    [Symbol.iterator]() {
        return this.#r.values();
    }
    get hexPrototype() {
        return this.#t.prototype;
    }
    #t;
    #r = /* @__PURE__ */ new Map();
    constructor(t, e = []){
        if (t instanceof $16061e18e8668e97$export$ef2184bd89960b14) {
            this.#t = t.#t, this.setHexes(t);
            return;
        }
        this.#t = t, this.setHexes(this.#n(e));
    }
    createHex(t) {
        return new this.#t(t);
    }
    getHex(t) {
        const e = this.createHex(t);
        return this.#r.get(e.toString());
    }
    hasHex(t) {
        return this.#r.has(t.toString());
    }
    setHexes(t) {
        for (const e of t){
            const n = e instanceof $16061e18e8668e97$export$9ccf03a0aa23a1ca ? e : new this.#t(e);
            this.#e(n);
        }
        return this;
    }
    filter(t) {
        const e = new $16061e18e8668e97$export$ef2184bd89960b14(this.#t);
        for (const n of this)t(n) && e.#e(n);
        return e;
    }
    map(t) {
        const e = new $16061e18e8668e97$export$ef2184bd89960b14(this.#t);
        for (const n of this)e.#e(t(n));
        return e;
    }
    traverse(t, { bail: e = !1 } = {}) {
        const n = new $16061e18e8668e97$export$ef2184bd89960b14(this.#t);
        for (const s of this.#n(t)){
            const o = this.getHex(s);
            if (o) n.#e(o);
            else if (e) return n;
        }
        return n;
    }
    forEach(t) {
        for (const e of this)t(e);
        return this;
    }
    reduce(t, e) {
        if (e === void 0) {
            let s, o, i;
            for (const c of this)o = i, i = c, o && (s = t(o, i));
            return s;
        }
        let n = e;
        for (const s of this)n = t(n, s);
        return n;
    }
    toArray() {
        return Array.from(this);
    }
    // todo: add to docs that hexSettings don't include any custom properties
    toJSON() {
        const { dimensions: t, orientation: e, origin: n, offset: s } = this.hexPrototype;
        return {
            hexSettings: {
                dimensions: t,
                orientation: e,
                origin: n,
                offset: s
            },
            coordinates: this.toArray()
        };
    }
    toString() {
        return `${this.constructor.name}(${this.size})`;
    }
    pointToHex(t, { allowOutside: e = !0 } = {}) {
        const n = $16061e18e8668e97$export$a44d5a34add2fecb(this.hexPrototype, t), s = this.getHex(n);
        return e ? s ?? this.createHex(n) : s;
    }
    distance(t, e, { allowOutside: n = !0 } = {}) {
        if (n) return $16061e18e8668e97$export$9f17032d917177de(this.hexPrototype, t, e);
        const s = this.getHex(t), o = this.getHex(e);
        if (!(!s || !o)) return $16061e18e8668e97$export$9f17032d917177de(this.hexPrototype, s, o);
    }
    neighborOf(t, e, { allowOutside: n = !0 } = {}) {
        const s = $16061e18e8668e97$export$8af18edf8bddf28e(this.createHex(t), e), o = this.getHex(s);
        return n ? o ?? s : o;
    }
    #e(t) {
        this.#r.set(t.toString(), t);
    }
    #n(t) {
        return this.#s(t) ? this.#o(t) : Array.isArray(t) && this.#s(t[0]) ? this.#o($16061e18e8668e97$export$ee1b3e54f0441b22(t)) : t;
    }
    #s(t) {
        return $16061e18e8668e97$var$V(t);
    }
    #o(t) {
        return t(this.createHex.bind(this));
    }
}



var $jDp01 = parcelRequire("jDp01");
let $3753227fdc8a3f3b$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $3753227fdc8a3f3b$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3753227fdc8a3f3b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size;
    while(i--)id += $3753227fdc8a3f3b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};



function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $i4CZ2 = parcelRequire("i4CZ2");
// Inlined version of Alea from https://github.com/davidbau/seedrandom.
// Converted to Typescript October 2020.
class $a1e355d2fa1df224$var$Alea {
    constructor(seed){
        const mash = $a1e355d2fa1df224$var$Mash();
        // Apply the seeding algorithm from Baagoe.
        this.c = 1;
        this.s0 = mash(' ');
        this.s1 = mash(' ');
        this.s2 = mash(' ');
        this.s0 -= mash(seed);
        if (this.s0 < 0) this.s0 += 1;
        this.s1 -= mash(seed);
        if (this.s1 < 0) this.s1 += 1;
        this.s2 -= mash(seed);
        if (this.s2 < 0) this.s2 += 1;
    }
    next() {
        const t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
        this.s0 = this.s1;
        this.s1 = this.s2;
        return this.s2 = t - (this.c = Math.trunc(t));
    }
}
function $a1e355d2fa1df224$var$Mash() {
    let n = 0xefc8249d;
    const mash = function(data) {
        const str = data.toString();
        for(let i = 0; i < str.length; i++){
            n += str.charCodeAt(i);
            let h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };
    return mash;
}
function $a1e355d2fa1df224$var$copy(f, t) {
    t.c = f.c;
    t.s0 = f.s0;
    t.s1 = f.s1;
    t.s2 = f.s2;
    return t;
}
function $a1e355d2fa1df224$export$407448d2b89b1813(seed, state) {
    const xg = new $a1e355d2fa1df224$var$Alea(seed);
    const prng = xg.next.bind(xg);
    if (state) $a1e355d2fa1df224$var$copy(state, xg);
    prng.state = ()=>$a1e355d2fa1df224$var$copy(xg, {});
    return prng;
}
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Random
 *
 * Calls that require a pseudorandom number generator.
 * Uses a seed from ctx, and also persists the PRNG
 * state in ctx so that moves can stay pure.
 */ class $a1e355d2fa1df224$var$Random {
    /**
     * constructor
     * @param {object} ctx - The ctx object to initialize from.
     */ constructor(state){
        // If we are on the client, the seed is not present.
        // Just use a temporary seed to execute the move without
        // crashing it. The move state itself is discarded,
        // so the actual value doesn't matter.
        this.state = state || {
            seed: '0'
        };
        this.used = false;
    }
    /**
     * Generates a new seed from the current date / time.
     */ static seed() {
        return Date.now().toString(36).slice(-10);
    }
    isUsed() {
        return this.used;
    }
    getState() {
        return this.state;
    }
    /**
     * Generate a random number.
     */ _random() {
        this.used = true;
        const R = this.state;
        const seed = R.prngstate ? '' : R.seed;
        const rand = $a1e355d2fa1df224$export$407448d2b89b1813(seed, R.prngstate);
        const number = rand();
        this.state = {
            ...R,
            prngstate: rand.state()
        };
        return number;
    }
    api() {
        const random = this._random.bind(this);
        const SpotValue = {
            D4: 4,
            D6: 6,
            D8: 8,
            D10: 10,
            D12: 12,
            D20: 20
        };
        // Generate functions for predefined dice values D4 - D20.
        const predefined = {};
        for(const key in SpotValue){
            const spotvalue = SpotValue[key];
            predefined[key] = (diceCount)=>{
                return diceCount === undefined ? Math.floor(random() * spotvalue) + 1 : Array.from({
                    length: diceCount
                }).map(()=>Math.floor(random() * spotvalue) + 1);
            };
        }
        function Die(spotvalue = 6, diceCount) {
            return diceCount === undefined ? Math.floor(random() * spotvalue) + 1 : Array.from({
                length: diceCount
            }).map(()=>Math.floor(random() * spotvalue) + 1);
        }
        return {
            /**
             * Similar to Die below, but with fixed spot values.
             * Supports passing a diceCount
             *    if not defined, defaults to 1 and returns the value directly.
             *    if defined, returns an array containing the random dice values.
             *
             * D4: (diceCount) => value
             * D6: (diceCount) => value
             * D8: (diceCount) => value
             * D10: (diceCount) => value
             * D12: (diceCount) => value
             * D20: (diceCount) => value
             */ ...predefined,
            Die: /**
             * Roll a die of specified spot value.
             *
             * @param {number} spotvalue - The die dimension (default: 6).
             * @param {number} diceCount - number of dice to throw.
             *                             if not defined, defaults to 1 and returns the value directly.
             *                             if defined, returns an array containing the random dice values.
             */ Die,
            /**
             * Generate a random number between 0 and 1.
             */ Number: ()=>{
                return random();
            },
            /**
             * Shuffle an array.
             *
             * @param {Array} deck - The array to shuffle. Does not mutate
             *                       the input, but returns the shuffled array.
             */ Shuffle: (deck)=>{
                const clone = [
                    ...deck
                ];
                let sourceIndex = deck.length;
                let destinationIndex = 0;
                const shuffled = Array.from({
                    length: sourceIndex
                });
                while(sourceIndex){
                    const randomIndex = Math.trunc(sourceIndex * random());
                    shuffled[destinationIndex++] = clone[randomIndex];
                    clone[randomIndex] = clone[--sourceIndex];
                }
                return shuffled;
            },
            _private: this
        };
    }
}
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ const $a1e355d2fa1df224$export$db202ddc8be9136 = {
    name: 'random',
    noClient: ({ api: api })=>{
        return api._private.isUsed();
    },
    flush: ({ api: api })=>{
        return api._private.getState();
    },
    api: ({ data: data })=>{
        const random = new $a1e355d2fa1df224$var$Random(data);
        return random.api();
    },
    setup: ({ game: game })=>{
        let { seed: seed } = game;
        if (seed === undefined) seed = $a1e355d2fa1df224$var$Random.seed();
        return {
            seed: seed
        };
    },
    playerView: ()=>undefined
};


var $0f00e0d907a420b6$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $0f00e0d907a420b6$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $0f00e0d907a420b6$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0f00e0d907a420b6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $0f00e0d907a420b6$var$funcProto = Function.prototype, $0f00e0d907a420b6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0f00e0d907a420b6$var$funcToString = $0f00e0d907a420b6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0f00e0d907a420b6$var$hasOwnProperty = $0f00e0d907a420b6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0f00e0d907a420b6$var$objectCtorString = $0f00e0d907a420b6$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0f00e0d907a420b6$var$objectToString = $0f00e0d907a420b6$var$objectProto.toString;
/** Built-in value references. */ var $0f00e0d907a420b6$var$getPrototype = $0f00e0d907a420b6$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0f00e0d907a420b6$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0f00e0d907a420b6$var$isPlainObject(value) {
    if (!$0f00e0d907a420b6$var$isObjectLike(value) || $0f00e0d907a420b6$var$objectToString.call(value) != $0f00e0d907a420b6$var$objectTag || $0f00e0d907a420b6$var$isHostObject(value)) return false;
    var proto = $0f00e0d907a420b6$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $0f00e0d907a420b6$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0f00e0d907a420b6$var$funcToString.call(Ctor) == $0f00e0d907a420b6$var$objectCtorString;
}
$0f00e0d907a420b6$exports = $0f00e0d907a420b6$var$isPlainObject;


/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ const $b0ae1e6bca8d95a9$export$3a1a48c8f6ef640e = 'MAKE_MOVE';
const $b0ae1e6bca8d95a9$export$ae1af26003f05816 = 'GAME_EVENT';
const $b0ae1e6bca8d95a9$export$db202ddc8be9136 = 'REDO';
const $b0ae1e6bca8d95a9$export$953cecd6e717a553 = 'RESET';
const $b0ae1e6bca8d95a9$export$342063e11d6c3cad = 'SYNC';
const $b0ae1e6bca8d95a9$export$35e795649ee09318 = 'UNDO';
const $b0ae1e6bca8d95a9$export$882b5998b3b9117c = 'UPDATE';
const $b0ae1e6bca8d95a9$export$56c0d5a1e737357d = 'PATCH';
const $b0ae1e6bca8d95a9$export$2d1720544b23b823 = 'PLUGIN';
const $b0ae1e6bca8d95a9$export$ffb5f4729a158638 = 'STRIP_TRANSIENTS';
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Generate a move to be dispatched to the game move reducer.
 *
 * @param {string} type - The move type.
 * @param {Array}  args - Additional arguments.
 * @param {string}  playerID - The ID of the player making this action.
 * @param {string}  credentials - (optional) The credentials for the player making this action.
 */ const $b0ae1e6bca8d95a9$export$ef35774e6d314e91 = (type, args, playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$3a1a48c8f6ef640e,
        payload: {
            type: type,
            args: args,
            playerID: playerID,
            credentials: credentials
        }
    });
/**
 * Generate a game event to be dispatched to the flow reducer.
 *
 * @param {string} type - The event type.
 * @param {Array}  args - Additional arguments.
 * @param {string}  playerID - The ID of the player making this action.
 * @param {string}  credentials - (optional) The credentials for the player making this action.
 */ const $b0ae1e6bca8d95a9$export$39b482c5e57630a8 = (type, args, playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$ae1af26003f05816,
        payload: {
            type: type,
            args: args,
            playerID: playerID,
            credentials: credentials
        }
    });
/**
 * Generate an automatic game event that is a side-effect of a move.
 * @param {string} type - The event type.
 * @param {Array}  args - Additional arguments.
 * @param {string}  playerID - The ID of the player making this action.
 * @param {string}  credentials - (optional) The credentials for the player making this action.
 */ const $b0ae1e6bca8d95a9$var$automaticGameEvent = (type, args, playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$ae1af26003f05816,
        payload: {
            type: type,
            args: args,
            playerID: playerID,
            credentials: credentials
        },
        automatic: true
    });
const $b0ae1e6bca8d95a9$export$2408f22a0fab9ae5 = (info)=>({
        type: $b0ae1e6bca8d95a9$export$342063e11d6c3cad,
        state: info.state,
        log: info.log,
        initialState: info.initialState,
        clientOnly: true
    });
/**
 * Used to update the Redux store's state with patch in response to
 * an action coming from another player.
 * @param prevStateID previous stateID
 * @param stateID stateID after this patch
 * @param {Operation[]} patch - The patch to apply.
 * @param {LogEntry[]} deltalog - A log delta.
 */ const $b0ae1e6bca8d95a9$export$4a5767248b18ef41 = (prevStateID, stateID, patch, deltalog)=>({
        type: $b0ae1e6bca8d95a9$export$56c0d5a1e737357d,
        prevStateID: prevStateID,
        stateID: stateID,
        patch: patch,
        deltalog: deltalog,
        clientOnly: true
    });
/**
 * Used to update the Redux store's state in response to
 * an action coming from another player.
 * @param {object} state - The state to restore.
 * @param {Array} deltalog - A log delta.
 */ const $b0ae1e6bca8d95a9$export$df995fae86a55f06 = (state, deltalog)=>({
        type: $b0ae1e6bca8d95a9$export$882b5998b3b9117c,
        state: state,
        deltalog: deltalog,
        clientOnly: true
    });
/**
 * Used to reset the game state.
 * @param {object} state - The initial state.
 */ const $b0ae1e6bca8d95a9$export$3b14a55fb2447963 = (state)=>({
        type: $b0ae1e6bca8d95a9$export$953cecd6e717a553,
        state: state,
        clientOnly: true
    });
/**
 * Used to undo the last move.
 * @param {string}  playerID - The ID of the player making this action.
 * @param {string}  credentials - (optional) The credentials for the player making this action.
 */ const $b0ae1e6bca8d95a9$export$90a7f3efeed30595 = (playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$35e795649ee09318,
        payload: {
            type: null,
            args: null,
            playerID: playerID,
            credentials: credentials
        }
    });
/**
 * Used to redo the last undone move.
 * @param {string}  playerID - The ID of the player making this action.
 * @param {string}  credentials - (optional) The credentials for the player making this action.
 */ const $b0ae1e6bca8d95a9$export$efccba1c4a2ef57b = (playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$db202ddc8be9136,
        payload: {
            type: null,
            args: null,
            playerID: playerID,
            credentials: credentials
        }
    });
/**
 * Allows plugins to define their own actions and intercept them.
 */ const $b0ae1e6bca8d95a9$var$plugin = (type, args, playerID, credentials)=>({
        type: $b0ae1e6bca8d95a9$export$2d1720544b23b823,
        payload: {
            type: type,
            args: args,
            playerID: playerID,
            credentials: credentials
        }
    });
/**
 * Private action used to strip transient metadata (e.g. errors) from the game
 * state.
 */ const $b0ae1e6bca8d95a9$export$43caf9889c228507 = ()=>({
        type: $b0ae1e6bca8d95a9$export$ffb5f4729a158638
    });
var $b0ae1e6bca8d95a9$export$ebd11618f299a286 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    makeMove: $b0ae1e6bca8d95a9$export$ef35774e6d314e91,
    gameEvent: $b0ae1e6bca8d95a9$export$39b482c5e57630a8,
    automaticGameEvent: $b0ae1e6bca8d95a9$var$automaticGameEvent,
    sync: $b0ae1e6bca8d95a9$export$2408f22a0fab9ae5,
    patch: $b0ae1e6bca8d95a9$export$4a5767248b18ef41,
    update: $b0ae1e6bca8d95a9$export$df995fae86a55f06,
    reset: $b0ae1e6bca8d95a9$export$3b14a55fb2447963,
    undo: $b0ae1e6bca8d95a9$export$90a7f3efeed30595,
    redo: $b0ae1e6bca8d95a9$export$efccba1c4a2ef57b,
    plugin: $b0ae1e6bca8d95a9$var$plugin,
    stripTransients: $b0ae1e6bca8d95a9$export$43caf9889c228507
});
/**
 * Moves can return this when they want to indicate
 * that the combination of arguments is illegal and
 * the move ought to be discarded.
 */ const $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5 = 'INVALID_MOVE';
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Plugin that allows using Immer to make immutable changes
 * to G by just mutating it.
 */ const $b0ae1e6bca8d95a9$var$ImmerPlugin = {
    name: 'plugin-immer',
    fnWrap: (move)=>(context, ...args)=>{
            let isInvalid = false;
            const newG = (0, $i4CZ2.default)(context.G, (G)=>{
                const result = move({
                    ...context,
                    G: G
                }, ...args);
                if (result === $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5) {
                    isInvalid = true;
                    return;
                }
                return result;
            });
            if (isInvalid) return $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5;
            return newG;
        }
};
var $b0ae1e6bca8d95a9$export$2329c99376c9d0a4;
(function(GameMethod) {
    GameMethod["MOVE"] = "MOVE";
    GameMethod["GAME_ON_END"] = "GAME_ON_END";
    GameMethod["PHASE_ON_BEGIN"] = "PHASE_ON_BEGIN";
    GameMethod["PHASE_ON_END"] = "PHASE_ON_END";
    GameMethod["TURN_ON_BEGIN"] = "TURN_ON_BEGIN";
    GameMethod["TURN_ON_MOVE"] = "TURN_ON_MOVE";
    GameMethod["TURN_ON_END"] = "TURN_ON_END";
})($b0ae1e6bca8d95a9$export$2329c99376c9d0a4 || ($b0ae1e6bca8d95a9$export$2329c99376c9d0a4 = {}));
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ var $b0ae1e6bca8d95a9$var$Errors;
(function(Errors) {
    Errors["CalledOutsideHook"] = "Events must be called from moves or the `onBegin`, `onEnd`, and `onMove` hooks.\nThis error probably means you called an event from other game code, like an `endIf` trigger or one of the `turn.order` methods.";
    Errors["EndTurnInOnEnd"] = "`endTurn` is disallowed in `onEnd` hooks \u2014 the turn is already ending.";
    Errors["MaxTurnEndings"] = "Maximum number of turn endings exceeded for this update.\nThis likely means game code is triggering an infinite loop.";
    Errors["PhaseEventInOnEnd"] = "`setPhase` & `endPhase` are disallowed in a phase\u2019s `onEnd` hook \u2014 the phase is already ending.\nIf you\u2019re trying to dynamically choose the next phase when a phase ends, use the phase\u2019s `next` trigger.";
    Errors["StageEventInOnEnd"] = "`setStage`, `endStage` & `setActivePlayers` are disallowed in `onEnd` hooks.";
    Errors["StageEventInPhaseBegin"] = "`setStage`, `endStage` & `setActivePlayers` are disallowed in a phase\u2019s `onBegin` hook.\nUse `setActivePlayers` in a `turn.onBegin` hook or declare stages with `turn.activePlayers` instead.";
    Errors["StageEventInTurnBegin"] = "`setStage` & `endStage` are disallowed in `turn.onBegin`.\nUse `setActivePlayers` or declare stages with `turn.activePlayers` instead.";
})($b0ae1e6bca8d95a9$var$Errors || ($b0ae1e6bca8d95a9$var$Errors = {}));
/**
 * Events
 */ class $b0ae1e6bca8d95a9$var$Events {
    constructor(flow, ctx, playerID){
        this.flow = flow;
        this.playerID = playerID;
        this.dispatch = [];
        this.initialTurn = ctx.turn;
        this.updateTurnContext(ctx, undefined);
        // This is an arbitrarily large upper threshold, which could be made
        // configurable via a game option if the need arises.
        this.maxEndedTurnsPerAction = ctx.numPlayers * 100;
    }
    api() {
        const events = {
            _private: this
        };
        for (const type of this.flow.eventNames)events[type] = (...args)=>{
            this.dispatch.push({
                type: type,
                args: args,
                phase: this.currentPhase,
                turn: this.currentTurn,
                calledFrom: this.currentMethod,
                // Used to capture a stack trace in case it is needed later.
                error: new Error('Events Plugin Error')
            });
        };
        return events;
    }
    isUsed() {
        return this.dispatch.length > 0;
    }
    updateTurnContext(ctx, methodType) {
        this.currentPhase = ctx.phase;
        this.currentTurn = ctx.turn;
        this.currentMethod = methodType;
    }
    unsetCurrentMethod() {
        this.currentMethod = undefined;
    }
    /**
     * Updates ctx with the triggered events.
     * @param {object} state - The state object { G, ctx }.
     */ update(state) {
        const initialState = state;
        const stateWithError = ({ stack: stack }, message)=>({
                ...initialState,
                plugins: {
                    ...initialState.plugins,
                    events: {
                        ...initialState.plugins.events,
                        data: {
                            error: message + '\n' + stack
                        }
                    }
                }
            });
        EventQueue: for(let i = 0; i < this.dispatch.length; i++){
            const event = this.dispatch[i];
            const turnHasEnded = event.turn !== state.ctx.turn;
            // This protects against potential infinite loops if specific events are called on hooks.
            // The moment we exceed the defined threshold, we just bail out of all phases.
            const endedTurns = this.currentTurn - this.initialTurn;
            if (endedTurns >= this.maxEndedTurnsPerAction) return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.MaxTurnEndings);
            if (event.calledFrom === undefined) return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.CalledOutsideHook);
            // Stop processing events once the game has finished.
            if (state.ctx.gameover) break EventQueue;
            switch(event.type){
                case 'endStage':
                case 'setStage':
                case 'setActivePlayers':
                    switch(event.calledFrom){
                        // Disallow all stage events in onEnd and phase.onBegin hooks.
                        case $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.TURN_ON_END:
                        case $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.PHASE_ON_END:
                            return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.StageEventInOnEnd);
                        case $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.PHASE_ON_BEGIN:
                            return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.StageEventInPhaseBegin);
                        // Disallow setStage & endStage in turn.onBegin hooks.
                        case $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.TURN_ON_BEGIN:
                            if (event.type === 'setActivePlayers') break;
                            return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.StageEventInTurnBegin);
                    }
                    // If the turn already ended, don't try to process stage events.
                    if (turnHasEnded) continue EventQueue;
                    break;
                case 'endTurn':
                    if (event.calledFrom === $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.TURN_ON_END || event.calledFrom === $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.PHASE_ON_END) return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.EndTurnInOnEnd);
                    // If the turn already ended some other way,
                    // don't try to end the turn again.
                    if (turnHasEnded) continue EventQueue;
                    break;
                case 'endPhase':
                case 'setPhase':
                    if (event.calledFrom === $b0ae1e6bca8d95a9$export$2329c99376c9d0a4.PHASE_ON_END) return stateWithError(event.error, $b0ae1e6bca8d95a9$var$Errors.PhaseEventInOnEnd);
                    // If the phase already ended some other way,
                    // don't try to end the phase again.
                    if (event.phase !== state.ctx.phase) continue EventQueue;
                    break;
            }
            const action = $b0ae1e6bca8d95a9$var$automaticGameEvent(event.type, event.args, this.playerID);
            state = this.flow.processEvent(state, action);
        }
        return state;
    }
}
/*
 * Copyright 2020 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ const $b0ae1e6bca8d95a9$var$EventsPlugin = {
    name: 'events',
    noClient: ({ api: api })=>api._private.isUsed(),
    isInvalid: ({ data: data })=>data.error || false,
    // Update the events plugin’s internal turn context each time a move
    // or hook is called. This allows events called after turn or phase
    // endings to dispatch the current turn and phase correctly.
    fnWrap: (method, methodType)=>(context, ...args)=>{
            const api = context.events;
            if (api) api._private.updateTurnContext(context.ctx, methodType);
            const G = method(context, ...args);
            if (api) api._private.unsetCurrentMethod();
            return G;
        },
    dangerouslyFlushRawState: ({ state: state, api: api })=>api._private.update(state),
    api: ({ game: game, ctx: ctx, playerID: playerID })=>new $b0ae1e6bca8d95a9$var$Events(game.flow, ctx, playerID).api()
};
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Plugin that makes it possible to add metadata to log entries.
 * During a move, you can set metadata using ctx.log.setMetadata and it will be
 * available on the log entry for that move.
 */ const $b0ae1e6bca8d95a9$var$LogPlugin = {
    name: 'log',
    flush: ()=>({}),
    api: ({ data: data })=>{
        return {
            setMetadata: (metadata)=>{
                data.metadata = metadata;
            }
        };
    },
    setup: ()=>({})
};
/**
 * Check if a value can be serialized (e.g. using `JSON.stringify`).
 * Adapted from: https://stackoverflow.com/a/30712764/3829557
 */ function $b0ae1e6bca8d95a9$var$isSerializable(value) {
    // Primitives are OK.
    if (value === undefined || value === null || typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string') return true;
    // A non-primitive value that is neither a POJO or an array cannot be serialized.
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0f00e0d907a420b6$exports)))(value) && !Array.isArray(value)) return false;
    // Recurse entries if the value is an object or array.
    for(const key in value){
        if (!$b0ae1e6bca8d95a9$var$isSerializable(value[key])) return false;
    }
    return true;
}
/**
 * Plugin that checks whether state is serializable, in order to avoid
 * network serialization bugs.
 */ const $b0ae1e6bca8d95a9$var$SerializablePlugin = {
    name: 'plugin-serializable',
    fnWrap: (move)=>(context, ...args)=>{
            const result = move(context, ...args);
            return result;
        }
};
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ const $b0ae1e6bca8d95a9$var$production = true;
const $b0ae1e6bca8d95a9$var$logfn = $b0ae1e6bca8d95a9$var$production ? ()=>{} : (...msg)=>console.log(...msg);
const $b0ae1e6bca8d95a9$var$errorfn = (...msg)=>console.error(...msg);
function $b0ae1e6bca8d95a9$export$23f2a1d2818174ef(msg) {
    $b0ae1e6bca8d95a9$var$logfn(`INFO: ${msg}`);
}
function $b0ae1e6bca8d95a9$export$f1e1789686576879(error) {
    $b0ae1e6bca8d95a9$var$errorfn('ERROR:', error);
}
/*
 * Copyright 2018 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * List of plugins that are always added.
 */ const $b0ae1e6bca8d95a9$var$CORE_PLUGINS = [
    $b0ae1e6bca8d95a9$var$ImmerPlugin,
    (0, $a1e355d2fa1df224$export$db202ddc8be9136),
    $b0ae1e6bca8d95a9$var$LogPlugin,
    $b0ae1e6bca8d95a9$var$SerializablePlugin
];
const $b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS = [
    ...$b0ae1e6bca8d95a9$var$CORE_PLUGINS,
    $b0ae1e6bca8d95a9$var$EventsPlugin
];
/**
 * Allow plugins to intercept actions and process them.
 */ const $b0ae1e6bca8d95a9$export$dda1d9f60106f0e9 = (state, action, opts)=>{
    // TODO(#723): Extend error handling to plugins.
    opts.game.plugins.filter((plugin)=>plugin.action !== undefined).filter((plugin)=>plugin.name === action.payload.type).forEach((plugin)=>{
        const name = plugin.name;
        const pluginState = state.plugins[name] || {
            data: {}
        };
        const data = plugin.action(pluginState.data, action.payload);
        state = {
            ...state,
            plugins: {
                ...state.plugins,
                [name]: {
                    ...pluginState,
                    data: data
                }
            }
        };
    });
    return state;
};
/**
 * The APIs created by various plugins are stored in the plugins
 * section of the state object:
 *
 * {
 *   G: {},
 *   ctx: {},
 *   plugins: {
 *     plugin-a: {
 *       data: {},  // this is generated by the plugin at Setup / Flush.
 *       api: {},   // this is ephemeral and generated by Enhance.
 *     }
 *   }
 * }
 *
 * This function retrieves plugin APIs and returns them as an object
 * for consumption as used by move contexts.
 */ const $b0ae1e6bca8d95a9$export$407448d2b89b1813 = ({ plugins: plugins })=>Object.entries(plugins || {}).reduce((apis, [name, { api: api }])=>{
        apis[name] = api;
        return apis;
    }, {});
/**
 * Applies the provided plugins to the given move / flow function.
 *
 * @param methodToWrap - The move function or hook to apply the plugins to.
 * @param methodType - The type of the move or hook being wrapped.
 * @param plugins - The list of plugins.
 */ const $b0ae1e6bca8d95a9$export$d66501df72047452 = (methodToWrap, methodType, plugins)=>{
    return [
        ...$b0ae1e6bca8d95a9$var$CORE_PLUGINS,
        ...plugins,
        $b0ae1e6bca8d95a9$var$EventsPlugin
    ].filter((plugin)=>plugin.fnWrap !== undefined).reduce((method, { fnWrap: fnWrap })=>fnWrap(method, methodType), methodToWrap);
};
/**
 * Allows the plugin to generate its initial state.
 */ const $b0ae1e6bca8d95a9$export$625550452a3fa3ec = (state, opts)=>{
    [
        ...$b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS,
        ...opts.game.plugins
    ].filter((plugin)=>plugin.setup !== undefined).forEach((plugin)=>{
        const name = plugin.name;
        const data = plugin.setup({
            G: state.G,
            ctx: state.ctx,
            game: opts.game
        });
        state = {
            ...state,
            plugins: {
                ...state.plugins,
                [name]: {
                    data: data
                }
            }
        };
    });
    return state;
};
/**
 * Invokes the plugin before a move or event.
 * The API that the plugin generates is stored inside
 * the `plugins` section of the state (which is subsequently
 * merged into ctx).
 */ const $b0ae1e6bca8d95a9$export$a9c23c6ac3fc3eca = (state, opts)=>{
    [
        ...$b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS,
        ...opts.game.plugins
    ].filter((plugin)=>plugin.api !== undefined).forEach((plugin)=>{
        const name = plugin.name;
        const pluginState = state.plugins[name] || {
            data: {}
        };
        const api = plugin.api({
            G: state.G,
            ctx: state.ctx,
            data: pluginState.data,
            game: opts.game,
            playerID: opts.playerID
        });
        state = {
            ...state,
            plugins: {
                ...state.plugins,
                [name]: {
                    ...pluginState,
                    api: api
                }
            }
        };
    });
    return state;
};
/**
 * Allows plugins to update their state after a move / event.
 */ const $b0ae1e6bca8d95a9$var$Flush = (state, opts)=>{
    // We flush the events plugin first, then custom plugins and the core plugins.
    // This means custom plugins cannot use the events API but will be available in event hooks.
    // Note that plugins are flushed in reverse, to allow custom plugins calling each other.
    [
        ...$b0ae1e6bca8d95a9$var$CORE_PLUGINS,
        ...opts.game.plugins,
        $b0ae1e6bca8d95a9$var$EventsPlugin
    ].reverse().forEach((plugin)=>{
        const name = plugin.name;
        const pluginState = state.plugins[name] || {
            data: {}
        };
        if (plugin.flush) {
            const newData = plugin.flush({
                G: state.G,
                ctx: state.ctx,
                game: opts.game,
                api: pluginState.api,
                data: pluginState.data
            });
            state = {
                ...state,
                plugins: {
                    ...state.plugins,
                    [plugin.name]: {
                        data: newData
                    }
                }
            };
        } else if (plugin.dangerouslyFlushRawState) {
            state = plugin.dangerouslyFlushRawState({
                state: state,
                game: opts.game,
                api: pluginState.api,
                data: pluginState.data
            });
            // Remove everything other than data.
            const data = state.plugins[name].data;
            state = {
                ...state,
                plugins: {
                    ...state.plugins,
                    [plugin.name]: {
                        data: data
                    }
                }
            };
        }
    });
    return state;
};
/**
 * Allows plugins to indicate if they should not be materialized on the client.
 * This will cause the client to discard the state update and wait for the
 * master instead.
 */ const $b0ae1e6bca8d95a9$export$a07804094c3ecf2d = (state, opts)=>{
    return [
        ...$b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS,
        ...opts.game.plugins
    ].filter((plugin)=>plugin.noClient !== undefined).map((plugin)=>{
        const name = plugin.name;
        const pluginState = state.plugins[name];
        if (pluginState) return plugin.noClient({
            G: state.G,
            ctx: state.ctx,
            game: opts.game,
            api: pluginState.api,
            data: pluginState.data
        });
        return false;
    }).includes(true);
};
/**
 * Allows plugins to indicate if the entire action should be thrown out
 * as invalid. This will cancel the entire state update.
 */ const $b0ae1e6bca8d95a9$var$IsInvalid = (state, opts)=>{
    const firstInvalidReturn = [
        ...$b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS,
        ...opts.game.plugins
    ].filter((plugin)=>plugin.isInvalid !== undefined).map((plugin)=>{
        const { name: name } = plugin;
        const pluginState = state.plugins[name];
        const message = plugin.isInvalid({
            G: state.G,
            ctx: state.ctx,
            game: opts.game,
            data: pluginState && pluginState.data
        });
        return message ? {
            plugin: name,
            message: message
        } : false;
    }).find((value)=>value);
    return firstInvalidReturn || false;
};
/**
 * Update plugin state after move/event & check if plugins consider the update to be valid.
 * @returns Tuple of `[updatedState]` or `[originalState, invalidError]`.
 */ const $b0ae1e6bca8d95a9$export$9e5f44173e64f162 = (state, opts)=>{
    const updatedState = $b0ae1e6bca8d95a9$var$Flush(state, opts);
    const isInvalid = $b0ae1e6bca8d95a9$var$IsInvalid(updatedState, opts);
    if (!isInvalid) return [
        updatedState
    ];
    const { plugin: plugin, message: message } = isInvalid;
    $b0ae1e6bca8d95a9$export$f1e1789686576879(`${plugin} plugin declared action invalid:\n${message}`);
    return [
        state,
        isInvalid
    ];
};
/**
 * Allows plugins to customize their data for specific players.
 * For example, a plugin may want to share no data with the client, or
 * want to keep some player data secret from opponents.
 */ const $b0ae1e6bca8d95a9$export$d141bba7fdc215a3 = ({ G: G, ctx: ctx, plugins: plugins = {} }, { game: game, playerID: playerID })=>{
    [
        ...$b0ae1e6bca8d95a9$var$DEFAULT_PLUGINS,
        ...game.plugins
    ].forEach(({ name: name, playerView: playerView })=>{
        if (!playerView) return;
        const { data: data } = plugins[name] || {
            data: {}
        };
        const newData = playerView({
            G: G,
            ctx: ctx,
            game: game,
            data: data,
            playerID: playerID
        });
        plugins = {
            ...plugins,
            [name]: {
                data: newData
            }
        };
    });
    return plugins;
};
/**
 * Adjust the given options to use the new minMoves/maxMoves if a legacy moveLimit was given
 * @param options The options object to apply backwards compatibility to
 * @param enforceMinMoves Use moveLimit to set both minMoves and maxMoves
 */ function $b0ae1e6bca8d95a9$export$8b22cf2602fb60ce(options, enforceMinMoves = false) {
    if (options.moveLimit) {
        if (enforceMinMoves) options.minMoves = options.moveLimit;
        options.maxMoves = options.moveLimit;
        delete options.moveLimit;
    }
}
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ function $b0ae1e6bca8d95a9$export$db3b6bfb95261072(ctx, arg) {
    let activePlayers = {};
    let _prevActivePlayers = [];
    let _nextActivePlayers = null;
    let _activePlayersMinMoves = {};
    let _activePlayersMaxMoves = {};
    if (Array.isArray(arg)) {
        // support a simple array of player IDs as active players
        const value = {};
        arg.forEach((v)=>value[v] = $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL);
        activePlayers = value;
    } else {
        // process active players argument object
        // stages previously did not enforce minMoves, this behaviour is kept intentionally
        $b0ae1e6bca8d95a9$export$8b22cf2602fb60ce(arg);
        if (arg.next) _nextActivePlayers = arg.next;
        if (arg.revert) _prevActivePlayers = [
            ...ctx._prevActivePlayers,
            {
                activePlayers: ctx.activePlayers,
                _activePlayersMinMoves: ctx._activePlayersMinMoves,
                _activePlayersMaxMoves: ctx._activePlayersMaxMoves,
                _activePlayersNumMoves: ctx._activePlayersNumMoves
            }
        ];
        if (arg.currentPlayer !== undefined) $b0ae1e6bca8d95a9$var$ApplyActivePlayerArgument(activePlayers, _activePlayersMinMoves, _activePlayersMaxMoves, ctx.currentPlayer, arg.currentPlayer);
        if (arg.others !== undefined) for(let i = 0; i < ctx.playOrder.length; i++){
            const id = ctx.playOrder[i];
            if (id !== ctx.currentPlayer) $b0ae1e6bca8d95a9$var$ApplyActivePlayerArgument(activePlayers, _activePlayersMinMoves, _activePlayersMaxMoves, id, arg.others);
        }
        if (arg.all !== undefined) for(let i = 0; i < ctx.playOrder.length; i++){
            const id = ctx.playOrder[i];
            $b0ae1e6bca8d95a9$var$ApplyActivePlayerArgument(activePlayers, _activePlayersMinMoves, _activePlayersMaxMoves, id, arg.all);
        }
        if (arg.value) for(const id in arg.value)$b0ae1e6bca8d95a9$var$ApplyActivePlayerArgument(activePlayers, _activePlayersMinMoves, _activePlayersMaxMoves, id, arg.value[id]);
        if (arg.minMoves) {
            for(const id in activePlayers)if (_activePlayersMinMoves[id] === undefined) _activePlayersMinMoves[id] = arg.minMoves;
        }
        if (arg.maxMoves) {
            for(const id in activePlayers)if (_activePlayersMaxMoves[id] === undefined) _activePlayersMaxMoves[id] = arg.maxMoves;
        }
    }
    if (Object.keys(activePlayers).length === 0) activePlayers = null;
    if (Object.keys(_activePlayersMinMoves).length === 0) _activePlayersMinMoves = null;
    if (Object.keys(_activePlayersMaxMoves).length === 0) _activePlayersMaxMoves = null;
    const _activePlayersNumMoves = {};
    for(const id in activePlayers)_activePlayersNumMoves[id] = 0;
    return {
        ...ctx,
        activePlayers: activePlayers,
        _activePlayersMinMoves: _activePlayersMinMoves,
        _activePlayersMaxMoves: _activePlayersMaxMoves,
        _activePlayersNumMoves: _activePlayersNumMoves,
        _prevActivePlayers: _prevActivePlayers,
        _nextActivePlayers: _nextActivePlayers
    };
}
/**
 * Update activePlayers, setting it to previous, next or null values
 * when it becomes empty.
 * @param ctx
 */ function $b0ae1e6bca8d95a9$export$4368d992c4eafac0(ctx) {
    let { activePlayers: activePlayers, _activePlayersMinMoves: _activePlayersMinMoves, _activePlayersMaxMoves: _activePlayersMaxMoves, _activePlayersNumMoves: _activePlayersNumMoves, _prevActivePlayers: _prevActivePlayers, _nextActivePlayers: _nextActivePlayers } = ctx;
    if (activePlayers && Object.keys(activePlayers).length === 0) {
        if (_nextActivePlayers) {
            ctx = $b0ae1e6bca8d95a9$export$db3b6bfb95261072(ctx, _nextActivePlayers);
            ({ activePlayers: activePlayers, _activePlayersMinMoves: _activePlayersMinMoves, _activePlayersMaxMoves: _activePlayersMaxMoves, _activePlayersNumMoves: _activePlayersNumMoves, _prevActivePlayers: _prevActivePlayers } = ctx);
        } else if (_prevActivePlayers.length > 0) {
            const lastIndex = _prevActivePlayers.length - 1;
            ({ activePlayers: activePlayers, _activePlayersMinMoves: _activePlayersMinMoves, _activePlayersMaxMoves: _activePlayersMaxMoves, _activePlayersNumMoves: _activePlayersNumMoves } = _prevActivePlayers[lastIndex]);
            _prevActivePlayers = _prevActivePlayers.slice(0, lastIndex);
        } else {
            activePlayers = null;
            _activePlayersMinMoves = null;
            _activePlayersMaxMoves = null;
        }
    }
    return {
        ...ctx,
        activePlayers: activePlayers,
        _activePlayersMinMoves: _activePlayersMinMoves,
        _activePlayersMaxMoves: _activePlayersMaxMoves,
        _activePlayersNumMoves: _activePlayersNumMoves,
        _prevActivePlayers: _prevActivePlayers
    };
}
/**
 * Apply an active player argument to the given player ID
 * @param {Object} activePlayers
 * @param {Object} _activePlayersMinMoves
 * @param {Object} _activePlayersMaxMoves
 * @param {String} playerID The player to apply the parameter to
 * @param {(String|Object)} arg An active player argument
 */ function $b0ae1e6bca8d95a9$var$ApplyActivePlayerArgument(activePlayers, _activePlayersMinMoves, _activePlayersMaxMoves, playerID, arg) {
    if (typeof arg !== 'object' || arg === $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL) arg = {
        stage: arg
    };
    if (arg.stage !== undefined) {
        // stages previously did not enforce minMoves, this behaviour is kept intentionally
        $b0ae1e6bca8d95a9$export$8b22cf2602fb60ce(arg);
        activePlayers[playerID] = arg.stage;
        if (arg.minMoves) _activePlayersMinMoves[playerID] = arg.minMoves;
        if (arg.maxMoves) _activePlayersMaxMoves[playerID] = arg.maxMoves;
    }
}
/**
 * Converts a playOrderPos index into its value in playOrder.
 * @param {Array} playOrder - An array of player ID's.
 * @param {number} playOrderPos - An index into the above.
 */ function $b0ae1e6bca8d95a9$var$getCurrentPlayer(playOrder, playOrderPos) {
    // convert to string in case playOrder is set to number[]
    return playOrder[playOrderPos] + '';
}
/**
 * Called at the start of a turn to initialize turn order state.
 *
 * TODO: This is called inside StartTurn, which is called from
 * both UpdateTurn and StartPhase (so it's called at the beginning
 * of a new phase as well as between turns). We should probably
 * split it into two.
 */ function $b0ae1e6bca8d95a9$export$9bb611d729802a56(state, turn) {
    let { G: G, ctx: ctx } = state;
    const { numPlayers: numPlayers } = ctx;
    const pluginAPIs = $b0ae1e6bca8d95a9$export$407448d2b89b1813(state);
    const context = {
        ...pluginAPIs,
        G: G,
        ctx: ctx
    };
    const order = turn.order;
    let playOrder = [
        ...Array.from({
            length: numPlayers
        })
    ].map((_, i)=>i + '');
    if (order.playOrder !== undefined) playOrder = order.playOrder(context);
    const playOrderPos = order.first(context);
    const posType = typeof playOrderPos;
    if (posType !== 'number') $b0ae1e6bca8d95a9$export$f1e1789686576879(`invalid value returned by turn.order.first \u{2014} expected number got ${posType} \u{201C}${playOrderPos}\u{201D}.`);
    const currentPlayer = $b0ae1e6bca8d95a9$var$getCurrentPlayer(playOrder, playOrderPos);
    ctx = {
        ...ctx,
        currentPlayer: currentPlayer,
        playOrderPos: playOrderPos,
        playOrder: playOrder
    };
    ctx = $b0ae1e6bca8d95a9$export$db3b6bfb95261072(ctx, turn.activePlayers || {});
    return ctx;
}
/**
 * Called at the end of each turn to update the turn order state.
 * @param {object} G - The game object G.
 * @param {object} ctx - The game object ctx.
 * @param {object} turn - A turn object for this phase.
 * @param {string} endTurnArg - An optional argument to endTurn that
                                may specify the next player.
 */ function $b0ae1e6bca8d95a9$export$3a6d5c9ae78a2c08(state, currentPlayer, turn, endTurnArg) {
    const order = turn.order;
    let { G: G, ctx: ctx } = state;
    let playOrderPos = ctx.playOrderPos;
    let endPhase = false;
    if (endTurnArg && endTurnArg !== true) {
        if (typeof endTurnArg !== 'object') $b0ae1e6bca8d95a9$export$f1e1789686576879(`invalid argument to endTurn: ${endTurnArg}`);
        Object.keys(endTurnArg).forEach((arg)=>{
            switch(arg){
                case 'remove':
                    currentPlayer = $b0ae1e6bca8d95a9$var$getCurrentPlayer(ctx.playOrder, playOrderPos);
                    break;
                case 'next':
                    playOrderPos = ctx.playOrder.indexOf(endTurnArg.next);
                    currentPlayer = endTurnArg.next;
                    break;
                default:
                    $b0ae1e6bca8d95a9$export$f1e1789686576879(`invalid argument to endTurn: ${arg}`);
            }
        });
    } else {
        const pluginAPIs = $b0ae1e6bca8d95a9$export$407448d2b89b1813(state);
        const context = {
            ...pluginAPIs,
            G: G,
            ctx: ctx
        };
        const t = order.next(context);
        const type = typeof t;
        if (t !== undefined && type !== 'number') $b0ae1e6bca8d95a9$export$f1e1789686576879(`invalid value returned by turn.order.next \u{2014} expected number or undefined got ${type} \u{201C}${t}\u{201D}.`);
        if (t === undefined) endPhase = true;
        else {
            playOrderPos = t;
            currentPlayer = $b0ae1e6bca8d95a9$var$getCurrentPlayer(ctx.playOrder, playOrderPos);
        }
    }
    ctx = {
        ...ctx,
        playOrderPos: playOrderPos,
        currentPlayer: currentPlayer
    };
    return {
        endPhase: endPhase,
        ctx: ctx
    };
}
/**
 * Set of different turn orders possible in a phase.
 * These are meant to be passed to the `turn` setting
 * in the flow objects.
 *
 * Each object defines the first player when the phase / game
 * begins, and also a function `next` to determine who the
 * next player is when the turn ends.
 *
 * The phase ends if next() returns undefined.
 */ const $b0ae1e6bca8d95a9$export$971d5caa766a69d7 = {
    /**
     * DEFAULT
     *
     * The default round-robin turn order.
     */ DEFAULT: {
        first: ({ ctx: ctx })=>ctx.turn === 0 ? ctx.playOrderPos : (ctx.playOrderPos + 1) % ctx.playOrder.length,
        next: ({ ctx: ctx })=>(ctx.playOrderPos + 1) % ctx.playOrder.length
    },
    /**
     * RESET
     *
     * Similar to DEFAULT, but starts from 0 each time.
     */ RESET: {
        first: ()=>0,
        next: ({ ctx: ctx })=>(ctx.playOrderPos + 1) % ctx.playOrder.length
    },
    /**
     * CONTINUE
     *
     * Similar to DEFAULT, but starts with the player who ended the last phase.
     */ CONTINUE: {
        first: ({ ctx: ctx })=>ctx.playOrderPos,
        next: ({ ctx: ctx })=>(ctx.playOrderPos + 1) % ctx.playOrder.length
    },
    /**
     * ONCE
     *
     * Another round-robin turn order, but goes around just once.
     * The phase ends after all players have played.
     */ ONCE: {
        first: ()=>0,
        next: ({ ctx: ctx })=>{
            if (ctx.playOrderPos < ctx.playOrder.length - 1) return ctx.playOrderPos + 1;
        }
    },
    /**
     * CUSTOM
     *
     * Identical to DEFAULT, but also sets playOrder at the
     * beginning of the phase.
     *
     * @param {Array} playOrder - The play order.
     */ CUSTOM: (playOrder)=>({
            playOrder: ()=>playOrder,
            first: ()=>0,
            next: ({ ctx: ctx })=>(ctx.playOrderPos + 1) % ctx.playOrder.length
        }),
    /**
     * CUSTOM_FROM
     *
     * Identical to DEFAULT, but also sets playOrder at the
     * beginning of the phase to a value specified by a field
     * in G.
     *
     * @param {string} playOrderField - Field in G.
     */ CUSTOM_FROM: (playOrderField)=>({
            playOrder: ({ G: G })=>G[playOrderField],
            first: ()=>0,
            next: ({ ctx: ctx })=>(ctx.playOrderPos + 1) % ctx.playOrder.length
        })
};
const $b0ae1e6bca8d95a9$export$25ce5a424b770e84 = {
    NULL: null
};
const $b0ae1e6bca8d95a9$export$e7094788287c5e9b = {
    /**
     * ALL
     *
     * The turn stays with one player, but any player can play (in any order)
     * until the phase ends.
     */ ALL: {
        all: $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL
    },
    /**
     * ALL_ONCE
     *
     * The turn stays with one player, but any player can play (once, and in any order).
     * This is typically used in a phase where you want to elicit a response
     * from every player in the game.
     */ ALL_ONCE: {
        all: $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL,
        minMoves: 1,
        maxMoves: 1
    },
    /**
     * OTHERS
     *
     * The turn stays with one player, and every *other* player can play (in any order)
     * until the phase ends.
     */ OTHERS: {
        others: $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL
    },
    /**
     * OTHERS_ONCE
     *
     * The turn stays with one player, and every *other* player can play (once, and in any order).
     * This is typically used in a phase where you want to elicit a response
     * from every *other* player in the game.
     */ OTHERS_ONCE: {
        others: $b0ae1e6bca8d95a9$export$25ce5a424b770e84.NULL,
        minMoves: 1,
        maxMoves: 1
    }
};



var $06105d02a3bc31a3$exports = {};
"use strict";
Object.defineProperty($06105d02a3bc31a3$exports, "__esModule", {
    value: true
});
$06105d02a3bc31a3$exports.createTests = $06105d02a3bc31a3$exports.createPatch = $06105d02a3bc31a3$exports.applyPatch = void 0;
var $85fc210bf17c1065$exports = {};
"use strict";
Object.defineProperty($85fc210bf17c1065$exports, "__esModule", {
    value: true
});
$85fc210bf17c1065$exports.Pointer = void 0;
/**
Unescape token part of a JSON Pointer string

`token` should *not* contain any '/' characters.

> Evaluation of each reference token begins by decoding any escaped
> character sequence.  This is performed by first transforming any
> occurrence of the sequence '~1' to '/', and then transforming any
> occurrence of the sequence '~0' to '~'.  By performing the
> substitutions in this order, an implementation avoids the error of
> turning '~01' first into '~1' and then into '/', which would be
> incorrect (the string '~01' correctly becomes '~1' after
> transformation).

Here's my take:

~1 is unescaped with higher priority than ~0 because it is a lower-order escape character.
I say "lower order" because '/' needs escaping due to the JSON Pointer serialization technique.
Whereas, '~' is escaped because escaping '/' uses the '~' character.
*/ function $85fc210bf17c1065$var$unescape(token) {
    return token.replace(/~1/g, '/').replace(/~0/g, '~');
}
/** Escape token part of a JSON Pointer string

> '~' needs to be encoded as '~0' and '/'
> needs to be encoded as '~1' when these characters appear in a
> reference token.

This is the exact inverse of `unescape()`, so the reverse replacements must take place in reverse order.
*/ function $85fc210bf17c1065$var$escape(token) {
    return token.replace(/~/g, '~0').replace(/\//g, '~1');
}
/**
JSON Pointer representation
*/ var $85fc210bf17c1065$var$Pointer = /** @class */ function() {
    function Pointer(tokens) {
        if (tokens === void 0) tokens = [
            ''
        ];
        this.tokens = tokens;
    }
    /**
    `path` *must* be a properly escaped string.
    */ Pointer.fromJSON = function(path) {
        var tokens = path.split('/').map($85fc210bf17c1065$var$unescape);
        if (tokens[0] !== '') throw new Error("Invalid JSON Pointer: " + path);
        return new Pointer(tokens);
    };
    Pointer.prototype.toString = function() {
        return this.tokens.map($85fc210bf17c1065$var$escape).join('/');
    };
    /**
    Returns an object with 'parent', 'key', and 'value' properties.
    In the special case that this Pointer's path == "",
    this object will be {parent: null, key: '', value: object}.
    Otherwise, parent and key will have the property such that parent[key] == value.
    */ Pointer.prototype.evaluate = function(object) {
        var parent = null;
        var key = '';
        var value = object;
        for(var i = 1, l = this.tokens.length; i < l; i++){
            parent = value;
            key = this.tokens[i];
            if (key == '__proto__' || key == 'constructor' || key == 'prototype') continue;
            // not sure if this the best way to handle non-existant paths...
            value = (parent || {})[key];
        }
        return {
            parent: parent,
            key: key,
            value: value
        };
    };
    Pointer.prototype.get = function(object) {
        return this.evaluate(object).value;
    };
    Pointer.prototype.set = function(object, value) {
        var cursor = object;
        for(var i = 1, l = this.tokens.length - 1, token = this.tokens[i]; i < l; i++)// not sure if this the best way to handle non-existant paths...
        cursor = (cursor || {})[token];
        if (cursor) cursor[this.tokens[this.tokens.length - 1]] = value;
    };
    Pointer.prototype.push = function(token) {
        // mutable
        this.tokens.push(token);
    };
    /**
    `token` should be a String. It'll be coerced to one anyway.
  
    immutable (shallowly)
    */ Pointer.prototype.add = function(token) {
        var tokens = this.tokens.concat(String(token));
        return new Pointer(tokens);
    };
    return Pointer;
}();
$85fc210bf17c1065$exports.Pointer = $85fc210bf17c1065$var$Pointer;


var $6c51edafdc58c647$exports = {};
"use strict";
var $6c51edafdc58c647$var$__extends = $6c51edafdc58c647$exports && $6c51edafdc58c647$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($6c51edafdc58c647$exports, "__esModule", {
    value: true
});
$6c51edafdc58c647$exports.apply = $6c51edafdc58c647$exports.InvalidOperationError = $6c51edafdc58c647$exports.test = $6c51edafdc58c647$exports.copy = $6c51edafdc58c647$exports.move = $6c51edafdc58c647$exports.replace = $6c51edafdc58c647$exports.remove = $6c51edafdc58c647$exports.add = $6c51edafdc58c647$exports.TestError = $6c51edafdc58c647$exports.MissingError = void 0;

var $662ee92c4c73578a$exports = {};
"use strict";
Object.defineProperty($662ee92c4c73578a$exports, "__esModule", {
    value: true
});
$662ee92c4c73578a$exports.clone = $662ee92c4c73578a$exports.objectType = $662ee92c4c73578a$exports.hasOwnProperty = void 0;
$662ee92c4c73578a$exports.hasOwnProperty = Object.prototype.hasOwnProperty;
function $662ee92c4c73578a$var$objectType(object) {
    if (object === undefined) return 'undefined';
    if (object === null) return 'null';
    if (Array.isArray(object)) return 'array';
    return typeof object;
}
$662ee92c4c73578a$exports.objectType = $662ee92c4c73578a$var$objectType;
function $662ee92c4c73578a$var$isNonPrimitive(value) {
    // loose-equality checking for null is faster than strict checking for each of null/undefined/true/false
    // checking null first, then calling typeof, is faster than vice-versa
    return value != null && typeof value == 'object';
}
/**
Recursively copy a value.

@param source - should be a JavaScript primitive, Array, Date, or (plain old) Object.
@returns copy of source where every Array and Object have been recursively
         reconstructed from their constituent elements
*/ function $662ee92c4c73578a$var$clone(source) {
    if (!$662ee92c4c73578a$var$isNonPrimitive(source)) // short-circuiting is faster than a single return
    return source;
    // x.constructor == Array is the fastest way to check if x is an Array
    if (source.constructor == Array) {
        // construction via imperative for-loop is faster than source.map(arrayVsObject)
        var length_1 = source.length;
        // setting the Array length during construction is faster than just `[]` or `new Array()`
        var arrayTarget = new Array(length_1);
        for(var i = 0; i < length_1; i++)arrayTarget[i] = $662ee92c4c73578a$var$clone(source[i]);
        return arrayTarget;
    }
    // Date
    if (source.constructor == Date) {
        var dateTarget = new Date(+source);
        return dateTarget;
    }
    // Object
    var objectTarget = {};
    // declaring the variable (with const) inside the loop is faster
    for(var key in source)// hasOwnProperty costs a bit of performance, but it's semantically necessary
    // using a global helper is MUCH faster than calling source.hasOwnProperty(key)
    if ($662ee92c4c73578a$exports.hasOwnProperty.call(source, key)) objectTarget[key] = $662ee92c4c73578a$var$clone(source[key]);
    return objectTarget;
}
$662ee92c4c73578a$exports.clone = $662ee92c4c73578a$var$clone;


var $83186f90232ecfe5$exports = {};
"use strict";
Object.defineProperty($83186f90232ecfe5$exports, "__esModule", {
    value: true
});
$83186f90232ecfe5$exports.diffAny = $83186f90232ecfe5$exports.diffObjects = $83186f90232ecfe5$exports.diffArrays = $83186f90232ecfe5$exports.intersection = $83186f90232ecfe5$exports.subtract = $83186f90232ecfe5$exports.isDestructive = void 0;

function $83186f90232ecfe5$var$isDestructive(_a) {
    var op = _a.op;
    return op === 'remove' || op === 'replace' || op === 'copy' || op === 'move';
}
$83186f90232ecfe5$exports.isDestructive = $83186f90232ecfe5$var$isDestructive;
/**
List the keys in `minuend` that are not in `subtrahend`.

A key is only considered if it is both 1) an own-property (o.hasOwnProperty(k))
of the object, and 2) has a value that is not undefined. This is to match JSON
semantics, where JSON object serialization drops keys with undefined values.

@param minuend Object of interest
@param subtrahend Object of comparison
@returns Array of keys that are in `minuend` but not in `subtrahend`.
*/ function $83186f90232ecfe5$var$subtract(minuend, subtrahend) {
    // initialize empty object; we only care about the keys, the values can be anything
    var obj = {};
    // build up obj with all the properties of minuend
    for(var add_key in minuend)if ($662ee92c4c73578a$exports.hasOwnProperty.call(minuend, add_key) && minuend[add_key] !== undefined) obj[add_key] = 1;
    // now delete all the properties of subtrahend from obj
    // (deleting a missing key has no effect)
    for(var del_key in subtrahend)if ($662ee92c4c73578a$exports.hasOwnProperty.call(subtrahend, del_key) && subtrahend[del_key] !== undefined) delete obj[del_key];
    // finally, extract whatever keys remain in obj
    return Object.keys(obj);
}
$83186f90232ecfe5$exports.subtract = $83186f90232ecfe5$var$subtract;
/**
List the keys that shared by all `objects`.

The semantics of what constitutes a "key" is described in {@link subtract}.

@param objects Array of objects to compare
@returns Array of keys that are in ("own-properties" of) every object in `objects`.
*/ function $83186f90232ecfe5$var$intersection(objects) {
    var length = objects.length;
    // prepare empty counter to keep track of how many objects each key occurred in
    var counter = {};
    // go through each object and increment the counter for each key in that object
    for(var i = 0; i < length; i++){
        var object = objects[i];
        for(var key in object)if ($662ee92c4c73578a$exports.hasOwnProperty.call(object, key) && object[key] !== undefined) counter[key] = (counter[key] || 0) + 1;
    }
    // now delete all keys from the counter that were not seen in every object
    for(var key in counter)if (counter[key] < length) delete counter[key];
    // finally, extract whatever keys remain in the counter
    return Object.keys(counter);
}
$83186f90232ecfe5$exports.intersection = $83186f90232ecfe5$var$intersection;
function $83186f90232ecfe5$var$isArrayAdd(array_operation) {
    return array_operation.op === 'add';
}
function $83186f90232ecfe5$var$isArrayRemove(array_operation) {
    return array_operation.op === 'remove';
}
function $83186f90232ecfe5$var$appendArrayOperation(base, operation) {
    return {
        // the new operation must be pushed on the end
        operations: base.operations.concat(operation),
        cost: base.cost + 1
    };
}
/**
Calculate the shortest sequence of operations to get from `input` to `output`,
using a dynamic programming implementation of the Levenshtein distance algorithm.

To get from the input ABC to the output AZ we could just delete all the input
and say "insert A, insert Z" and be done with it. That's what we do if the
input is empty. But we can be smarter.

          output
               A   Z
               -   -
          [0]  1   2
input A |  1  [0]  1
      B |  2  [1]  1
      C |  3   2  [2]

1) start at 0,0 (+0)
2) keep A (+0)
3) remove B (+1)
4) replace C with Z (+1)

If the `input` (source) is empty, they'll all be in the top row, resulting in an
array of 'add' operations.
If the `output` (target) is empty, everything will be in the left column,
resulting in an array of 'remove' operations.

@returns A list of add/remove/replace operations.
*/ function $83186f90232ecfe5$var$diffArrays(input, output, ptr, diff) {
    if (diff === void 0) diff = $83186f90232ecfe5$var$diffAny;
    // set up cost matrix (very simple initialization: just a map)
    var memo = {
        '0,0': {
            operations: [],
            cost: 0
        }
    };
    /**
    Calculate the cheapest sequence of operations required to get from
    input.slice(0, i) to output.slice(0, j).
    There may be other valid sequences with the same cost, but none cheaper.
  
    @param i The row in the layout above
    @param j The column in the layout above
    @returns An object containing a list of operations, along with the total cost
             of applying them (+1 for each add/remove/replace operation)
    */ function dist(i, j) {
        // memoized
        var memo_key = i + "," + j;
        var memoized = memo[memo_key];
        if (memoized === undefined) {
            // TODO: this !diff(...).length usage could/should be lazy
            if (i > 0 && j > 0 && !diff(input[i - 1], output[j - 1], ptr.add(String(i - 1))).length) // equal (no operations => no cost)
            memoized = dist(i - 1, j - 1);
            else {
                var alternatives = [];
                if (i > 0) {
                    // NOT topmost row
                    var remove_base = dist(i - 1, j);
                    var remove_operation = {
                        op: 'remove',
                        index: i - 1
                    };
                    alternatives.push($83186f90232ecfe5$var$appendArrayOperation(remove_base, remove_operation));
                }
                if (j > 0) {
                    // NOT leftmost column
                    var add_base = dist(i, j - 1);
                    var add_operation = {
                        op: 'add',
                        index: i - 1,
                        value: output[j - 1]
                    };
                    alternatives.push($83186f90232ecfe5$var$appendArrayOperation(add_base, add_operation));
                }
                if (i > 0 && j > 0) {
                    // TABLE MIDDLE
                    // supposing we replaced it, compute the rest of the costs:
                    var replace_base = dist(i - 1, j - 1);
                    // okay, the general plan is to replace it, but we can be smarter,
                    // recursing into the structure and replacing only part of it if
                    // possible, but to do so we'll need the original value
                    var replace_operation = {
                        op: 'replace',
                        index: i - 1,
                        original: input[i - 1],
                        value: output[j - 1]
                    };
                    alternatives.push($83186f90232ecfe5$var$appendArrayOperation(replace_base, replace_operation));
                }
                // the only other case, i === 0 && j === 0, has already been memoized
                // the meat of the algorithm:
                // sort by cost to find the lowest one (might be several ties for lowest)
                // [4, 6, 7, 1, 2].sort((a, b) => a - b) -> [ 1, 2, 4, 6, 7 ]
                var best = alternatives.sort(function(a, b) {
                    return a.cost - b.cost;
                })[0];
                memoized = best;
            }
            memo[memo_key] = memoized;
        }
        return memoized;
    }
    // handle weird objects masquerading as Arrays that don't have proper length
    // properties by using 0 for everything but positive numbers
    var input_length = isNaN(input.length) || input.length <= 0 ? 0 : input.length;
    var output_length = isNaN(output.length) || output.length <= 0 ? 0 : output.length;
    var array_operations = dist(input_length, output_length).operations;
    var padded_operations = array_operations.reduce(function(_a, array_operation) {
        var operations = _a[0], padding = _a[1];
        if ($83186f90232ecfe5$var$isArrayAdd(array_operation)) {
            var padded_index = array_operation.index + 1 + padding;
            var index_token = padded_index < input_length + padding ? String(padded_index) : '-';
            var operation = {
                op: array_operation.op,
                path: ptr.add(index_token).toString(),
                value: array_operation.value
            };
            // padding++ // maybe only if array_operation.index > -1 ?
            return [
                operations.concat(operation),
                padding + 1
            ];
        } else if ($83186f90232ecfe5$var$isArrayRemove(array_operation)) {
            var operation = {
                op: array_operation.op,
                path: ptr.add(String(array_operation.index + padding)).toString()
            };
            // padding--
            return [
                operations.concat(operation),
                padding - 1
            ];
        } else {
            var replace_ptr = ptr.add(String(array_operation.index + padding));
            var replace_operations = diff(array_operation.original, array_operation.value, replace_ptr);
            return [
                operations.concat.apply(operations, replace_operations),
                padding
            ];
        }
    }, [
        [],
        0
    ])[0];
    return padded_operations;
}
$83186f90232ecfe5$exports.diffArrays = $83186f90232ecfe5$var$diffArrays;
function $83186f90232ecfe5$var$diffObjects(input, output, ptr, diff) {
    if (diff === void 0) diff = $83186f90232ecfe5$var$diffAny;
    // if a key is in input but not output -> remove it
    var operations = [];
    $83186f90232ecfe5$var$subtract(input, output).forEach(function(key) {
        operations.push({
            op: 'remove',
            path: ptr.add(key).toString()
        });
    });
    // if a key is in output but not input -> add it
    $83186f90232ecfe5$var$subtract(output, input).forEach(function(key) {
        operations.push({
            op: 'add',
            path: ptr.add(key).toString(),
            value: output[key]
        });
    });
    // if a key is in both, diff it recursively
    $83186f90232ecfe5$var$intersection([
        input,
        output
    ]).forEach(function(key) {
        operations.push.apply(operations, diff(input[key], output[key], ptr.add(key)));
    });
    return operations;
}
$83186f90232ecfe5$exports.diffObjects = $83186f90232ecfe5$var$diffObjects;
/**
`diffAny()` returns an empty array if `input` and `output` are materially equal
(i.e., would produce equivalent JSON); otherwise it produces an array of patches
that would transform `input` into `output`.

> Here, "equal" means that the value at the target location and the
> value conveyed by "value" are of the same JSON type, and that they
> are considered equal by the following rules for that type:
> o  strings: are considered equal if they contain the same number of
>    Unicode characters and their code points are byte-by-byte equal.
> o  numbers: are considered equal if their values are numerically
>    equal.
> o  arrays: are considered equal if they contain the same number of
>    values, and if each value can be considered equal to the value at
>    the corresponding position in the other array, using this list of
>    type-specific rules.
> o  objects: are considered equal if they contain the same number of
>    members, and if each member can be considered equal to a member in
>    the other object, by comparing their keys (as strings) and their
>    values (using this list of type-specific rules).
> o  literals (false, true, and null): are considered equal if they are
>    the same.
*/ function $83186f90232ecfe5$var$diffAny(input, output, ptr, diff) {
    if (diff === void 0) diff = $83186f90232ecfe5$var$diffAny;
    // strict equality handles literals, numbers, and strings (a sufficient but not necessary cause)
    if (input === output) return [];
    var input_type = $662ee92c4c73578a$exports.objectType(input);
    var output_type = $662ee92c4c73578a$exports.objectType(output);
    if (input_type == 'array' && output_type == 'array') return $83186f90232ecfe5$var$diffArrays(input, output, ptr, diff);
    if (input_type == 'object' && output_type == 'object') return $83186f90232ecfe5$var$diffObjects(input, output, ptr, diff);
    // at this point we know that input and output are materially different;
    // could be array -> object, object -> array, boolean -> undefined,
    // number -> string, or some other combination, but nothing that can be split
    // up into multiple patches: so `output` must replace `input` wholesale.
    return [
        {
            op: 'replace',
            path: ptr.toString(),
            value: output
        }
    ];
}
$83186f90232ecfe5$exports.diffAny = $83186f90232ecfe5$var$diffAny;


var $6c51edafdc58c647$var$MissingError = /** @class */ function(_super) {
    $6c51edafdc58c647$var$__extends(MissingError, _super);
    function MissingError(path) {
        var _this = _super.call(this, "Value required at path: " + path) || this;
        _this.path = path;
        _this.name = 'MissingError';
        return _this;
    }
    return MissingError;
}(Error);
$6c51edafdc58c647$exports.MissingError = $6c51edafdc58c647$var$MissingError;
var $6c51edafdc58c647$var$TestError = /** @class */ function(_super) {
    $6c51edafdc58c647$var$__extends(TestError, _super);
    function TestError(actual, expected) {
        var _this = _super.call(this, "Test failed: " + actual + " != " + expected) || this;
        _this.actual = actual;
        _this.expected = expected;
        _this.name = 'TestError';
        return _this;
    }
    return TestError;
}(Error);
$6c51edafdc58c647$exports.TestError = $6c51edafdc58c647$var$TestError;
function $6c51edafdc58c647$var$_add(object, key, value) {
    if (Array.isArray(object)) {
        // `key` must be an index
        if (key == '-') object.push(value);
        else {
            var index = parseInt(key, 10);
            object.splice(index, 0, value);
        }
    } else object[key] = value;
}
function $6c51edafdc58c647$var$_remove(object, key) {
    if (Array.isArray(object)) {
        // '-' syntax doesn't make sense when removing
        var index = parseInt(key, 10);
        object.splice(index, 1);
    } else // not sure what the proper behavior is when path = ''
    delete object[key];
}
/**
>  o  If the target location specifies an array index, a new value is
>     inserted into the array at the specified index.
>  o  If the target location specifies an object member that does not
>     already exist, a new member is added to the object.
>  o  If the target location specifies an object member that does exist,
>     that member's value is replaced.
*/ function $6c51edafdc58c647$var$add(object, operation) {
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    // it's not exactly a "MissingError" in the same way that `remove` is -- more like a MissingParent, or something
    if (endpoint.parent === undefined) return new $6c51edafdc58c647$var$MissingError(operation.path);
    $6c51edafdc58c647$var$_add(endpoint.parent, endpoint.key, $662ee92c4c73578a$exports.clone(operation.value));
    return null;
}
$6c51edafdc58c647$exports.add = $6c51edafdc58c647$var$add;
/**
> The "remove" operation removes the value at the target location.
> The target location MUST exist for the operation to be successful.
*/ function $6c51edafdc58c647$var$remove(object, operation) {
    // endpoint has parent, key, and value properties
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.value === undefined) return new $6c51edafdc58c647$var$MissingError(operation.path);
    // not sure what the proper behavior is when path = ''
    $6c51edafdc58c647$var$_remove(endpoint.parent, endpoint.key);
    return null;
}
$6c51edafdc58c647$exports.remove = $6c51edafdc58c647$var$remove;
/**
> The "replace" operation replaces the value at the target location
> with a new value.  The operation object MUST contain a "value" member
> whose content specifies the replacement value.
> The target location MUST exist for the operation to be successful.

> This operation is functionally identical to a "remove" operation for
> a value, followed immediately by an "add" operation at the same
> location with the replacement value.

Even more simply, it's like the add operation with an existence check.
*/ function $6c51edafdc58c647$var$replace(object, operation) {
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === null) return new $6c51edafdc58c647$var$MissingError(operation.path);
    // this existence check treats arrays as a special case
    if (Array.isArray(endpoint.parent)) {
        if (parseInt(endpoint.key, 10) >= endpoint.parent.length) return new $6c51edafdc58c647$var$MissingError(operation.path);
    } else if (endpoint.value === undefined) return new $6c51edafdc58c647$var$MissingError(operation.path);
    endpoint.parent[endpoint.key] = operation.value;
    return null;
}
$6c51edafdc58c647$exports.replace = $6c51edafdc58c647$var$replace;
/**
> The "move" operation removes the value at a specified location and
> adds it to the target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to move the value from.
> This operation is functionally identical to a "remove" operation on
> the "from" location, followed immediately by an "add" operation at
> the target location with the value that was just removed.

> The "from" location MUST NOT be a proper prefix of the "path"
> location; i.e., a location cannot be moved into one of its children.

TODO: throw if the check described in the previous paragraph fails.
*/ function $6c51edafdc58c647$var$move(object, operation) {
    var from_endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.from).evaluate(object);
    if (from_endpoint.value === undefined) return new $6c51edafdc58c647$var$MissingError(operation.from);
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === undefined) return new $6c51edafdc58c647$var$MissingError(operation.path);
    $6c51edafdc58c647$var$_remove(from_endpoint.parent, from_endpoint.key);
    $6c51edafdc58c647$var$_add(endpoint.parent, endpoint.key, from_endpoint.value);
    return null;
}
$6c51edafdc58c647$exports.move = $6c51edafdc58c647$var$move;
/**
> The "copy" operation copies the value at a specified location to the
> target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to copy the value from.
> The "from" location MUST exist for the operation to be successful.

> This operation is functionally identical to an "add" operation at the
> target location using the value specified in the "from" member.

Alternatively, it's like 'move' without the 'remove'.
*/ function $6c51edafdc58c647$var$copy(object, operation) {
    var from_endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.from).evaluate(object);
    if (from_endpoint.value === undefined) return new $6c51edafdc58c647$var$MissingError(operation.from);
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === undefined) return new $6c51edafdc58c647$var$MissingError(operation.path);
    $6c51edafdc58c647$var$_add(endpoint.parent, endpoint.key, $662ee92c4c73578a$exports.clone(from_endpoint.value));
    return null;
}
$6c51edafdc58c647$exports.copy = $6c51edafdc58c647$var$copy;
/**
> The "test" operation tests that a value at the target location is
> equal to a specified value.
> The operation object MUST contain a "value" member that conveys the
> value to be compared to the target location's value.
> The target location MUST be equal to the "value" value for the
> operation to be considered successful.
*/ function $6c51edafdc58c647$var$test(object, operation) {
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(operation.path).evaluate(object);
    // TODO: this diffAny(...).length usage could/should be lazy
    if ($83186f90232ecfe5$exports.diffAny(endpoint.value, operation.value, new $85fc210bf17c1065$exports.Pointer()).length) return new $6c51edafdc58c647$var$TestError(endpoint.value, operation.value);
    return null;
}
$6c51edafdc58c647$exports.test = $6c51edafdc58c647$var$test;
var $6c51edafdc58c647$var$InvalidOperationError = /** @class */ function(_super) {
    $6c51edafdc58c647$var$__extends(InvalidOperationError, _super);
    function InvalidOperationError(operation) {
        var _this = _super.call(this, "Invalid operation: " + operation.op) || this;
        _this.operation = operation;
        _this.name = 'InvalidOperationError';
        return _this;
    }
    return InvalidOperationError;
}(Error);
$6c51edafdc58c647$exports.InvalidOperationError = $6c51edafdc58c647$var$InvalidOperationError;
/**
Switch on `operation.op`, applying the corresponding patch function for each
case to `object`.
*/ function $6c51edafdc58c647$var$apply(object, operation) {
    // not sure why TypeScript can't infer typesafety of:
    //   {add, remove, replace, move, copy, test}[operation.op](object, operation)
    // (seems like a bug)
    switch(operation.op){
        case 'add':
            return $6c51edafdc58c647$var$add(object, operation);
        case 'remove':
            return $6c51edafdc58c647$var$remove(object, operation);
        case 'replace':
            return $6c51edafdc58c647$var$replace(object, operation);
        case 'move':
            return $6c51edafdc58c647$var$move(object, operation);
        case 'copy':
            return $6c51edafdc58c647$var$copy(object, operation);
        case 'test':
            return $6c51edafdc58c647$var$test(object, operation);
    }
    return new $6c51edafdc58c647$var$InvalidOperationError(operation);
}
$6c51edafdc58c647$exports.apply = $6c51edafdc58c647$var$apply;



/**
Apply a 'application/json-patch+json'-type patch to an object.

`patch` *must* be an array of operations.

> Operation objects MUST have exactly one "op" member, whose value
> indicates the operation to perform.  Its value MUST be one of "add",
> "remove", "replace", "move", "copy", or "test"; other values are
> errors.

This method mutates the target object in-place.

@returns list of results, one for each operation: `null` indicated success,
         otherwise, the result will be an instance of one of the Error classes:
         MissingError, InvalidOperationError, or TestError.
*/ function $06105d02a3bc31a3$var$applyPatch(object, patch) {
    return patch.map(function(operation) {
        return $6c51edafdc58c647$exports.apply(object, operation);
    });
}
$06105d02a3bc31a3$exports.applyPatch = $06105d02a3bc31a3$var$applyPatch;
function $06105d02a3bc31a3$var$wrapVoidableDiff(diff) {
    function wrappedDiff(input, output, ptr) {
        var custom_patch = diff(input, output, ptr);
        // ensure an array is always returned
        return Array.isArray(custom_patch) ? custom_patch : $83186f90232ecfe5$exports.diffAny(input, output, ptr, wrappedDiff);
    }
    return wrappedDiff;
}
/**
Produce a 'application/json-patch+json'-type patch to get from one object to
another.

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

`diff` is called on each pair of comparable non-primitive nodes in the
`input`/`output` object trees, producing nested patches. Return `undefined`
to fall back to default behaviour.

Returns list of operations to perform on `input` to produce `output`.
*/ function $06105d02a3bc31a3$var$createPatch(input, output, diff) {
    var ptr = new $85fc210bf17c1065$exports.Pointer();
    // a new Pointer gets a default path of [''] if not specified
    return (diff ? $06105d02a3bc31a3$var$wrapVoidableDiff(diff) : $83186f90232ecfe5$exports.diffAny)(input, output, ptr);
}
$06105d02a3bc31a3$exports.createPatch = $06105d02a3bc31a3$var$createPatch;
/**
Create a test operation based on `input`'s current evaluation of the JSON
Pointer `path`; if such a pointer cannot be resolved, returns undefined.
*/ function $06105d02a3bc31a3$var$createTest(input, path) {
    var endpoint = $85fc210bf17c1065$exports.Pointer.fromJSON(path).evaluate(input);
    if (endpoint !== undefined) return {
        op: 'test',
        path: path,
        value: endpoint.value
    };
}
/**
Produce an 'application/json-patch+json'-type list of tests, to verify that
existing values in an object are identical to the those captured at some
checkpoint (whenever this function is called).

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

Returns list of test operations.
*/ function $06105d02a3bc31a3$var$createTests(input, patch) {
    var tests = new Array();
    patch.filter($83186f90232ecfe5$exports.isDestructive).forEach(function(operation) {
        var pathTest = $06105d02a3bc31a3$var$createTest(input, operation.path);
        if (pathTest) tests.push(pathTest);
        if ('from' in operation) {
            var fromTest = $06105d02a3bc31a3$var$createTest(input, operation.from);
            if (fromTest) tests.push(fromTest);
        }
    });
    return tests;
}
$06105d02a3bc31a3$exports.createTests = $06105d02a3bc31a3$var$createTests;


/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Flow
 *
 * Creates a reducer that updates ctx (analogous to how moves update G).
 */ function $c0af5ddcdbbb6eb0$var$Flow({ moves: moves, phases: phases, endIf: endIf, onEnd: onEnd, turn: turn, events: events, plugins: plugins }) {
    // Attach defaults.
    if (moves === undefined) moves = {};
    if (events === undefined) events = {};
    if (plugins === undefined) plugins = [];
    if (phases === undefined) phases = {};
    if (!endIf) endIf = ()=>undefined;
    if (!onEnd) onEnd = ({ G: G })=>G;
    if (!turn) turn = {};
    const phaseMap = {
        ...phases
    };
    if ('' in phaseMap) (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)('cannot specify phase with empty name');
    phaseMap[''] = {};
    const moveMap = {};
    const moveNames = new Set();
    let startingPhase = null;
    Object.keys(moves).forEach((name)=>moveNames.add(name));
    const HookWrapper = (hook, hookType)=>{
        const withPlugins = (0, $b0ae1e6bca8d95a9$export$d66501df72047452)(hook, hookType, plugins);
        return (state)=>{
            const pluginAPIs = (0, $b0ae1e6bca8d95a9$export$407448d2b89b1813)(state);
            return withPlugins({
                ...pluginAPIs,
                G: state.G,
                ctx: state.ctx,
                playerID: state.playerID
            });
        };
    };
    const TriggerWrapper = (trigger)=>{
        return (state)=>{
            const pluginAPIs = (0, $b0ae1e6bca8d95a9$export$407448d2b89b1813)(state);
            return trigger({
                ...pluginAPIs,
                G: state.G,
                ctx: state.ctx
            });
        };
    };
    const wrapped = {
        onEnd: HookWrapper(onEnd, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).GAME_ON_END),
        endIf: TriggerWrapper(endIf)
    };
    for(const phase in phaseMap){
        const phaseConfig = phaseMap[phase];
        if (phaseConfig.start === true) startingPhase = phase;
        if (phaseConfig.moves !== undefined) for (const move of Object.keys(phaseConfig.moves)){
            moveMap[phase + '.' + move] = phaseConfig.moves[move];
            moveNames.add(move);
        }
        if (phaseConfig.endIf === undefined) phaseConfig.endIf = ()=>undefined;
        if (phaseConfig.onBegin === undefined) phaseConfig.onBegin = ({ G: G })=>G;
        if (phaseConfig.onEnd === undefined) phaseConfig.onEnd = ({ G: G })=>G;
        if (phaseConfig.turn === undefined) phaseConfig.turn = turn;
        if (phaseConfig.turn.order === undefined) phaseConfig.turn.order = (0, $b0ae1e6bca8d95a9$export$971d5caa766a69d7).DEFAULT;
        if (phaseConfig.turn.onBegin === undefined) phaseConfig.turn.onBegin = ({ G: G })=>G;
        if (phaseConfig.turn.onEnd === undefined) phaseConfig.turn.onEnd = ({ G: G })=>G;
        if (phaseConfig.turn.endIf === undefined) phaseConfig.turn.endIf = ()=>false;
        if (phaseConfig.turn.onMove === undefined) phaseConfig.turn.onMove = ({ G: G })=>G;
        if (phaseConfig.turn.stages === undefined) phaseConfig.turn.stages = {};
        // turns previously treated moveLimit as both minMoves and maxMoves, this behaviour is kept intentionally
        (0, $b0ae1e6bca8d95a9$export$8b22cf2602fb60ce)(phaseConfig.turn, true);
        for(const stage in phaseConfig.turn.stages){
            const stageConfig = phaseConfig.turn.stages[stage];
            const moves = stageConfig.moves || {};
            for (const move of Object.keys(moves)){
                const key = phase + '.' + stage + '.' + move;
                moveMap[key] = moves[move];
                moveNames.add(move);
            }
        }
        phaseConfig.wrapped = {
            onBegin: HookWrapper(phaseConfig.onBegin, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).PHASE_ON_BEGIN),
            onEnd: HookWrapper(phaseConfig.onEnd, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).PHASE_ON_END),
            endIf: TriggerWrapper(phaseConfig.endIf)
        };
        phaseConfig.turn.wrapped = {
            onMove: HookWrapper(phaseConfig.turn.onMove, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).TURN_ON_MOVE),
            onBegin: HookWrapper(phaseConfig.turn.onBegin, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).TURN_ON_BEGIN),
            onEnd: HookWrapper(phaseConfig.turn.onEnd, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).TURN_ON_END),
            endIf: TriggerWrapper(phaseConfig.turn.endIf)
        };
        if (typeof phaseConfig.next !== 'function') {
            const { next: next } = phaseConfig;
            phaseConfig.next = ()=>next || null;
        }
        phaseConfig.wrapped.next = TriggerWrapper(phaseConfig.next);
    }
    function GetPhase(ctx) {
        return ctx.phase ? phaseMap[ctx.phase] : phaseMap[''];
    }
    function OnMove(state) {
        return state;
    }
    function Process(state, events) {
        const phasesEnded = new Set();
        const turnsEnded = new Set();
        for(let i = 0; i < events.length; i++){
            const { fn: fn, arg: arg, ...rest } = events[i];
            // Detect a loop of EndPhase calls.
            // This could potentially even be an infinite loop
            // if the endIf condition of each phase blindly
            // returns true. The moment we detect a single
            // loop, we just bail out of all phases.
            if (fn === EndPhase) {
                turnsEnded.clear();
                const phase = state.ctx.phase;
                if (phasesEnded.has(phase)) {
                    const ctx = {
                        ...state.ctx,
                        phase: null
                    };
                    return {
                        ...state,
                        ctx: ctx
                    };
                }
                phasesEnded.add(phase);
            }
            // Process event.
            const next = [];
            state = fn(state, {
                ...rest,
                arg: arg,
                next: next
            });
            if (fn === EndGame) break;
            // Check if we should end the game.
            const shouldEndGame = ShouldEndGame(state);
            if (shouldEndGame) {
                events.push({
                    fn: EndGame,
                    arg: shouldEndGame,
                    turn: state.ctx.turn,
                    phase: state.ctx.phase,
                    automatic: true
                });
                continue;
            }
            // Check if we should end the phase.
            const shouldEndPhase = ShouldEndPhase(state);
            if (shouldEndPhase) {
                events.push({
                    fn: EndPhase,
                    arg: shouldEndPhase,
                    turn: state.ctx.turn,
                    phase: state.ctx.phase,
                    automatic: true
                });
                continue;
            }
            // Check if we should end the turn.
            if ([
                OnMove,
                UpdateStage,
                UpdateActivePlayers
            ].includes(fn)) {
                const shouldEndTurn = ShouldEndTurn(state);
                if (shouldEndTurn) {
                    events.push({
                        fn: EndTurn,
                        arg: shouldEndTurn,
                        turn: state.ctx.turn,
                        phase: state.ctx.phase,
                        automatic: true
                    });
                    continue;
                }
            }
            events.push(...next);
        }
        return state;
    }
    ///////////
    // Start //
    ///////////
    function StartGame(state, { next: next }) {
        next.push({
            fn: StartPhase
        });
        return state;
    }
    function StartPhase(state, { next: next }) {
        let { G: G, ctx: ctx } = state;
        const phaseConfig = GetPhase(ctx);
        // Run any phase setup code provided by the user.
        G = phaseConfig.wrapped.onBegin(state);
        next.push({
            fn: StartTurn
        });
        return {
            ...state,
            G: G,
            ctx: ctx
        };
    }
    function StartTurn(state, { currentPlayer: currentPlayer }) {
        let { ctx: ctx } = state;
        const phaseConfig = GetPhase(ctx);
        // Initialize the turn order state.
        if (currentPlayer) {
            ctx = {
                ...ctx,
                currentPlayer: currentPlayer
            };
            if (phaseConfig.turn.activePlayers) ctx = (0, $b0ae1e6bca8d95a9$export$db3b6bfb95261072)(ctx, phaseConfig.turn.activePlayers);
        } else // This is only called at the beginning of the phase
        // when there is no currentPlayer yet.
        ctx = (0, $b0ae1e6bca8d95a9$export$9bb611d729802a56)(state, phaseConfig.turn);
        const turn = ctx.turn + 1;
        ctx = {
            ...ctx,
            turn: turn,
            numMoves: 0,
            _prevActivePlayers: []
        };
        const G = phaseConfig.turn.wrapped.onBegin({
            ...state,
            ctx: ctx
        });
        return {
            ...state,
            G: G,
            ctx: ctx,
            _undo: [],
            _redo: []
        };
    }
    ////////////
    // Update //
    ////////////
    function UpdatePhase(state, { arg: arg, next: next, phase: phase }) {
        const phaseConfig = GetPhase({
            phase: phase
        });
        let { ctx: ctx } = state;
        if (arg && arg.next) {
            if (arg.next in phaseMap) ctx = {
                ...ctx,
                phase: arg.next
            };
            else {
                (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)('invalid phase: ' + arg.next);
                return state;
            }
        } else ctx = {
            ...ctx,
            phase: phaseConfig.wrapped.next(state) || null
        };
        state = {
            ...state,
            ctx: ctx
        };
        // Start the new phase.
        next.push({
            fn: StartPhase
        });
        return state;
    }
    function UpdateTurn(state, { arg: arg, currentPlayer: currentPlayer, next: next }) {
        let { G: G, ctx: ctx } = state;
        const phaseConfig = GetPhase(ctx);
        // Update turn order state.
        const { endPhase: endPhase, ctx: newCtx } = (0, $b0ae1e6bca8d95a9$export$3a6d5c9ae78a2c08)(state, currentPlayer, phaseConfig.turn, arg);
        ctx = newCtx;
        state = {
            ...state,
            G: G,
            ctx: ctx
        };
        if (endPhase) next.push({
            fn: EndPhase,
            turn: ctx.turn,
            phase: ctx.phase
        });
        else next.push({
            fn: StartTurn,
            currentPlayer: ctx.currentPlayer
        });
        return state;
    }
    function UpdateStage(state, { arg: arg, playerID: playerID }) {
        if (typeof arg === 'string' || arg === (0, $b0ae1e6bca8d95a9$export$25ce5a424b770e84).NULL) arg = {
            stage: arg
        };
        if (typeof arg !== 'object') return state;
        // `arg` should be of type `StageArg`, loose typing as `any` here for historic reasons
        // stages previously did not enforce minMoves, this behaviour is kept intentionally
        (0, $b0ae1e6bca8d95a9$export$8b22cf2602fb60ce)(arg);
        let { ctx: ctx } = state;
        let { activePlayers: activePlayers, _activePlayersMinMoves: _activePlayersMinMoves, _activePlayersMaxMoves: _activePlayersMaxMoves, _activePlayersNumMoves: _activePlayersNumMoves } = ctx;
        // Checking if stage is valid, even Stage.NULL
        if (arg.stage !== undefined) {
            if (activePlayers === null) activePlayers = {};
            activePlayers[playerID] = arg.stage;
            _activePlayersNumMoves[playerID] = 0;
            if (arg.minMoves) {
                if (_activePlayersMinMoves === null) _activePlayersMinMoves = {};
                _activePlayersMinMoves[playerID] = arg.minMoves;
            }
            if (arg.maxMoves) {
                if (_activePlayersMaxMoves === null) _activePlayersMaxMoves = {};
                _activePlayersMaxMoves[playerID] = arg.maxMoves;
            }
        }
        ctx = {
            ...ctx,
            activePlayers: activePlayers,
            _activePlayersMinMoves: _activePlayersMinMoves,
            _activePlayersMaxMoves: _activePlayersMaxMoves,
            _activePlayersNumMoves: _activePlayersNumMoves
        };
        return {
            ...state,
            ctx: ctx
        };
    }
    function UpdateActivePlayers(state, { arg: arg }) {
        return {
            ...state,
            ctx: (0, $b0ae1e6bca8d95a9$export$db3b6bfb95261072)(state.ctx, arg)
        };
    }
    ///////////////
    // ShouldEnd //
    ///////////////
    function ShouldEndGame(state) {
        return wrapped.endIf(state);
    }
    function ShouldEndPhase(state) {
        const phaseConfig = GetPhase(state.ctx);
        return phaseConfig.wrapped.endIf(state);
    }
    function ShouldEndTurn(state) {
        const phaseConfig = GetPhase(state.ctx);
        // End the turn if the required number of moves has been made.
        const currentPlayerMoves = state.ctx.numMoves || 0;
        if (phaseConfig.turn.maxMoves && currentPlayerMoves >= phaseConfig.turn.maxMoves) return true;
        return phaseConfig.turn.wrapped.endIf(state);
    }
    /////////
    // End //
    /////////
    function EndGame(state, { arg: arg, phase: phase }) {
        state = EndPhase(state, {
            phase: phase
        });
        if (arg === undefined) arg = true;
        state = {
            ...state,
            ctx: {
                ...state.ctx,
                gameover: arg
            }
        };
        // Run game end hook.
        const G = wrapped.onEnd(state);
        return {
            ...state,
            G: G
        };
    }
    function EndPhase(state, { arg: arg, next: next, turn: initialTurn, automatic: automatic }) {
        // End the turn first.
        state = EndTurn(state, {
            turn: initialTurn,
            force: true,
            automatic: true
        });
        const { phase: phase, turn: turn } = state.ctx;
        if (next) next.push({
            fn: UpdatePhase,
            arg: arg,
            phase: phase
        });
        // If we aren't in a phase, there is nothing else to do.
        if (phase === null) return state;
        // Run any cleanup code for the phase that is about to end.
        const phaseConfig = GetPhase(state.ctx);
        const G = phaseConfig.wrapped.onEnd(state);
        // Reset the phase.
        const ctx = {
            ...state.ctx,
            phase: null
        };
        // Add log entry.
        const action = (0, $b0ae1e6bca8d95a9$export$39b482c5e57630a8)('endPhase', arg);
        const { _stateID: _stateID } = state;
        const logEntry = {
            action: action,
            _stateID: _stateID,
            turn: turn,
            phase: phase
        };
        if (automatic) logEntry.automatic = true;
        const deltalog = [
            ...state.deltalog || [],
            logEntry
        ];
        return {
            ...state,
            G: G,
            ctx: ctx,
            deltalog: deltalog
        };
    }
    function EndTurn(state, { arg: arg, next: next, turn: initialTurn, force: force, automatic: automatic, playerID: playerID }) {
        // This is not the turn that EndTurn was originally
        // called for. The turn was probably ended some other way.
        if (initialTurn !== state.ctx.turn) return state;
        const { currentPlayer: currentPlayer, numMoves: numMoves, phase: phase, turn: turn } = state.ctx;
        const phaseConfig = GetPhase(state.ctx);
        // Prevent ending the turn if minMoves haven't been reached.
        const currentPlayerMoves = numMoves || 0;
        if (!force && phaseConfig.turn.minMoves && currentPlayerMoves < phaseConfig.turn.minMoves) {
            (0, $b0ae1e6bca8d95a9$export$23f2a1d2818174ef)(`cannot end turn before making ${phaseConfig.turn.minMoves} moves`);
            return state;
        }
        // Run turn-end triggers.
        const G = phaseConfig.turn.wrapped.onEnd(state);
        if (next) next.push({
            fn: UpdateTurn,
            arg: arg,
            currentPlayer: currentPlayer
        });
        // Reset activePlayers.
        let ctx = {
            ...state.ctx,
            activePlayers: null
        };
        // Remove player from playerOrder
        if (arg && arg.remove) {
            playerID = playerID || currentPlayer;
            const playOrder = ctx.playOrder.filter((i)=>i != playerID);
            const playOrderPos = ctx.playOrderPos > playOrder.length - 1 ? 0 : ctx.playOrderPos;
            ctx = {
                ...ctx,
                playOrder: playOrder,
                playOrderPos: playOrderPos
            };
            if (playOrder.length === 0) {
                next.push({
                    fn: EndPhase,
                    turn: turn,
                    phase: phase
                });
                return state;
            }
        }
        // Create log entry.
        const action = (0, $b0ae1e6bca8d95a9$export$39b482c5e57630a8)('endTurn', arg);
        const { _stateID: _stateID } = state;
        const logEntry = {
            action: action,
            _stateID: _stateID,
            turn: turn,
            phase: phase
        };
        if (automatic) logEntry.automatic = true;
        const deltalog = [
            ...state.deltalog || [],
            logEntry
        ];
        return {
            ...state,
            G: G,
            ctx: ctx,
            deltalog: deltalog,
            _undo: [],
            _redo: []
        };
    }
    function EndStage(state, { arg: arg, next: next, automatic: automatic, playerID: playerID }) {
        playerID = playerID || state.ctx.currentPlayer;
        let { ctx: ctx, _stateID: _stateID } = state;
        let { activePlayers: activePlayers, _activePlayersNumMoves: _activePlayersNumMoves, _activePlayersMinMoves: _activePlayersMinMoves, _activePlayersMaxMoves: _activePlayersMaxMoves, phase: phase, turn: turn } = ctx;
        const playerInStage = activePlayers !== null && playerID in activePlayers;
        const phaseConfig = GetPhase(ctx);
        if (!arg && playerInStage) {
            const stage = phaseConfig.turn.stages[activePlayers[playerID]];
            if (stage && stage.next) arg = stage.next;
        }
        // Checking if arg is a valid stage, even Stage.NULL
        if (next) next.push({
            fn: UpdateStage,
            arg: arg,
            playerID: playerID
        });
        // If player isn’t in a stage, there is nothing else to do.
        if (!playerInStage) return state;
        // Prevent ending the stage if minMoves haven't been reached.
        const currentPlayerMoves = _activePlayersNumMoves[playerID] || 0;
        if (_activePlayersMinMoves && _activePlayersMinMoves[playerID] && currentPlayerMoves < _activePlayersMinMoves[playerID]) {
            (0, $b0ae1e6bca8d95a9$export$23f2a1d2818174ef)(`cannot end stage before making ${_activePlayersMinMoves[playerID]} moves`);
            return state;
        }
        // Remove player from activePlayers.
        activePlayers = {
            ...activePlayers
        };
        delete activePlayers[playerID];
        if (_activePlayersMinMoves) {
            // Remove player from _activePlayersMinMoves.
            _activePlayersMinMoves = {
                ..._activePlayersMinMoves
            };
            delete _activePlayersMinMoves[playerID];
        }
        if (_activePlayersMaxMoves) {
            // Remove player from _activePlayersMaxMoves.
            _activePlayersMaxMoves = {
                ..._activePlayersMaxMoves
            };
            delete _activePlayersMaxMoves[playerID];
        }
        ctx = (0, $b0ae1e6bca8d95a9$export$4368d992c4eafac0)({
            ...ctx,
            activePlayers: activePlayers,
            _activePlayersMinMoves: _activePlayersMinMoves,
            _activePlayersMaxMoves: _activePlayersMaxMoves
        });
        // Create log entry.
        const action = (0, $b0ae1e6bca8d95a9$export$39b482c5e57630a8)('endStage', arg);
        const logEntry = {
            action: action,
            _stateID: _stateID,
            turn: turn,
            phase: phase
        };
        if (automatic) logEntry.automatic = true;
        const deltalog = [
            ...state.deltalog || [],
            logEntry
        ];
        return {
            ...state,
            ctx: ctx,
            deltalog: deltalog
        };
    }
    /**
     * Retrieves the relevant move that can be played by playerID.
     *
     * If ctx.activePlayers is set (i.e. one or more players are in some stage),
     * then it attempts to find the move inside the stages config for
     * that turn. If the stage for a player is '', then the player is
     * allowed to make a move (as determined by the phase config), but
     * isn't restricted to a particular set as defined in the stage config.
     *
     * If not, it then looks for the move inside the phase.
     *
     * If it doesn't find the move there, it looks at the global move definition.
     *
     * @param {object} ctx
     * @param {string} name
     * @param {string} playerID
     */ function GetMove(ctx, name, playerID) {
        const phaseConfig = GetPhase(ctx);
        const stages = phaseConfig.turn.stages;
        const { activePlayers: activePlayers } = ctx;
        if (activePlayers && activePlayers[playerID] !== undefined && activePlayers[playerID] !== (0, $b0ae1e6bca8d95a9$export$25ce5a424b770e84).NULL && stages[activePlayers[playerID]] !== undefined && stages[activePlayers[playerID]].moves !== undefined) {
            // Check if moves are defined for the player's stage.
            const stage = stages[activePlayers[playerID]];
            const moves = stage.moves;
            if (name in moves) return moves[name];
        } else if (phaseConfig.moves) {
            // Check if moves are defined for the current phase.
            if (name in phaseConfig.moves) return phaseConfig.moves[name];
        } else if (name in moves) // Check for the move globally.
        return moves[name];
        return null;
    }
    function ProcessMove(state, action) {
        const { playerID: playerID, type: type } = action;
        const { currentPlayer: currentPlayer, activePlayers: activePlayers, _activePlayersMaxMoves: _activePlayersMaxMoves } = state.ctx;
        const move = GetMove(state.ctx, type, playerID);
        const shouldCount = !move || typeof move === 'function' || move.noLimit !== true;
        let { numMoves: numMoves, _activePlayersNumMoves: _activePlayersNumMoves } = state.ctx;
        if (shouldCount) {
            if (playerID === currentPlayer) numMoves++;
            if (activePlayers) _activePlayersNumMoves[playerID]++;
        }
        state = {
            ...state,
            ctx: {
                ...state.ctx,
                numMoves: numMoves,
                _activePlayersNumMoves: _activePlayersNumMoves
            }
        };
        if (_activePlayersMaxMoves && _activePlayersNumMoves[playerID] >= _activePlayersMaxMoves[playerID]) state = EndStage(state, {
            playerID: playerID,
            automatic: true
        });
        const phaseConfig = GetPhase(state.ctx);
        const G = phaseConfig.turn.wrapped.onMove({
            ...state,
            playerID: playerID
        });
        state = {
            ...state,
            G: G
        };
        const events = [
            {
                fn: OnMove
            }
        ];
        return Process(state, events);
    }
    function SetStageEvent(state, playerID, arg) {
        return Process(state, [
            {
                fn: EndStage,
                arg: arg,
                playerID: playerID
            }
        ]);
    }
    function EndStageEvent(state, playerID) {
        return Process(state, [
            {
                fn: EndStage,
                playerID: playerID
            }
        ]);
    }
    function SetActivePlayersEvent(state, _playerID, arg) {
        return Process(state, [
            {
                fn: UpdateActivePlayers,
                arg: arg
            }
        ]);
    }
    function SetPhaseEvent(state, _playerID, newPhase) {
        return Process(state, [
            {
                fn: EndPhase,
                phase: state.ctx.phase,
                turn: state.ctx.turn,
                arg: {
                    next: newPhase
                }
            }
        ]);
    }
    function EndPhaseEvent(state) {
        return Process(state, [
            {
                fn: EndPhase,
                phase: state.ctx.phase,
                turn: state.ctx.turn
            }
        ]);
    }
    function EndTurnEvent(state, _playerID, arg) {
        return Process(state, [
            {
                fn: EndTurn,
                turn: state.ctx.turn,
                phase: state.ctx.phase,
                arg: arg
            }
        ]);
    }
    function PassEvent(state, _playerID, arg) {
        return Process(state, [
            {
                fn: EndTurn,
                turn: state.ctx.turn,
                phase: state.ctx.phase,
                force: true,
                arg: arg
            }
        ]);
    }
    function EndGameEvent(state, _playerID, arg) {
        return Process(state, [
            {
                fn: EndGame,
                turn: state.ctx.turn,
                phase: state.ctx.phase,
                arg: arg
            }
        ]);
    }
    const eventHandlers = {
        endStage: EndStageEvent,
        setStage: SetStageEvent,
        endTurn: EndTurnEvent,
        pass: PassEvent,
        endPhase: EndPhaseEvent,
        setPhase: SetPhaseEvent,
        endGame: EndGameEvent,
        setActivePlayers: SetActivePlayersEvent
    };
    const enabledEventNames = [];
    if (events.endTurn !== false) enabledEventNames.push('endTurn');
    if (events.pass !== false) enabledEventNames.push('pass');
    if (events.endPhase !== false) enabledEventNames.push('endPhase');
    if (events.setPhase !== false) enabledEventNames.push('setPhase');
    if (events.endGame !== false) enabledEventNames.push('endGame');
    if (events.setActivePlayers !== false) enabledEventNames.push('setActivePlayers');
    if (events.endStage !== false) enabledEventNames.push('endStage');
    if (events.setStage !== false) enabledEventNames.push('setStage');
    function ProcessEvent(state, action) {
        const { type: type, playerID: playerID, args: args } = action.payload;
        if (typeof eventHandlers[type] !== 'function') return state;
        return eventHandlers[type](state, playerID, ...Array.isArray(args) ? args : [
            args
        ]);
    }
    function IsPlayerActive(_G, ctx, playerID) {
        if (ctx.activePlayers) return playerID in ctx.activePlayers;
        return ctx.currentPlayer === playerID;
    }
    return {
        ctx: (numPlayers)=>({
                numPlayers: numPlayers,
                turn: 0,
                currentPlayer: '0',
                playOrder: [
                    ...Array.from({
                        length: numPlayers
                    })
                ].map((_, i)=>i + ''),
                playOrderPos: 0,
                phase: startingPhase,
                activePlayers: null
            }),
        init: (state)=>{
            return Process(state, [
                {
                    fn: StartGame
                }
            ]);
        },
        isPlayerActive: IsPlayerActive,
        eventHandlers: eventHandlers,
        eventNames: Object.keys(eventHandlers),
        enabledEventNames: enabledEventNames,
        moveMap: moveMap,
        moveNames: [
            ...moveNames.values()
        ],
        processMove: ProcessMove,
        processEvent: ProcessEvent,
        getMove: GetMove
    };
}
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ function $c0af5ddcdbbb6eb0$var$IsProcessed(game) {
    return game.processMove !== undefined;
}
/**
 * Helper to generate the game move reducer. The returned
 * reducer has the following signature:
 *
 * (G, action, ctx) => {}
 *
 * You can roll your own if you like, or use any Redux
 * addon to generate such a reducer.
 *
 * The convention used in this framework is to
 * have action.type contain the name of the move, and
 * action.args contain any additional arguments as an
 * Array.
 */ function $c0af5ddcdbbb6eb0$export$56c0d5a1e737357d(game) {
    // The Game() function has already been called on this
    // config object, so just pass it through.
    if ($c0af5ddcdbbb6eb0$var$IsProcessed(game)) return game;
    if (game.name === undefined) game.name = 'default';
    if (game.deltaState === undefined) game.deltaState = false;
    if (game.disableUndo === undefined) game.disableUndo = false;
    if (game.setup === undefined) game.setup = ()=>({});
    if (game.moves === undefined) game.moves = {};
    if (game.playerView === undefined) game.playerView = ({ G: G })=>G;
    if (game.plugins === undefined) game.plugins = [];
    game.plugins.forEach((plugin)=>{
        if (plugin.name === undefined) throw new Error('Plugin missing name attribute');
        if (plugin.name.includes(' ')) throw new Error(plugin.name + ': Plugin name must not include spaces');
    });
    if (game.name.includes(' ')) throw new Error(game.name + ': Game name must not include spaces');
    const flow = $c0af5ddcdbbb6eb0$var$Flow(game);
    return {
        ...game,
        flow: flow,
        moveNames: flow.moveNames,
        pluginNames: game.plugins.map((p)=>p.name),
        processMove: (state, action)=>{
            let moveFn = flow.getMove(state.ctx, action.type, action.playerID);
            if ($c0af5ddcdbbb6eb0$export$9bb611d729802a56(moveFn)) moveFn = moveFn.move;
            if (moveFn instanceof Function) {
                const fn = (0, $b0ae1e6bca8d95a9$export$d66501df72047452)(moveFn, (0, $b0ae1e6bca8d95a9$export$2329c99376c9d0a4).MOVE, game.plugins);
                let args = [];
                if (action.args !== undefined) args = Array.isArray(action.args) ? action.args : [
                    action.args
                ];
                const context = {
                    ...(0, $b0ae1e6bca8d95a9$export$407448d2b89b1813)(state),
                    G: state.G,
                    ctx: state.ctx,
                    playerID: action.playerID
                };
                return fn(context, ...args);
            }
            (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`invalid move object: ${action.type}`);
            return state.G;
        }
    };
}
function $c0af5ddcdbbb6eb0$export$9bb611d729802a56(move) {
    return move instanceof Object && move.move !== undefined;
}
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ var $c0af5ddcdbbb6eb0$var$UpdateErrorType;
(function(UpdateErrorType) {
    // The action’s credentials were missing or invalid
    UpdateErrorType["UnauthorizedAction"] = "update/unauthorized_action";
    // The action’s matchID was not found
    UpdateErrorType["MatchNotFound"] = "update/match_not_found";
    // Could not apply Patch operation (rfc6902).
    UpdateErrorType["PatchFailed"] = "update/patch_failed";
})($c0af5ddcdbbb6eb0$var$UpdateErrorType || ($c0af5ddcdbbb6eb0$var$UpdateErrorType = {}));
var $c0af5ddcdbbb6eb0$var$ActionErrorType;
(function(ActionErrorType) {
    // The action contained a stale state ID
    ActionErrorType["StaleStateId"] = "action/stale_state_id";
    // The requested move is unknown or not currently available
    ActionErrorType["UnavailableMove"] = "action/unavailable_move";
    // The move declared it was invalid (INVALID_MOVE constant)
    ActionErrorType["InvalidMove"] = "action/invalid_move";
    // The player making the action is not currently active
    ActionErrorType["InactivePlayer"] = "action/inactive_player";
    // The game has finished
    ActionErrorType["GameOver"] = "action/gameover";
    // The requested action is disabled (e.g. undo/redo, events)
    ActionErrorType["ActionDisabled"] = "action/action_disabled";
    // The requested action is not currently possible
    ActionErrorType["ActionInvalid"] = "action/action_invalid";
    // The requested action was declared invalid by a plugin
    ActionErrorType["PluginActionInvalid"] = "action/plugin_invalid";
})($c0af5ddcdbbb6eb0$var$ActionErrorType || ($c0af5ddcdbbb6eb0$var$ActionErrorType = {}));
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Check if the payload for the passed action contains a playerID.
 */ const $c0af5ddcdbbb6eb0$var$actionHasPlayerID = (action)=>action.payload.playerID !== null && action.payload.playerID !== undefined;
/**
 * Returns true if a move can be undone.
 */ const $c0af5ddcdbbb6eb0$var$CanUndoMove = (G, ctx, move)=>{
    function HasUndoable(move) {
        return move.undoable !== undefined;
    }
    function IsFunction(undoable) {
        return undoable instanceof Function;
    }
    if (!HasUndoable(move)) return true;
    if (IsFunction(move.undoable)) return move.undoable({
        G: G,
        ctx: ctx
    });
    return move.undoable;
};
/**
 * Update the undo and redo stacks for a move or event.
 */ function $c0af5ddcdbbb6eb0$var$updateUndoRedoState(state, opts) {
    if (opts.game.disableUndo) return state;
    const undoEntry = {
        G: state.G,
        ctx: state.ctx,
        plugins: state.plugins,
        playerID: opts.action.payload.playerID || state.ctx.currentPlayer
    };
    if (opts.action.type === 'MAKE_MOVE') undoEntry.moveType = opts.action.payload.type;
    return {
        ...state,
        _undo: [
            ...state._undo,
            undoEntry
        ],
        // Always reset redo stack when making a move or event
        _redo: []
    };
}
/**
 * Process state, adding the initial deltalog for this action.
 */ function $c0af5ddcdbbb6eb0$var$initializeDeltalog(state, action, move) {
    // Create a log entry for this action.
    const logEntry = {
        action: action,
        _stateID: state._stateID,
        turn: state.ctx.turn,
        phase: state.ctx.phase
    };
    const pluginLogMetadata = state.plugins.log.data.metadata;
    if (pluginLogMetadata !== undefined) logEntry.metadata = pluginLogMetadata;
    if (typeof move === 'object' && move.redact === true) logEntry.redact = true;
    else if (typeof move === 'object' && move.redact instanceof Function) logEntry.redact = move.redact({
        G: state.G,
        ctx: state.ctx
    });
    return {
        ...state,
        deltalog: [
            logEntry
        ]
    };
}
/**
 * Update plugin state after move/event & check if plugins consider the action to be valid.
 * @param state Current version of state in the reducer.
 * @param oldState State to revert to in case of error.
 * @param pluginOpts Plugin configuration options.
 * @returns Tuple of the new state updated after flushing plugins and the old
 * state augmented with an error if a plugin declared the action invalid.
 */ function $c0af5ddcdbbb6eb0$var$flushAndValidatePlugins(state, oldState, pluginOpts) {
    const [newState, isInvalid] = (0, $b0ae1e6bca8d95a9$export$9e5f44173e64f162)(state, pluginOpts);
    if (!isInvalid) return [
        newState
    ];
    return [
        newState,
        $c0af5ddcdbbb6eb0$var$WithError(oldState, $c0af5ddcdbbb6eb0$var$ActionErrorType.PluginActionInvalid, isInvalid)
    ];
}
/**
 * ExtractTransientsFromState
 *
 * Split out transients from the a TransientState
 */ function $c0af5ddcdbbb6eb0$var$ExtractTransients(transientState) {
    if (!transientState) // We preserve null for the state for legacy callers, but the transient
    // field should be undefined if not present to be consistent with the
    // code path below.
    return [
        null,
        undefined
    ];
    const { transients: transients, ...state } = transientState;
    return [
        state,
        transients
    ];
}
/**
 * WithError
 *
 * Augment a State instance with transient error information.
 */ function $c0af5ddcdbbb6eb0$var$WithError(state, errorType, payload) {
    const error = {
        type: errorType,
        payload: payload
    };
    return {
        ...state,
        transients: {
            error: error
        }
    };
}
/**
 * Middleware for processing TransientState associated with the reducer
 * returned by CreateGameReducer.
 * This should pretty much be used everywhere you want realistic state
 * transitions and error handling.
 */ const $c0af5ddcdbbb6eb0$export$971d5caa766a69d7 = (store)=>(next)=>(action)=>{
            const result = next(action);
            switch(action.type){
                case 0, $b0ae1e6bca8d95a9$export$ffb5f4729a158638:
                    return result;
                default:
                    {
                        const [, transients] = $c0af5ddcdbbb6eb0$var$ExtractTransients(store.getState());
                        if (typeof transients !== 'undefined') {
                            store.dispatch((0, $b0ae1e6bca8d95a9$export$43caf9889c228507)());
                            // Dev Note: If parent middleware needs to correlate the spawned
                            // StripTransients action to the triggering action, instrument here.
                            //
                            // This is a bit tricky; for more details, see:
                            //   https://github.com/boardgameio/boardgame.io/pull/940#discussion_r636200648
                            return {
                                ...result,
                                transients: transients
                            };
                        }
                        return result;
                    }
            }
        };
/**
 * CreateGameReducer
 *
 * Creates the main game state reducer.
 */ function $c0af5ddcdbbb6eb0$export$e7094788287c5e9b({ game: game, isClient: isClient }) {
    game = $c0af5ddcdbbb6eb0$export$56c0d5a1e737357d(game);
    /**
     * GameReducer
     *
     * Redux reducer that maintains the overall game state.
     * @param {object} state - The state before the action.
     * @param {object} action - A Redux action.
     */ return (stateWithTransients = null, action)=>{
        let [state /*, transients */ ] = $c0af5ddcdbbb6eb0$var$ExtractTransients(stateWithTransients);
        switch(action.type){
            case 0, $b0ae1e6bca8d95a9$export$ffb5f4729a158638:
                // This action indicates that transient metadata in the state has been
                // consumed and should now be stripped from the state..
                return state;
            case 0, $b0ae1e6bca8d95a9$export$ae1af26003f05816:
                {
                    state = {
                        ...state,
                        deltalog: []
                    };
                    // Process game events only on the server.
                    // These events like `endTurn` typically
                    // contain code that may rely on secret state
                    // and cannot be computed on the client.
                    if (isClient) return state;
                    // Disallow events once the game is over.
                    if (state.ctx.gameover !== undefined) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`cannot call event after game end`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.GameOver);
                    }
                    // Ignore the event if the player isn't active.
                    if ($c0af5ddcdbbb6eb0$var$actionHasPlayerID(action) && !game.flow.isPlayerActive(state.G, state.ctx, action.payload.playerID)) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`disallowed event: ${action.payload.type}`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.InactivePlayer);
                    }
                    // Execute plugins.
                    state = (0, $b0ae1e6bca8d95a9$export$a9c23c6ac3fc3eca)(state, {
                        game: game,
                        isClient: false,
                        playerID: action.payload.playerID
                    });
                    // Process event.
                    let newState = game.flow.processEvent(state, action);
                    // Execute plugins.
                    let stateWithError;
                    [newState, stateWithError] = $c0af5ddcdbbb6eb0$var$flushAndValidatePlugins(newState, state, {
                        game: game,
                        isClient: false
                    });
                    if (stateWithError) return stateWithError;
                    // Update undo / redo state.
                    newState = $c0af5ddcdbbb6eb0$var$updateUndoRedoState(newState, {
                        game: game,
                        action: action
                    });
                    return {
                        ...newState,
                        _stateID: state._stateID + 1
                    };
                }
            case 0, $b0ae1e6bca8d95a9$export$3a1a48c8f6ef640e:
                {
                    const oldState = state = {
                        ...state,
                        deltalog: []
                    };
                    // Check whether the move is allowed at this time.
                    const move = game.flow.getMove(state.ctx, action.payload.type, action.payload.playerID || state.ctx.currentPlayer);
                    if (move === null) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`disallowed move: ${action.payload.type}`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.UnavailableMove);
                    }
                    // Don't run move on client if move says so.
                    if (isClient && move.client === false) return state;
                    // Disallow moves once the game is over.
                    if (state.ctx.gameover !== undefined) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`cannot make move after game end`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.GameOver);
                    }
                    // Ignore the move if the player isn't active.
                    if ($c0af5ddcdbbb6eb0$var$actionHasPlayerID(action) && !game.flow.isPlayerActive(state.G, state.ctx, action.payload.playerID)) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`disallowed move: ${action.payload.type}`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.InactivePlayer);
                    }
                    // Execute plugins.
                    state = (0, $b0ae1e6bca8d95a9$export$a9c23c6ac3fc3eca)(state, {
                        game: game,
                        isClient: isClient,
                        playerID: action.payload.playerID
                    });
                    // Process the move.
                    const G = game.processMove(state, action.payload);
                    // The game declared the move as invalid.
                    if (G === (0, $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5)) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`invalid move: ${action.payload.type} args: ${action.payload.args}`);
                        // TODO(#723): Marshal a nice error payload with the processed move.
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.InvalidMove);
                    }
                    const newState = {
                        ...state,
                        G: G
                    };
                    // Some plugin indicated that it is not suitable to be
                    // materialized on the client (and must wait for the server
                    // response instead).
                    if (isClient && (0, $b0ae1e6bca8d95a9$export$a07804094c3ecf2d)(newState, {
                        game: game
                    })) return state;
                    state = newState;
                    // If we're on the client, just process the move
                    // and no triggers in multiplayer mode.
                    // These will be processed on the server, which
                    // will send back a state update.
                    if (isClient) {
                        let stateWithError;
                        [state, stateWithError] = $c0af5ddcdbbb6eb0$var$flushAndValidatePlugins(state, oldState, {
                            game: game,
                            isClient: true
                        });
                        if (stateWithError) return stateWithError;
                        return {
                            ...state,
                            _stateID: state._stateID + 1
                        };
                    }
                    // On the server, construct the deltalog.
                    state = $c0af5ddcdbbb6eb0$var$initializeDeltalog(state, action, move);
                    // Allow the flow reducer to process any triggers that happen after moves.
                    state = game.flow.processMove(state, action.payload);
                    let stateWithError;
                    [state, stateWithError] = $c0af5ddcdbbb6eb0$var$flushAndValidatePlugins(state, oldState, {
                        game: game
                    });
                    if (stateWithError) return stateWithError;
                    // Update undo / redo state.
                    state = $c0af5ddcdbbb6eb0$var$updateUndoRedoState(state, {
                        game: game,
                        action: action
                    });
                    return {
                        ...state,
                        _stateID: state._stateID + 1
                    };
                }
            case 0, $b0ae1e6bca8d95a9$export$953cecd6e717a553:
            case 0, $b0ae1e6bca8d95a9$export$882b5998b3b9117c:
            case 0, $b0ae1e6bca8d95a9$export$342063e11d6c3cad:
                return action.state;
            case 0, $b0ae1e6bca8d95a9$export$35e795649ee09318:
                {
                    state = {
                        ...state,
                        deltalog: []
                    };
                    if (game.disableUndo) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)('Undo is not enabled');
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionDisabled);
                    }
                    const { G: G, ctx: ctx, _undo: _undo, _redo: _redo, _stateID: _stateID } = state;
                    if (_undo.length < 2) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`No moves to undo`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionInvalid);
                    }
                    const last = _undo[_undo.length - 1];
                    const restore = _undo[_undo.length - 2];
                    // Only allow players to undo their own moves.
                    if ($c0af5ddcdbbb6eb0$var$actionHasPlayerID(action) && action.payload.playerID !== last.playerID) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`Cannot undo other players' moves`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionInvalid);
                    }
                    // If undoing a move, check it is undoable.
                    if (last.moveType) {
                        const lastMove = game.flow.getMove(restore.ctx, last.moveType, last.playerID);
                        if (!$c0af5ddcdbbb6eb0$var$CanUndoMove(G, ctx, lastMove)) {
                            (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`Move cannot be undone`);
                            return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionInvalid);
                        }
                    }
                    state = $c0af5ddcdbbb6eb0$var$initializeDeltalog(state, action);
                    return {
                        ...state,
                        G: restore.G,
                        ctx: restore.ctx,
                        plugins: restore.plugins,
                        _stateID: _stateID + 1,
                        _undo: _undo.slice(0, -1),
                        _redo: [
                            last,
                            ..._redo
                        ]
                    };
                }
            case 0, $b0ae1e6bca8d95a9$export$db202ddc8be9136:
                {
                    state = {
                        ...state,
                        deltalog: []
                    };
                    if (game.disableUndo) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)('Redo is not enabled');
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionDisabled);
                    }
                    const { _undo: _undo, _redo: _redo, _stateID: _stateID } = state;
                    if (_redo.length === 0) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`No moves to redo`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionInvalid);
                    }
                    const first = _redo[0];
                    // Only allow players to redo their own undos.
                    if ($c0af5ddcdbbb6eb0$var$actionHasPlayerID(action) && action.payload.playerID !== first.playerID) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`Cannot redo other players' moves`);
                        return $c0af5ddcdbbb6eb0$var$WithError(state, $c0af5ddcdbbb6eb0$var$ActionErrorType.ActionInvalid);
                    }
                    state = $c0af5ddcdbbb6eb0$var$initializeDeltalog(state, action);
                    return {
                        ...state,
                        G: first.G,
                        ctx: first.ctx,
                        plugins: first.plugins,
                        _stateID: _stateID + 1,
                        _undo: [
                            ..._undo,
                            first
                        ],
                        _redo: _redo.slice(1)
                    };
                }
            case 0, $b0ae1e6bca8d95a9$export$2d1720544b23b823:
                // TODO(#723): Expose error semantics to plugin processing.
                return (0, $b0ae1e6bca8d95a9$export$dda1d9f60106f0e9)(state, action, {
                    game: game
                });
            case 0, $b0ae1e6bca8d95a9$export$56c0d5a1e737357d:
                {
                    const oldState = state;
                    const newState = JSON.parse(JSON.stringify(oldState));
                    const patchError = (0, $06105d02a3bc31a3$exports.applyPatch)(newState, action.patch);
                    const hasError = patchError.some((entry)=>entry !== null);
                    if (hasError) {
                        (0, $b0ae1e6bca8d95a9$export$f1e1789686576879)(`Patch ${JSON.stringify(action.patch)} apply failed`);
                        return $c0af5ddcdbbb6eb0$var$WithError(oldState, $c0af5ddcdbbb6eb0$var$UpdateErrorType.PatchFailed, patchError);
                    } else return newState;
                }
            default:
                return state;
        }
    };
}




/*
 * Copyright 2020 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Creates the initial game state.
 */ function $db45a927a1518596$export$9bb611d729802a56({ game: game, numPlayers: numPlayers, setupData: setupData }) {
    game = (0, $c0af5ddcdbbb6eb0$export$56c0d5a1e737357d)(game);
    if (!numPlayers) numPlayers = 2;
    const ctx = game.flow.ctx(numPlayers);
    let state = {
        // User managed state.
        G: {},
        ctx: // Framework managed state.
        ctx,
        // Plugin related state.
        plugins: {}
    };
    // Run plugins over initial state.
    state = (0, $b0ae1e6bca8d95a9$export$625550452a3fa3ec)(state, {
        game: game
    });
    state = (0, $b0ae1e6bca8d95a9$export$a9c23c6ac3fc3eca)(state, {
        game: game,
        playerID: undefined
    });
    const pluginAPIs = (0, $b0ae1e6bca8d95a9$export$407448d2b89b1813)(state);
    state.G = game.setup({
        ...pluginAPIs,
        ctx: state.ctx
    }, setupData);
    let initial = {
        ...state,
        // List of {G, ctx} pairs that can be undone.
        _undo: [],
        // List of {G, ctx} pairs that can be redone.
        _redo: [],
        // A monotonically non-decreasing ID to ensure that
        // state updates are only allowed from clients that
        // are at the same version that the server.
        _stateID: 0
    };
    initial = game.flow.init(initial);
    [initial] = (0, $b0ae1e6bca8d95a9$export$9e5f44173e64f162)(initial, {
        game: game
    });
    // Initialize undo stack.
    if (!game.disableUndo) initial._undo = [
        {
            G: initial.G,
            ctx: initial.ctx,
            plugins: initial.plugins
        }
    ];
    return initial;
}


/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ class $2347415c38c40b90$export$971d5caa766a69d7 {
    constructor({ transportDataCallback: transportDataCallback, gameName: gameName, playerID: playerID, matchID: matchID, credentials: credentials, numPlayers: numPlayers }){
        /** Callback to let the client know when the connection status has changed. */ this.connectionStatusCallback = ()=>{};
        this.isConnected = false;
        this.transportDataCallback = transportDataCallback;
        this.gameName = gameName || 'default';
        this.playerID = playerID || null;
        this.matchID = matchID || 'default';
        this.credentials = credentials;
        this.numPlayers = numPlayers || 2;
    }
    /** Subscribe to connection state changes. */ subscribeToConnectionStatus(fn) {
        this.connectionStatusCallback = fn;
    }
    /** Transport implementations should call this when they connect/disconnect. */ setConnectionStatus(isConnected) {
        this.isConnected = isConnected;
        this.connectionStatusCallback();
    }
    /** Transport implementations should call this when they receive data from a master. */ notifyClient(data) {
        this.transportDataCallback(data);
    }
}


/**
 * This class doesn’t do anything, but simplifies the client class by providing
 * dummy functions to call, so we don’t need to mock them in the client.
 */ class $9911eba7eef15d22$var$DummyImpl extends (0, $2347415c38c40b90$export$971d5caa766a69d7) {
    connect() {}
    disconnect() {}
    sendAction() {}
    sendChatMessage() {}
    requestSync() {}
    updateCredentials() {}
    updateMatchID() {}
    updatePlayerID() {}
}
const $9911eba7eef15d22$var$DummyTransport = (opts)=>new $9911eba7eef15d22$var$DummyImpl(opts);
/**
 * Class to manage boardgame.io clients and limit debug panel rendering.
 */ class $9911eba7eef15d22$var$ClientManager {
    constructor(){
        this.debugPanel = null;
        this.currentClient = null;
        this.clients = new Map();
        this.subscribers = new Map();
    }
    /**
     * Register a client with the client manager.
     */ register(client) {
        // Add client to clients map.
        this.clients.set(client, client);
        // Mount debug for this client (no-op if another debug is already mounted).
        this.mountDebug(client);
        this.notifySubscribers();
    }
    /**
     * Unregister a client from the client manager.
     */ unregister(client) {
        // Remove client from clients map.
        this.clients.delete(client);
        if (this.currentClient === client) {
            // If the removed client owned the debug panel, unmount it.
            this.unmountDebug();
            // Mount debug panel for next available client.
            for (const [client] of this.clients){
                if (this.debugPanel) break;
                this.mountDebug(client);
            }
        }
        this.notifySubscribers();
    }
    /**
     * Subscribe to the client manager state.
     * Calls the passed callback each time the current client changes or a client
     * registers/unregisters.
     * Returns a function to unsubscribe from the state updates.
     */ subscribe(callback) {
        const id = Symbol();
        this.subscribers.set(id, callback);
        callback(this.getState());
        return ()=>{
            this.subscribers.delete(id);
        };
    }
    /**
     * Switch to a client with a matching playerID.
     */ switchPlayerID(playerID) {
        // For multiplayer clients, try switching control to a different client
        // that is using the same transport layer.
        if (this.currentClient.multiplayer) {
            for (const [client] of this.clients)if (client.playerID === playerID && client.debugOpt !== false && client.multiplayer === this.currentClient.multiplayer) {
                this.switchToClient(client);
                return;
            }
        }
        // If no client matches, update the playerID for the current client.
        this.currentClient.updatePlayerID(playerID);
        this.notifySubscribers();
    }
    /**
     * Set the passed client as the active client for debugging.
     */ switchToClient(client) {
        if (client === this.currentClient) return;
        this.unmountDebug();
        this.mountDebug(client);
        this.notifySubscribers();
    }
    /**
     * Notify all subscribers of changes to the client manager state.
     */ notifySubscribers() {
        const arg = this.getState();
        this.subscribers.forEach((cb)=>{
            cb(arg);
        });
    }
    /**
     * Get the client manager state.
     */ getState() {
        return {
            client: this.currentClient,
            debuggableClients: this.getDebuggableClients()
        };
    }
    /**
     * Get an array of the registered clients that haven’t disabled the debug panel.
     */ getDebuggableClients() {
        return [
            ...this.clients.values()
        ].filter((client)=>client.debugOpt !== false);
    }
    /**
     * Mount the debug panel using the passed client.
     */ mountDebug(client) {
        if (client.debugOpt === false || this.debugPanel !== null || typeof document === 'undefined') return;
        let DebugImpl;
        let target = document.body;
        if (client.debugOpt && client.debugOpt !== true) {
            DebugImpl = client.debugOpt.impl || DebugImpl;
            target = client.debugOpt.target || target;
        }
        if (DebugImpl) {
            this.currentClient = client;
            this.debugPanel = new DebugImpl({
                target: target,
                props: {
                    clientManager: this
                }
            });
        }
    }
    /**
     * Unmount the debug panel.
     */ unmountDebug() {
        this.debugPanel.$destroy();
        this.debugPanel = null;
        this.currentClient = null;
    }
}
/*
 * Copyright 2017 The boardgame.io Authors
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */ /**
 * Global client manager instance that all clients register with.
 */ const $9911eba7eef15d22$var$GlobalClientManager = new $9911eba7eef15d22$var$ClientManager();
/**
 * Standardise the passed playerID, using currentPlayer if appropriate.
 */ function $9911eba7eef15d22$var$assumedPlayerID(playerID, store, multiplayer) {
    // In singleplayer mode, if the client does not have a playerID
    // associated with it, we attach the currentPlayer as playerID.
    if (!multiplayer && (playerID === null || playerID === undefined)) {
        const state = store.getState();
        playerID = state.ctx.currentPlayer;
    }
    return playerID;
}
/**
 * createDispatchers
 *
 * Create action dispatcher wrappers with bound playerID and credentials
 */ function $9911eba7eef15d22$var$createDispatchers(storeActionType, innerActionNames, store, playerID, credentials, multiplayer) {
    const dispatchers = {};
    for (const name of innerActionNames)dispatchers[name] = (...args)=>{
        const action = (0, $b0ae1e6bca8d95a9$export$ebd11618f299a286)[storeActionType](name, args, $9911eba7eef15d22$var$assumedPlayerID(playerID, store, multiplayer), credentials);
        store.dispatch(action);
    };
    return dispatchers;
}
// Creates a set of dispatchers to make moves.
const $9911eba7eef15d22$var$createMoveDispatchers = $9911eba7eef15d22$var$createDispatchers.bind(null, 'makeMove');
// Creates a set of dispatchers to dispatch game flow events.
const $9911eba7eef15d22$var$createEventDispatchers = $9911eba7eef15d22$var$createDispatchers.bind(null, 'gameEvent');
// Creates a set of dispatchers to dispatch actions to plugins.
const $9911eba7eef15d22$var$createPluginDispatchers = $9911eba7eef15d22$var$createDispatchers.bind(null, 'plugin');
/**
 * Implementation of Client (see below).
 */ class $9911eba7eef15d22$var$_ClientImpl {
    constructor({ game: game, debug: debug, numPlayers: numPlayers, multiplayer: multiplayer, matchID: matchID, playerID: playerID, credentials: credentials, enhancer: enhancer }){
        this.game = (0, $c0af5ddcdbbb6eb0$export$56c0d5a1e737357d)(game);
        this.playerID = playerID;
        this.matchID = matchID || 'default';
        this.credentials = credentials;
        this.multiplayer = multiplayer;
        this.debugOpt = debug;
        this.manager = $9911eba7eef15d22$var$GlobalClientManager;
        this.gameStateOverride = null;
        this.subscribers = {};
        this._running = false;
        this.reducer = (0, $c0af5ddcdbbb6eb0$export$e7094788287c5e9b)({
            game: this.game,
            isClient: multiplayer !== undefined
        });
        this.initialState = null;
        if (!multiplayer) this.initialState = (0, $db45a927a1518596$export$9bb611d729802a56)({
            game: this.game,
            numPlayers: numPlayers
        });
        this.reset = ()=>{
            this.store.dispatch((0, $b0ae1e6bca8d95a9$export$3b14a55fb2447963)(this.initialState));
        };
        this.undo = ()=>{
            const undo$1 = (0, $b0ae1e6bca8d95a9$export$90a7f3efeed30595)($9911eba7eef15d22$var$assumedPlayerID(this.playerID, this.store, this.multiplayer), this.credentials);
            this.store.dispatch(undo$1);
        };
        this.redo = ()=>{
            const redo$1 = (0, $b0ae1e6bca8d95a9$export$efccba1c4a2ef57b)($9911eba7eef15d22$var$assumedPlayerID(this.playerID, this.store, this.multiplayer), this.credentials);
            this.store.dispatch(redo$1);
        };
        this.log = [];
        /**
         * Middleware that manages the log object.
         * Reducers generate deltalogs, which are log events
         * that are the result of application of a single action.
         * The master may also send back a deltalog or the entire
         * log depending on the type of request.
         * The middleware below takes care of all these cases while
         * managing the log object.
         */ const LogMiddleware = (store)=>(next)=>(action)=>{
                    const result = next(action);
                    const state = store.getState();
                    switch(action.type){
                        case 0, $b0ae1e6bca8d95a9$export$3a1a48c8f6ef640e:
                        case 0, $b0ae1e6bca8d95a9$export$ae1af26003f05816:
                        case 0, $b0ae1e6bca8d95a9$export$35e795649ee09318:
                        case 0, $b0ae1e6bca8d95a9$export$db202ddc8be9136:
                            {
                                const deltalog = state.deltalog;
                                this.log = [
                                    ...this.log,
                                    ...deltalog
                                ];
                                break;
                            }
                        case 0, $b0ae1e6bca8d95a9$export$953cecd6e717a553:
                            this.log = [];
                            break;
                        case 0, $b0ae1e6bca8d95a9$export$56c0d5a1e737357d:
                        case 0, $b0ae1e6bca8d95a9$export$882b5998b3b9117c:
                            {
                                let id = -1;
                                if (this.log.length > 0) id = this.log[this.log.length - 1]._stateID;
                                let deltalog = action.deltalog || [];
                                // Filter out actions that are already present
                                // in the current log. This may occur when the
                                // client adds an entry to the log followed by
                                // the update from the master here.
                                deltalog = deltalog.filter((l)=>l._stateID > id);
                                this.log = [
                                    ...this.log,
                                    ...deltalog
                                ];
                                break;
                            }
                        case 0, $b0ae1e6bca8d95a9$export$342063e11d6c3cad:
                            this.initialState = action.initialState;
                            this.log = action.log || [];
                            break;
                    }
                    return result;
                };
        /**
         * Middleware that intercepts actions and sends them to the master,
         * which keeps the authoritative version of the state.
         */ const TransportMiddleware = (store)=>(next)=>(action)=>{
                    const baseState = store.getState();
                    const result = next(action);
                    if (!('clientOnly' in action) && action.type !== (0, $b0ae1e6bca8d95a9$export$ffb5f4729a158638)) this.transport.sendAction(baseState, action);
                    return result;
                };
        /**
         * Middleware that intercepts actions and invokes the subscription callback.
         */ const SubscriptionMiddleware = ()=>(next)=>(action)=>{
                    const result = next(action);
                    this.notifySubscribers();
                    return result;
                };
        const middleware = (0, $ad4393542232627c$export$9ff26e0402cc7b7)((0, $c0af5ddcdbbb6eb0$export$971d5caa766a69d7), SubscriptionMiddleware, TransportMiddleware, LogMiddleware);
        enhancer = enhancer !== undefined ? (0, $ad4393542232627c$export$f672e0b6f7222cd7)(middleware, enhancer) : middleware;
        this.store = (0, $ad4393542232627c$export$f51a9068ac82ea43)(this.reducer, this.initialState, enhancer);
        if (!multiplayer) multiplayer = $9911eba7eef15d22$var$DummyTransport;
        this.transport = multiplayer({
            transportDataCallback: (data)=>this.receiveTransportData(data),
            gameKey: game,
            game: this.game,
            matchID: matchID,
            playerID: playerID,
            credentials: credentials,
            gameName: this.game.name,
            numPlayers: numPlayers
        });
        this.createDispatchers();
        this.chatMessages = [];
        this.sendChatMessage = (payload)=>{
            this.transport.sendChatMessage(this.matchID, {
                id: (0, $3753227fdc8a3f3b$export$ac4959f4f1338dfc)(7),
                sender: this.playerID,
                payload: payload
            });
        };
    }
    /** Handle incoming match data from a multiplayer transport. */ receiveMatchData(matchData) {
        this.matchData = matchData;
        this.notifySubscribers();
    }
    /** Handle an incoming chat message from a multiplayer transport. */ receiveChatMessage(message) {
        this.chatMessages = [
            ...this.chatMessages,
            message
        ];
        this.notifySubscribers();
    }
    /** Handle all incoming updates from a multiplayer transport. */ receiveTransportData(data) {
        const [matchID] = data.args;
        if (matchID !== this.matchID) return;
        switch(data.type){
            case 'sync':
                {
                    const [, syncInfo] = data.args;
                    const action = (0, $b0ae1e6bca8d95a9$export$2408f22a0fab9ae5)(syncInfo);
                    this.receiveMatchData(syncInfo.filteredMetadata);
                    this.store.dispatch(action);
                    break;
                }
            case 'update':
                {
                    const [, state, deltalog] = data.args;
                    const currentState = this.store.getState();
                    if (state._stateID >= currentState._stateID) {
                        const action = (0, $b0ae1e6bca8d95a9$export$df995fae86a55f06)(state, deltalog);
                        this.store.dispatch(action);
                    }
                    break;
                }
            case 'patch':
                {
                    const [, prevStateID, stateID, patch$1, deltalog] = data.args;
                    const currentStateID = this.store.getState()._stateID;
                    if (prevStateID !== currentStateID) break;
                    const action = (0, $b0ae1e6bca8d95a9$export$4a5767248b18ef41)(prevStateID, stateID, patch$1, deltalog);
                    this.store.dispatch(action);
                    // Emit sync if patch apply failed.
                    if (this.store.getState()._stateID === currentStateID) this.transport.requestSync();
                    break;
                }
            case 'matchData':
                {
                    const [, matchData] = data.args;
                    this.receiveMatchData(matchData);
                    break;
                }
            case 'chat':
                {
                    const [, chatMessage] = data.args;
                    this.receiveChatMessage(chatMessage);
                    break;
                }
        }
    }
    notifySubscribers() {
        Object.values(this.subscribers).forEach((fn)=>fn(this.getState()));
    }
    overrideGameState(state) {
        this.gameStateOverride = state;
        this.notifySubscribers();
    }
    start() {
        this.transport.connect();
        this._running = true;
        this.manager.register(this);
    }
    stop() {
        this.transport.disconnect();
        this._running = false;
        this.manager.unregister(this);
    }
    subscribe(fn) {
        const id = Object.keys(this.subscribers).length;
        this.subscribers[id] = fn;
        this.transport.subscribeToConnectionStatus(()=>this.notifySubscribers());
        if (this._running || !this.multiplayer) fn(this.getState());
        // Return a handle that allows the caller to unsubscribe.
        return ()=>{
            delete this.subscribers[id];
        };
    }
    getInitialState() {
        return this.initialState;
    }
    getState() {
        let state = this.store.getState();
        if (this.gameStateOverride !== null) state = this.gameStateOverride;
        // This is the state before a sync with the game master.
        if (state === null) return state;
        // isActive.
        let isActive = true;
        const isPlayerActive = this.game.flow.isPlayerActive(state.G, state.ctx, this.playerID);
        if (this.multiplayer && !isPlayerActive) isActive = false;
        if (!this.multiplayer && this.playerID !== null && this.playerID !== undefined && !isPlayerActive) isActive = false;
        if (state.ctx.gameover !== undefined) isActive = false;
        // Secrets are normally stripped on the server,
        // but we also strip them here so that game developers
        // can see their effects while prototyping.
        // Do not strip again if this is a multiplayer game
        // since the server has already stripped secret info. (issue #818)
        if (!this.multiplayer) state = {
            ...state,
            G: this.game.playerView({
                G: state.G,
                ctx: state.ctx,
                playerID: this.playerID
            }),
            plugins: (0, $b0ae1e6bca8d95a9$export$d141bba7fdc215a3)(state, this)
        };
        // Combine into return value.
        return {
            ...state,
            log: this.log,
            isActive: isActive,
            isConnected: this.transport.isConnected
        };
    }
    createDispatchers() {
        this.moves = $9911eba7eef15d22$var$createMoveDispatchers(this.game.moveNames, this.store, this.playerID, this.credentials, this.multiplayer);
        this.events = $9911eba7eef15d22$var$createEventDispatchers(this.game.flow.enabledEventNames, this.store, this.playerID, this.credentials, this.multiplayer);
        this.plugins = $9911eba7eef15d22$var$createPluginDispatchers(this.game.pluginNames, this.store, this.playerID, this.credentials, this.multiplayer);
    }
    updatePlayerID(playerID) {
        this.playerID = playerID;
        this.createDispatchers();
        this.transport.updatePlayerID(playerID);
        this.notifySubscribers();
    }
    updateMatchID(matchID) {
        this.matchID = matchID;
        this.createDispatchers();
        this.transport.updateMatchID(matchID);
        this.notifySubscribers();
    }
    updateCredentials(credentials) {
        this.credentials = credentials;
        this.createDispatchers();
        this.transport.updateCredentials(credentials);
        this.notifySubscribers();
    }
}
/**
 * Client
 *
 * boardgame.io JS client.
 *
 * @param {...object} game - The return value of `Game`.
 * @param {...object} numPlayers - The number of players.
 * @param {...object} multiplayer - Set to a falsy value or a transportFactory, e.g., SocketIO()
 * @param {...object} matchID - The matchID that you want to connect to.
 * @param {...object} playerID - The playerID associated with this client.
 * @param {...string} credentials - The authentication credentials associated with this client.
 *
 * Returns:
 *   A JS object that provides an API to interact with the
 *   game by dispatching moves and events.
 */ function $9911eba7eef15d22$export$e7094788287c5e9b(opts) {
    return new $9911eba7eef15d22$var$_ClientImpl(opts);
}




const $7b066675d1aa79fa$var$GRID_CENTER = [
    3,
    3
];
const $7b066675d1aa79fa$var$GRID_RADIUS = 3;
function $7b066675d1aa79fa$var$makeGrid() {
    const Tile = (0, $16061e18e8668e97$export$98781bdbfe5970f1)({
        origin: 'topLeft',
        dimensions: 30
    });
    return new (0, $16061e18e8668e97$export$ef2184bd89960b14)(Tile, (0, $16061e18e8668e97$export$a70866d5e0158cdc)({
        start: $7b066675d1aa79fa$var$GRID_CENTER,
        radius: $7b066675d1aa79fa$var$GRID_RADIUS
    }));
}
const $7b066675d1aa79fa$var$GRID = $7b066675d1aa79fa$var$makeGrid();
function $7b066675d1aa79fa$var$setup() {
    const outer_ring_traverer = (0, $16061e18e8668e97$export$e7d0da6968da5dd)({
        center: $7b066675d1aa79fa$var$GRID_CENTER,
        radius: $7b066675d1aa79fa$var$GRID_RADIUS
    });
    let stones = [];
    let c = 'white';
    $7b066675d1aa79fa$var$GRID.traverse(outer_ring_traverer).forEach((hex)=>{
        stones.push({
            color: c,
            q: hex.q,
            r: hex.r
        });
        c = c === "white" ? "black" : "white";
    });
    let mb = $7b066675d1aa79fa$var$GRID.neighborOf($7b066675d1aa79fa$var$GRID_CENTER, (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).E);
    stones.push({
        color: "black",
        q: mb.q,
        r: mb.r
    });
    let mw = $7b066675d1aa79fa$var$GRID.neighborOf($7b066675d1aa79fa$var$GRID_CENTER, (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).W);
    stones.push({
        color: "white",
        q: mw.q,
        r: mw.r
    });
    return {
        grid: JSON.stringify($7b066675d1aa79fa$var$GRID),
        stones: stones
    };
}
function $7b066675d1aa79fa$var$pointyDirections() {
    return [
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).NE,
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).E,
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).SE,
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).SW,
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).W,
        (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).NW
    ];
}
function $7b066675d1aa79fa$var$pickStone({ G: G, events: events }, id) {
    const idhex = $7b066675d1aa79fa$var$GRID.getHex(id);
    if (idhex) {
        let stone_i = G.stones.findIndex((s)=>$7b066675d1aa79fa$var$isSameHex(s, idhex));
        let color = stone_i === -1 ? null : G.stones[stone_i].color;
        if (color) {
            const stone = G.stones[stone_i];
            if (G.current.length === 0) {
                G.current.push(stone_i);
                return;
            } else if (G.current.length === 1) {
                const prev = G.stones[G.current[0]];
                if ($7b066675d1aa79fa$var$isSameHex(prev, stone)) {
                    G.current.pop();
                    return;
                } else if (stone.color !== prev.color && $7b066675d1aa79fa$var$GRID.distance(stone, prev) === 1) G.current.push(stone_i);
            }
        }
    }
    if (G.current.length === 2) {
        events.setActivePlayers({
            currentPlayer: "putdown"
        });
        return;
    }
    return 0, $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5;
}
function $7b066675d1aa79fa$var$neighborDirection(src, wanted) {
    return {
        q: src.q - wanted.q,
        r: src.r - wanted.r
    };
}
function $7b066675d1aa79fa$var$isSameHex(h1, h2) {
    return h1.q === h2.q && h1.r === h2.r;
}
function $7b066675d1aa79fa$var$isSamePair(p1, p2) {
    return $7b066675d1aa79fa$var$isSameHex(p1[0], p2[0]) && $7b066675d1aa79fa$var$isSameHex(p1[1], p2[1]) || $7b066675d1aa79fa$var$isSameHex(p1[0], p2[1]) && $7b066675d1aa79fa$var$isSameHex(p1[1], p2[0]);
}
function $7b066675d1aa79fa$var$isUndo(G, move) {
    if (G.history.length === 0) return false;
    const last_move = G.history[G.history.length - 1];
    return $7b066675d1aa79fa$var$isSamePair(last_move.src, move.dest) && $7b066675d1aa79fa$var$isSamePair(last_move.dest, move.src);
}
function $7b066675d1aa79fa$var$movePair(grid, stones, pair, dest) {
    if (grid.getHex(dest) && stones.findIndex((s)=>$7b066675d1aa79fa$var$isSameHex(s, dest)) === -1) {
        const dist1 = grid.distance(dest, pair[1]);
        if (dist1 === 1) {
            const delta = $7b066675d1aa79fa$var$neighborDirection(pair[1], dest);
            console.debug([
                pair[1].q,
                pair[1].r
            ], "=>", dest, "in direction", delta);
            let dest0 = {
                q: pair[0].q - delta.q,
                r: pair[0].r - delta.r
            };
            console.debug([
                pair[0].q,
                pair[0].r
            ], "in direction", delta, "=>", dest0);
            if (grid.getHex(dest0)) {
                if ($7b066675d1aa79fa$var$isSameHex(dest0, pair[1]) || stones.findIndex((s)=>$7b066675d1aa79fa$var$isSameHex(s, dest0)) === -1) return {
                    src: [
                        {
                            ...pair[0]
                        },
                        {
                            ...pair[1]
                        }
                    ],
                    dest: [
                        {
                            q: dest0.q,
                            r: dest0.r,
                            color: pair[0].color
                        },
                        {
                            q: dest.q,
                            r: dest.r,
                            color: pair[1].color
                        }
                    ]
                };
            }
        }
    }
    return null;
}
function $7b066675d1aa79fa$var$putStone({ G: G, events: events }, id) {
    const idhex = $7b066675d1aa79fa$var$GRID.getHex(id);
    if (idhex) {
        let stone0 = G.stones[G.current[0]];
        let stone1 = G.stones[G.current[1]];
        if ($7b066675d1aa79fa$var$isSameHex(stone0, idhex) || $7b066675d1aa79fa$var$isSameHex(stone1, idhex)) {
            let this_move = {
                src: [
                    {
                        ...stone0
                    },
                    {
                        ...stone1
                    }
                ],
                dest: [
                    {
                        ...stone1
                    },
                    {
                        ...stone0
                    }
                ]
            };
            if (!$7b066675d1aa79fa$var$isUndo(G, this_move)) {
                G.history.push(this_move);
                let temp = stone0.color;
                stone0.color = stone1.color;
                stone1.color = temp;
                events.endTurn();
                return;
            }
        } else {
            let this_move = $7b066675d1aa79fa$var$movePair($7b066675d1aa79fa$var$GRID, G.stones, [
                stone0,
                stone1
            ], idhex);
            if (this_move != null) {
                if (!$7b066675d1aa79fa$var$isUndo(G, this_move)) {
                    G.history.push(this_move);
                    stone1.q = idhex.q;
                    stone1.r = idhex.r;
                    stone0.q = this_move.dest[0].q;
                    stone0.r = this_move.dest[0].r;
                    events.endTurn();
                    return;
                }
            }
        }
    }
    return 0, $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5;
}
function $7b066675d1aa79fa$var$undo({ G: G, events: events }) {
    if (G.history.length === 0) return 0, $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5;
    const to_undo = G.history.pop();
    const stone0_i = G.stones.findIndex((s)=>$7b066675d1aa79fa$var$isSameHex(s, to_undo.dest[0]));
    const stone1_i = G.stones.findIndex((s)=>$7b066675d1aa79fa$var$isSameHex(s, to_undo.dest[1]));
    G.stones[stone0_i].q = to_undo.src[0].q;
    G.stones[stone0_i].r = to_undo.src[0].r;
    G.stones[stone1_i].q = to_undo.src[1].q;
    G.stones[stone1_i].r = to_undo.src[1].r;
    events.endTurn();
}
function $7b066675d1aa79fa$var$clear({ G: G, events: events }) {
    G.current = [];
    events.setActivePlayers({
        currentPlayer: "pickup"
    });
}
function $7b066675d1aa79fa$var$fullMove({ G: G, events: events }, ...id) {
    if (id === null || id.length !== 6) return 0, $b0ae1e6bca8d95a9$export$7ccc53e8f1e7dfc5;
    $7b066675d1aa79fa$var$pickStone({
        G: G,
        events: events
    }, id.slice(0, 2));
    $7b066675d1aa79fa$var$pickStone({
        G: G,
        events: events
    }, id.slice(2, 4));
    $7b066675d1aa79fa$var$putStone({
        G: G,
        events: events
    }, id.slice(4, 6));
}
const $7b066675d1aa79fa$export$7718f34a11c79886 = {
    setup: ()=>({
            ...$7b066675d1aa79fa$var$setup(),
            history: [],
            current: [],
            winner: null,
            winning_line: null,
            players: {
                0: {
                    color: "white"
                },
                1: {
                    color: "black"
                }
            }
        }),
    turn: {
        onBegin: ({ G: G, events: events })=>{
            G.current = [];
            events.setActivePlayers({
                currentPlayer: "pickup"
            });
        },
        stages: {
            pickup: {
                moves: {
                    clickCell: $7b066675d1aa79fa$var$pickStone,
                    undo: $7b066675d1aa79fa$var$undo,
                    clear: $7b066675d1aa79fa$var$clear,
                    fullMove: $7b066675d1aa79fa$var$fullMove
                },
                next: 'putdown'
            },
            putdown: {
                moves: {
                    clickCell: $7b066675d1aa79fa$var$putStone,
                    clear: $7b066675d1aa79fa$var$clear
                }
            }
        },
        onEnd: ({ G: G, events: events })=>{
            if (G.history.length === 0) return;
            if (G.current.length < 2) return;
            $7b066675d1aa79fa$var$checkWin(G, events);
        }
    },
    endIf: ({ G: G })=>{
        if (G.winner) return {
            color: G.winner,
            winning_line: G.winning_line,
            winner: Object.keys(G.players).find((k)=>G.players[k].color === G.winner)
        };
    },
    ai: {
        enumerate: (G, ctx)=>{
            if (ctx.gameover) return [];
            function pairStone(grid, stone, stones) {
                return $7b066675d1aa79fa$var$pointyDirections().map((d)=>grid.neighborOf(stone, d)).filter((h)=>grid.getHex(h)).map((h)=>stones.find((s)=>$7b066675d1aa79fa$var$isSameHex(h, s))).filter(Boolean).filter((s)=>s.color !== stone.color);
            }
            const cartesian = (...a)=>a.reduce((a, b)=>a.flatMap((d)=>b.map((e)=>[
                                d,
                                e
                            ].flat())));
            function pairMoves(grid, pair, stones) {
                return [
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).NE,
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).E,
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).SE,
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).SW,
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).W,
                    (0, $16061e18e8668e97$export$cacd6541cfeeb6c1).NW
                ].map((d)=>grid.neighborOf(pair[1], d)).map((h)=>$7b066675d1aa79fa$var$movePair(grid, stones, pair, h)).filter(Boolean);
            }
            let switches = [];
            G.stones.forEach((s)=>cartesian([
                    s
                ], pairStone($7b066675d1aa79fa$var$GRID, s, G.stones)).forEach((p)=>switches.push(p)));
            let moves = [];
            switches.forEach((s)=>pairMoves($7b066675d1aa79fa$var$GRID, s, G.stones).forEach((m)=>moves.push(m)));
            let switch_moves = switches.map((m)=>{
                return {
                    src: [
                        {
                            q: m[0].q,
                            r: m[0].r
                        },
                        {
                            q: m[1].q,
                            r: m[1].r
                        }
                    ],
                    dest: [
                        {
                            q: m[1].q,
                            r: m[1].r
                        },
                        {
                            q: m[0].q,
                            r: m[0].r
                        }
                    ]
                };
            });
            moves = [
                ...switch_moves,
                ...moves
            ];
            return moves.filter((m)=>!$7b066675d1aa79fa$var$isUndo(G, m)).map((m)=>{
                return {
                    move: 'fullMove',
                    args: [
                        m.src[0].q,
                        m.src[0].r,
                        m.src[1].q,
                        m.src[1].r,
                        m.dest[1].q,
                        m.dest[1].r
                    ]
                };
            }).filter((m)=>m.args?.length === 6);
        }
    }
};
function $7b066675d1aa79fa$var$isLineWin(grid, stones, line_traverser) {
    let color = null;
    let length = 0;
    grid.traverse(line_traverser, {
        bail: true
    }).forEach((hex)=>{
        // console.log(length, hex);
        let stone_i = stones.findIndex((s)=>s.q === hex.q && s.r === hex.r);
        if (stone_i === -1) // console.log("stopped cause empty");
        return false;
        else if (color === null) color = stones[stone_i].color;
        else if (color !== stones[stone_i].color) // console.log("stopped cause color changed");
        return false;
        length++;
    });
    return length >= 4;
}
function $7b066675d1aa79fa$var$checkWin(G, events) {
    console.log("checkWin");
    G.stones.forEach((h)=>{
        // console.log(h);
        $7b066675d1aa79fa$var$pointyDirections().forEach((d)=>{
            // console.log("Direction", d);
            const line_t = (0, $16061e18e8668e97$export$53f1d5ea8de3d7c)({
                start: h,
                direction: d,
                length: 4
            });
            if ($7b066675d1aa79fa$var$isLineWin($7b066675d1aa79fa$var$GRID, G.stones, line_t)) {
                G.winner = h.color;
                G.winning_line = [];
                $7b066675d1aa79fa$var$GRID.traverse(line_t, {
                    bail: true
                }).forEach((h)=>G.winning_line.push({
                        q: h.q,
                        r: h.r
                    }));
                return;
            }
        });
    });
}


function $2ae89aad8d89d959$var$parseId(id) {
    return id.split('_').splice(1, 2).map((x)=>parseInt(x)) || null;
}
function $2ae89aad8d89d959$var$getCellValue(grid, stones, q, r) {
    if (grid.getHex([
        q,
        r
    ])) return stones.filter((s)=>s.q === q && s.r === r).pop()?.color || null;
    else return undefined;
}
const $2ae89aad8d89d959$var$DRAW_DATA = {
    stroke_width: 3,
    colors: {
        board: '#C4A484',
        stroke: '#999',
        stroke_selected: 'green',
        stroke_won: 'yellow'
    }
};
class $2ae89aad8d89d959$var$GameClient {
    constructor(rootElement, debug = false){
        this.debug = debug;
        this.client = (0, $9911eba7eef15d22$export$e7094788287c5e9b)({
            game: (0, $7b066675d1aa79fa$export$7718f34a11c79886),
            debug: debug
        });
        this.client.start();
        const deserializedGrid = JSON.parse(this.client.getState().G.grid);
        this.grid = (0, $16061e18e8668e97$export$ef2184bd89960b14).fromJSON(deserializedGrid);
        let xs = [];
        this.grid.forEach((hex)=>hex.corners.forEach(({ x: x })=>xs.push(x)));
        this.xmin = Math.min(...xs);
        this.xmax = Math.max(...xs);
        this.rootElement = rootElement;
        this.svg = (0, $jDp01.SVG)().addTo(this.rootElement).attr({
            id: 'svgboard'
        });
        this.createBoard();
        this.createExtraControls();
        this.attachListeners();
        this.client.subscribe((state)=>this.update(state));
    }
    createBoard() {
        this.grid.forEach((hex)=>{
            // create a polygon from a hex's corner points
            const polygon = this.svg.polygon(hex.corners.map(({ x: x, y: y })=>[
                    x - this.xmin + $2ae89aad8d89d959$var$DRAW_DATA.stroke_width,
                    y
                ]).reduce((a, b)=>a.concat(b), [])).fill($2ae89aad8d89d959$var$DRAW_DATA.colors.board).stroke({
                width: $2ae89aad8d89d959$var$DRAW_DATA.stroke_width,
                color: $2ae89aad8d89d959$var$DRAW_DATA.colors.stroke
            }).attr({
                id: `hex_${hex.q}_${hex.r}`,
                class: 'hex'
            });
            this.svg.group().add(polygon);
        });
        this.svg.size(this.xmax - this.xmin + 2 * $2ae89aad8d89d959$var$DRAW_DATA.stroke_width);
        if (this.debug) // show q_r coordinates for each cell
        this.grid.forEach((hex)=>{
            const text = this.svg.plain(`${hex.q}_${hex.r}`).stroke({
                color: "red",
                width: 1
            }).attr({
                x: hex.corners[0].x - this.xmin + $2ae89aad8d89d959$var$DRAW_DATA.stroke_width,
                y: hex.corners[0].y
            });
            this.svg.group().add(text);
        });
    }
    createExtraControls() {
        // let undoBtn = this.rootElement.appendChild(document.createElement('button'));
        // undoBtn.id = "undoBtn";
        // undoBtn.type = "button";
        // undoBtn.textContent = "Undo";
        let clearBtn = this.rootElement.appendChild(document.createElement('button'));
        clearBtn.id = "clearBtn";
        clearBtn.type = "button";
        clearBtn.textContent = "Clear Selection";
    }
    attachListeners() {
        const cells = this.rootElement.querySelectorAll('.hex');
        const handleCellClick = (event)=>{
            const id = $2ae89aad8d89d959$var$parseId(event.target.id);
            this.client.moves.clickCell(id);
        };
        cells.forEach((cell)=>{
            cell.onclick = handleCellClick;
        });
        // this.rootElement.querySelector('#undoBtn').onclick = event=>this.client.moves.undo();
        // this.rootElement.querySelector('#undoBtn').onclick = event=>this.client.undo();
        this.rootElement.querySelector('#clearBtn').onclick = (event)=>this.client.moves.clear();
    }
    update(state) {
        this.rootElement.querySelector('header').innerText = `Player ${state.ctx.currentPlayer} (${state.G.players[state.ctx.currentPlayer].color}) Turn`;
        const cells = this.rootElement.querySelectorAll('.hex');
        cells.forEach((cell)=>{
            const cellId = $2ae89aad8d89d959$var$parseId(cell.id);
            const cellValue = $2ae89aad8d89d959$var$getCellValue(this.grid, state.G.stones, cellId[0], cellId[1]);
            cell.style.fill = cellValue !== null ? cellValue : '';
        });
        this.rootElement.querySelectorAll(".selected_hex").forEach((c)=>c.parentNode.removeChild(c));
        this.rootElement.querySelectorAll(".winning_hex").forEach((c)=>c.parentNode.removeChild(c));
        if (state.ctx.gameover) {
            console.log("game over", state.ctx.gameover);
            this.rootElement.querySelector("header").innerText = `player ${state.ctx.gameover.winner} (${state.ctx.gameover.color}) wins`;
            this.rootElement.querySelectorAll(".winning_hex").forEach((c)=>c.parentNode.removeChild(c));
            state.ctx.gameover.winning_line.map((h)=>this.grid.getHex(h)).forEach((hex)=>{
                const polygon = this.svg.polygon(hex.corners.map(({ x: x, y: y })=>`${x - this.xmin + $2ae89aad8d89d959$var$DRAW_DATA.stroke_width},${y}`)).fill("none").stroke({
                    width: $2ae89aad8d89d959$var$DRAW_DATA.stroke_width,
                    color: $2ae89aad8d89d959$var$DRAW_DATA.colors.stroke_won
                }).attr({
                    class: 'winning_hex'
                });
                this.svg.group().add(polygon);
            });
        } else state.G.current.map((s)=>this.grid.getHex(state.G.stones[s])).forEach((hex)=>{
            const polygon = this.svg.polygon(hex.corners.map(({ x: x, y: y })=>`${x - this.xmin + $2ae89aad8d89d959$var$DRAW_DATA.stroke_width},${y}`)).fill("none").stroke({
                width: $2ae89aad8d89d959$var$DRAW_DATA.stroke_width,
                color: $2ae89aad8d89d959$var$DRAW_DATA.colors.stroke_selected
            }).attr({
                class: 'selected_hex'
            });
            this.svg.group().add(polygon);
        });
    }
}
function $2ae89aad8d89d959$var$makeMoveDemo(node, move) {
    let item = node.appendChild(document.createElement("li"));
    let svg = (0, $jDp01.SVG)().addTo(item).size('100%', '100%');
    const Tile = (0, $16061e18e8668e97$export$98781bdbfe5970f1)({
        origin: 'topLeft',
        dimensions: 15
    });
    const grid = new (0, $16061e18e8668e97$export$ef2184bd89960b14)(Tile, (0, $16061e18e8668e97$export$a70866d5e0158cdc)({
        start: [
            3,
            3
        ],
        radius: 3
    }));
    const STROKE_WIDTH = 3;
    grid.forEach((hex)=>{
        // create a polygon from a hex's corner points
        const polygon = svg.polygon(hex.corners.map(({ x: x, y: y })=>[
                x,
                y
            ]).reduce((a, b)=>a.concat(b), [])).fill($2ae89aad8d89d959$var$DRAW_DATA.colors.board).stroke({
            width: STROKE_WIDTH,
            color: $2ae89aad8d89d959$var$DRAW_DATA.colors.stroke
        }).attr({
            id: `demohex_${hex.q}_${hex.r}`,
            class: 'hex'
        });
        svg.group().add(polygon);
    });
    [
        ...move.src
    ].forEach((stone, i)=>{
        const src_hex = grid.getHex(stone);
        const dx = grid.getHex(move.dest[i]).corners[0].x - src_hex.corners[0].x;
        const dy = grid.getHex(move.dest[i]).corners[0].y - src_hex.corners[0].y;
        const polygon = svg.polygon(src_hex.corners.map(({ x: x, y: y })=>[
                x,
                y
            ]).reduce((a, b)=>a.concat(b), [])).fill(stone.color).stroke({
            width: STROKE_WIDTH,
            color: $2ae89aad8d89d959$var$DRAW_DATA.colors.stroke
        }).attr({
            class: 'hex'
        }).animate(1000).dmove(dx, dy).loop(undefined, true, 100);
        svg.group().add(polygon.element());
    });
}
const $2ae89aad8d89d959$var$demoUl = document.getElementById('move_list');
[
    {
        src: [
            {
                color: "black",
                q: 3,
                r: 3
            },
            {
                color: "white",
                q: 3,
                r: 2
            }
        ],
        dest: [
            {
                color: "black",
                q: 2,
                r: 3
            },
            {
                color: "white",
                q: 2,
                r: 2
            }
        ]
    },
    {
        src: [
            {
                color: "black",
                q: 3,
                r: 3
            },
            {
                color: "white",
                q: 3,
                r: 2
            }
        ],
        dest: [
            {
                color: "black",
                q: 3,
                r: 2
            },
            {
                color: "white",
                q: 3,
                r: 1
            }
        ]
    },
    {
        src: [
            {
                color: "black",
                q: 3,
                r: 3
            },
            {
                color: "white",
                q: 3,
                r: 2
            }
        ],
        dest: [
            {
                color: "black",
                q: 3,
                r: 2
            },
            {
                color: "white",
                q: 3,
                r: 3
            }
        ]
    }
].forEach((move)=>$2ae89aad8d89d959$var$makeMoveDemo($2ae89aad8d89d959$var$demoUl, move));
document.getElementById("game_info_toggler")?.addEventListener("click", ()=>{
    let elem = document.getElementById('game_info');
    if (elem.style.display === 'none') elem.style.display = 'block';
    else elem.style.display = 'none';
});
const $2ae89aad8d89d959$var$appElement = document.getElementById('app');
const $2ae89aad8d89d959$var$app = new $2ae89aad8d89d959$var$GameClient($2ae89aad8d89d959$var$appElement);


//# sourceMappingURL=path0.8fafa908.js.map
